var dr = typeof global == "object" && global && global.Object === Object && global, li = typeof self == "object" && self && self.Object === Object && self, se = dr || li || Function("return this")(), ie = se.Symbol, gr = Object.prototype, ui = gr.hasOwnProperty, ci = gr.toString, Fe = ie ? ie.toStringTag : void 0;
function di(e) {
  var a = ui.call(e, Fe), n = e[Fe];
  try {
    e[Fe] = void 0;
    var r = !0;
  } catch {
  }
  var t = ci.call(e);
  return r && (a ? e[Fe] = n : delete e[Fe]), t;
}
var gi = Object.prototype, mi = gi.toString;
function pi(e) {
  return mi.call(e);
}
var hi = "[object Null]", fi = "[object Undefined]", hn = ie ? ie.toStringTag : void 0;
function Me(e) {
  return e == null ? e === void 0 ? fi : hi : hn && hn in Object(e) ? di(e) : pi(e);
}
function he(e) {
  return e != null && typeof e == "object";
}
var yi = "[object Symbol]";
function $a(e) {
  return typeof e == "symbol" || he(e) && Me(e) == yi;
}
function Ia(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length, t = Array(r); ++n < r; )
    t[n] = a(e[n], n, e);
  return t;
}
var oe = Array.isArray, fn = ie ? ie.prototype : void 0, yn = fn ? fn.toString : void 0;
function mr(e) {
  if (typeof e == "string")
    return e;
  if (oe(e))
    return Ia(e, mr) + "";
  if ($a(e))
    return yn ? yn.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function fe(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function pr(e) {
  return e;
}
var bi = "[object AsyncFunction]", Ci = "[object Function]", _i = "[object GeneratorFunction]", Ai = "[object Proxy]";
function Ka(e) {
  if (!fe(e))
    return !1;
  var a = Me(e);
  return a == Ci || a == _i || a == bi || a == Ai;
}
var ya = se["__core-js_shared__"], bn = function() {
  var e = /[^.]+$/.exec(ya && ya.keys && ya.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function vi(e) {
  return !!bn && bn in e;
}
var Si = Function.prototype, Mi = Si.toString;
function De(e) {
  if (e != null) {
    try {
      return Mi.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Di = /[\\^$.*+?()[\]{}|]/g, wi = /^\[object .+?Constructor\]$/, zi = Function.prototype, Ti = Object.prototype, Ri = zi.toString, Pi = Ti.hasOwnProperty, Ei = RegExp(
  "^" + Ri.call(Pi).replace(Di, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Oi(e) {
  if (!fe(e) || vi(e))
    return !1;
  var a = Ka(e) ? Ei : wi;
  return a.test(De(e));
}
function Bi(e, a) {
  return e == null ? void 0 : e[a];
}
function we(e, a) {
  var n = Bi(e, a);
  return Oi(n) ? n : void 0;
}
var Ma = we(se, "WeakMap"), Cn = Object.create, Li = /* @__PURE__ */ function() {
  function e() {
  }
  return function(a) {
    if (!fe(a))
      return {};
    if (Cn)
      return Cn(a);
    e.prototype = a;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Ni(e, a, n) {
  switch (n.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, n[0]);
    case 2:
      return e.call(a, n[0], n[1]);
    case 3:
      return e.call(a, n[0], n[1], n[2]);
  }
  return e.apply(a, n);
}
function Gi(e, a) {
  var n = -1, r = e.length;
  for (a || (a = Array(r)); ++n < r; )
    a[n] = e[n];
  return a;
}
var Fi = 800, Ui = 16, $i = Date.now;
function Ii(e) {
  var a = 0, n = 0;
  return function() {
    var r = $i(), t = Ui - (r - n);
    if (n = r, t > 0) {
      if (++a >= Fi)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function Ki(e) {
  return function() {
    return e;
  };
}
var Je = function() {
  try {
    var e = we(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), ki = Je ? function(e, a) {
  return Je(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ki(a),
    writable: !0
  });
} : pr, hr = Ii(ki);
function Hi(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && a(e[n], n, e) !== !1; )
    ;
  return e;
}
var Yi = 9007199254740991, xi = /^(?:0|[1-9]\d*)$/;
function fr(e, a) {
  var n = typeof e;
  return a = a ?? Yi, !!a && (n == "number" || n != "symbol" && xi.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function ka(e, a, n) {
  a == "__proto__" && Je ? Je(e, a, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[a] = n;
}
function aa(e, a) {
  return e === a || e !== e && a !== a;
}
var ji = Object.prototype, Vi = ji.hasOwnProperty;
function yr(e, a, n) {
  var r = e[a];
  (!(Vi.call(e, a) && aa(r, n)) || n === void 0 && !(a in e)) && ka(e, a, n);
}
function br(e, a, n, r) {
  var t = !n;
  n || (n = {});
  for (var s = -1, o = a.length; ++s < o; ) {
    var l = a[s], c = void 0;
    c === void 0 && (c = e[l]), t ? ka(n, l, c) : yr(n, l, c);
  }
  return n;
}
var _n = Math.max;
function Cr(e, a, n) {
  return a = _n(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var r = arguments, t = -1, s = _n(r.length - a, 0), o = Array(s); ++t < s; )
      o[t] = r[a + t];
    t = -1;
    for (var l = Array(a + 1); ++t < a; )
      l[t] = r[t];
    return l[a] = n(o), Ni(e, this, l);
  };
}
function Zi(e, a) {
  return hr(Cr(e, a, pr), e + "");
}
var Wi = 9007199254740991;
function _r(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Wi;
}
function Ee(e) {
  return e != null && _r(e.length) && !Ka(e);
}
function Ji(e, a, n) {
  if (!fe(n))
    return !1;
  var r = typeof a;
  return (r == "number" ? Ee(n) && fr(a, n.length) : r == "string" && a in n) ? aa(n[a], e) : !1;
}
function qi(e) {
  return Zi(function(a, n) {
    var r = -1, t = n.length, s = t > 1 ? n[t - 1] : void 0, o = t > 2 ? n[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (t--, s) : void 0, o && Ji(n[0], n[1], o) && (s = t < 3 ? void 0 : s, t = 1), a = Object(a); ++r < t; ) {
      var l = n[r];
      l && e(a, l, r, s);
    }
    return a;
  });
}
var Xi = Object.prototype;
function Ha(e) {
  var a = e && e.constructor, n = typeof a == "function" && a.prototype || Xi;
  return e === n;
}
function Qi(e, a) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = a(n);
  return r;
}
var eo = "[object Arguments]";
function An(e) {
  return he(e) && Me(e) == eo;
}
var Ar = Object.prototype, ao = Ar.hasOwnProperty, no = Ar.propertyIsEnumerable, qe = An(/* @__PURE__ */ function() {
  return arguments;
}()) ? An : function(e) {
  return he(e) && ao.call(e, "callee") && !no.call(e, "callee");
};
function ro() {
  return !1;
}
var vr = typeof exports == "object" && exports && !exports.nodeType && exports, vn = vr && typeof module == "object" && module && !module.nodeType && module, to = vn && vn.exports === vr, Sn = to ? se.Buffer : void 0, io = Sn ? Sn.isBuffer : void 0, Ya = io || ro, oo = "[object Arguments]", so = "[object Array]", lo = "[object Boolean]", uo = "[object Date]", co = "[object Error]", go = "[object Function]", mo = "[object Map]", po = "[object Number]", ho = "[object Object]", fo = "[object RegExp]", yo = "[object Set]", bo = "[object String]", Co = "[object WeakMap]", _o = "[object ArrayBuffer]", Ao = "[object DataView]", vo = "[object Float32Array]", So = "[object Float64Array]", Mo = "[object Int8Array]", Do = "[object Int16Array]", wo = "[object Int32Array]", zo = "[object Uint8Array]", To = "[object Uint8ClampedArray]", Ro = "[object Uint16Array]", Po = "[object Uint32Array]", k = {};
k[vo] = k[So] = k[Mo] = k[Do] = k[wo] = k[zo] = k[To] = k[Ro] = k[Po] = !0;
k[oo] = k[so] = k[_o] = k[lo] = k[Ao] = k[uo] = k[co] = k[go] = k[mo] = k[po] = k[ho] = k[fo] = k[yo] = k[bo] = k[Co] = !1;
function Eo(e) {
  return he(e) && _r(e.length) && !!k[Me(e)];
}
function xa(e) {
  return function(a) {
    return e(a);
  };
}
var Sr = typeof exports == "object" && exports && !exports.nodeType && exports, Ie = Sr && typeof module == "object" && module && !module.nodeType && module, Oo = Ie && Ie.exports === Sr, ba = Oo && dr.process, Re = function() {
  try {
    var e = Ie && Ie.require && Ie.require("util").types;
    return e || ba && ba.binding && ba.binding("util");
  } catch {
  }
}(), Mn = Re && Re.isTypedArray, Mr = Mn ? xa(Mn) : Eo, Bo = Object.prototype, Lo = Bo.hasOwnProperty;
function Dr(e, a) {
  var n = oe(e), r = !n && qe(e), t = !n && !r && Ya(e), s = !n && !r && !t && Mr(e), o = n || r || t || s, l = o ? Qi(e.length, String) : [], c = l.length;
  for (var p in e)
    (a || Lo.call(e, p)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    t && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    fr(p, c))) && l.push(p);
  return l;
}
function wr(e, a) {
  return function(n) {
    return e(a(n));
  };
}
var No = wr(Object.keys, Object), Go = Object.prototype, Fo = Go.hasOwnProperty;
function Uo(e) {
  if (!Ha(e))
    return No(e);
  var a = [];
  for (var n in Object(e))
    Fo.call(e, n) && n != "constructor" && a.push(n);
  return a;
}
function $o(e) {
  return Ee(e) ? Dr(e) : Uo(e);
}
function Io(e) {
  var a = [];
  if (e != null)
    for (var n in Object(e))
      a.push(n);
  return a;
}
var Ko = Object.prototype, ko = Ko.hasOwnProperty;
function Ho(e) {
  if (!fe(e))
    return Io(e);
  var a = Ha(e), n = [];
  for (var r in e)
    r == "constructor" && (a || !ko.call(e, r)) || n.push(r);
  return n;
}
function ja(e) {
  return Ee(e) ? Dr(e, !0) : Ho(e);
}
var Yo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xo = /^\w*$/;
function zr(e, a) {
  if (oe(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || $a(e) ? !0 : xo.test(e) || !Yo.test(e) || a != null && e in Object(a);
}
var ke = we(Object, "create");
function jo() {
  this.__data__ = ke ? ke(null) : {}, this.size = 0;
}
function Vo(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var Zo = "__lodash_hash_undefined__", Wo = Object.prototype, Jo = Wo.hasOwnProperty;
function qo(e) {
  var a = this.__data__;
  if (ke) {
    var n = a[e];
    return n === Zo ? void 0 : n;
  }
  return Jo.call(a, e) ? a[e] : void 0;
}
var Xo = Object.prototype, Qo = Xo.hasOwnProperty;
function es(e) {
  var a = this.__data__;
  return ke ? a[e] !== void 0 : Qo.call(a, e);
}
var as = "__lodash_hash_undefined__";
function ns(e, a) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ke && a === void 0 ? as : a, this;
}
function Ae(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
Ae.prototype.clear = jo;
Ae.prototype.delete = Vo;
Ae.prototype.get = qo;
Ae.prototype.has = es;
Ae.prototype.set = ns;
function rs() {
  this.__data__ = [], this.size = 0;
}
function na(e, a) {
  for (var n = e.length; n--; )
    if (aa(e[n][0], a))
      return n;
  return -1;
}
var ts = Array.prototype, is = ts.splice;
function os(e) {
  var a = this.__data__, n = na(a, e);
  if (n < 0)
    return !1;
  var r = a.length - 1;
  return n == r ? a.pop() : is.call(a, n, 1), --this.size, !0;
}
function ss(e) {
  var a = this.__data__, n = na(a, e);
  return n < 0 ? void 0 : a[n][1];
}
function ls(e) {
  return na(this.__data__, e) > -1;
}
function us(e, a) {
  var n = this.__data__, r = na(n, e);
  return r < 0 ? (++this.size, n.push([e, a])) : n[r][1] = a, this;
}
function ge(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
ge.prototype.clear = rs;
ge.prototype.delete = os;
ge.prototype.get = ss;
ge.prototype.has = ls;
ge.prototype.set = us;
var He = we(se, "Map");
function cs() {
  this.size = 0, this.__data__ = {
    hash: new Ae(),
    map: new (He || ge)(),
    string: new Ae()
  };
}
function ds(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function ra(e, a) {
  var n = e.__data__;
  return ds(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
}
function gs(e) {
  var a = ra(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function ms(e) {
  return ra(this, e).get(e);
}
function ps(e) {
  return ra(this, e).has(e);
}
function hs(e, a) {
  var n = ra(this, e), r = n.size;
  return n.set(e, a), this.size += n.size == r ? 0 : 1, this;
}
function ye(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
ye.prototype.clear = cs;
ye.prototype.delete = gs;
ye.prototype.get = ms;
ye.prototype.has = ps;
ye.prototype.set = hs;
var fs = "Expected a function";
function Va(e, a) {
  if (typeof e != "function" || a != null && typeof a != "function")
    throw new TypeError(fs);
  var n = function() {
    var r = arguments, t = a ? a.apply(this, r) : r[0], s = n.cache;
    if (s.has(t))
      return s.get(t);
    var o = e.apply(this, r);
    return n.cache = s.set(t, o) || s, o;
  };
  return n.cache = new (Va.Cache || ye)(), n;
}
Va.Cache = ye;
var ys = 500;
function bs(e) {
  var a = Va(e, function(r) {
    return n.size === ys && n.clear(), r;
  }), n = a.cache;
  return a;
}
var Cs = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, _s = /\\(\\)?/g, As = bs(function(e) {
  var a = [];
  return e.charCodeAt(0) === 46 && a.push(""), e.replace(Cs, function(n, r, t, s) {
    a.push(t ? s.replace(_s, "$1") : r || n);
  }), a;
});
function vs(e) {
  return e == null ? "" : mr(e);
}
function Za(e, a) {
  return oe(e) ? e : zr(e, a) ? [e] : As(vs(e));
}
function Wa(e) {
  if (typeof e == "string" || $a(e))
    return e;
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function Tr(e, a) {
  a = Za(a, e);
  for (var n = 0, r = a.length; e != null && n < r; )
    e = e[Wa(a[n++])];
  return n && n == r ? e : void 0;
}
function Ja(e, a) {
  for (var n = -1, r = a.length, t = e.length; ++n < r; )
    e[t + n] = a[n];
  return e;
}
var Dn = ie ? ie.isConcatSpreadable : void 0;
function Ss(e) {
  return oe(e) || qe(e) || !!(Dn && e && e[Dn]);
}
function Ms(e, a, n, r, t) {
  var s = -1, o = e.length;
  for (n || (n = Ss), t || (t = []); ++s < o; ) {
    var l = e[s];
    n(l) ? Ja(t, l) : t[t.length] = l;
  }
  return t;
}
function Ds(e) {
  var a = e == null ? 0 : e.length;
  return a ? Ms(e) : [];
}
function ws(e) {
  return hr(Cr(e, void 0, Ds), e + "");
}
var qa = wr(Object.getPrototypeOf, Object), zs = "[object Object]", Ts = Function.prototype, Rs = Object.prototype, Rr = Ts.toString, Ps = Rs.hasOwnProperty, Es = Rr.call(Object);
function Pr(e) {
  if (!he(e) || Me(e) != zs)
    return !1;
  var a = qa(e);
  if (a === null)
    return !0;
  var n = Ps.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && Rr.call(n) == Es;
}
function Os(e, a, n) {
  var r = -1, t = e.length;
  a < 0 && (a = -a > t ? 0 : t + a), n = n > t ? t : n, n < 0 && (n += t), t = a > n ? 0 : n - a >>> 0, a >>>= 0;
  for (var s = Array(t); ++r < t; )
    s[r] = e[r + a];
  return s;
}
function Bs() {
  this.__data__ = new ge(), this.size = 0;
}
function Ls(e) {
  var a = this.__data__, n = a.delete(e);
  return this.size = a.size, n;
}
function Ns(e) {
  return this.__data__.get(e);
}
function Gs(e) {
  return this.__data__.has(e);
}
var Fs = 200;
function Us(e, a) {
  var n = this.__data__;
  if (n instanceof ge) {
    var r = n.__data__;
    if (!He || r.length < Fs - 1)
      return r.push([e, a]), this.size = ++n.size, this;
    n = this.__data__ = new ye(r);
  }
  return n.set(e, a), this.size = n.size, this;
}
function ze(e) {
  var a = this.__data__ = new ge(e);
  this.size = a.size;
}
ze.prototype.clear = Bs;
ze.prototype.delete = Ls;
ze.prototype.get = Ns;
ze.prototype.has = Gs;
ze.prototype.set = Us;
var Er = typeof exports == "object" && exports && !exports.nodeType && exports, wn = Er && typeof module == "object" && module && !module.nodeType && module, $s = wn && wn.exports === Er, zn = $s ? se.Buffer : void 0, Tn = zn ? zn.allocUnsafe : void 0;
function Or(e, a) {
  if (a)
    return e.slice();
  var n = e.length, r = Tn ? Tn(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Is(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length, t = 0, s = []; ++n < r; ) {
    var o = e[n];
    a(o, n, e) && (s[t++] = o);
  }
  return s;
}
function Br() {
  return [];
}
var Ks = Object.prototype, ks = Ks.propertyIsEnumerable, Rn = Object.getOwnPropertySymbols, Hs = Rn ? function(e) {
  return e == null ? [] : (e = Object(e), Is(Rn(e), function(a) {
    return ks.call(e, a);
  }));
} : Br, Ys = Object.getOwnPropertySymbols, xs = Ys ? function(e) {
  for (var a = []; e; )
    Ja(a, Hs(e)), e = qa(e);
  return a;
} : Br;
function js(e, a, n) {
  var r = a(e);
  return oe(e) ? r : Ja(r, n(e));
}
function Lr(e) {
  return js(e, ja, xs);
}
var Da = we(se, "DataView"), wa = we(se, "Promise"), za = we(se, "Set"), Pn = "[object Map]", Vs = "[object Object]", En = "[object Promise]", On = "[object Set]", Bn = "[object WeakMap]", Ln = "[object DataView]", Zs = De(Da), Ws = De(He), Js = De(wa), qs = De(za), Xs = De(Ma), ue = Me;
(Da && ue(new Da(new ArrayBuffer(1))) != Ln || He && ue(new He()) != Pn || wa && ue(wa.resolve()) != En || za && ue(new za()) != On || Ma && ue(new Ma()) != Bn) && (ue = function(e) {
  var a = Me(e), n = a == Vs ? e.constructor : void 0, r = n ? De(n) : "";
  if (r)
    switch (r) {
      case Zs:
        return Ln;
      case Ws:
        return Pn;
      case Js:
        return En;
      case qs:
        return On;
      case Xs:
        return Bn;
    }
  return a;
});
var Qs = Object.prototype, el = Qs.hasOwnProperty;
function al(e) {
  var a = e.length, n = new e.constructor(a);
  return a && typeof e[0] == "string" && el.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Nn = se.Uint8Array;
function Xa(e) {
  var a = new e.constructor(e.byteLength);
  return new Nn(a).set(new Nn(e)), a;
}
function nl(e, a) {
  var n = Xa(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var rl = /\w*$/;
function tl(e) {
  var a = new e.constructor(e.source, rl.exec(e));
  return a.lastIndex = e.lastIndex, a;
}
var Gn = ie ? ie.prototype : void 0, Fn = Gn ? Gn.valueOf : void 0;
function il(e) {
  return Fn ? Object(Fn.call(e)) : {};
}
function Nr(e, a) {
  var n = a ? Xa(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var ol = "[object Boolean]", sl = "[object Date]", ll = "[object Map]", ul = "[object Number]", cl = "[object RegExp]", dl = "[object Set]", gl = "[object String]", ml = "[object Symbol]", pl = "[object ArrayBuffer]", hl = "[object DataView]", fl = "[object Float32Array]", yl = "[object Float64Array]", bl = "[object Int8Array]", Cl = "[object Int16Array]", _l = "[object Int32Array]", Al = "[object Uint8Array]", vl = "[object Uint8ClampedArray]", Sl = "[object Uint16Array]", Ml = "[object Uint32Array]";
function Dl(e, a, n) {
  var r = e.constructor;
  switch (a) {
    case pl:
      return Xa(e);
    case ol:
    case sl:
      return new r(+e);
    case hl:
      return nl(e);
    case fl:
    case yl:
    case bl:
    case Cl:
    case _l:
    case Al:
    case vl:
    case Sl:
    case Ml:
      return Nr(e, n);
    case ll:
      return new r();
    case ul:
    case gl:
      return new r(e);
    case cl:
      return tl(e);
    case dl:
      return new r();
    case ml:
      return il(e);
  }
}
function wl(e) {
  return typeof e.constructor == "function" && !Ha(e) ? Li(qa(e)) : {};
}
var zl = "[object Map]";
function Tl(e) {
  return he(e) && ue(e) == zl;
}
var Un = Re && Re.isMap, Rl = Un ? xa(Un) : Tl, Pl = "[object Set]";
function El(e) {
  return he(e) && ue(e) == Pl;
}
var $n = Re && Re.isSet, Ol = $n ? xa($n) : El, Bl = 1, Gr = "[object Arguments]", Ll = "[object Array]", Nl = "[object Boolean]", Gl = "[object Date]", Fl = "[object Error]", Fr = "[object Function]", Ul = "[object GeneratorFunction]", $l = "[object Map]", Il = "[object Number]", Ur = "[object Object]", Kl = "[object RegExp]", kl = "[object Set]", Hl = "[object String]", Yl = "[object Symbol]", xl = "[object WeakMap]", jl = "[object ArrayBuffer]", Vl = "[object DataView]", Zl = "[object Float32Array]", Wl = "[object Float64Array]", Jl = "[object Int8Array]", ql = "[object Int16Array]", Xl = "[object Int32Array]", Ql = "[object Uint8Array]", eu = "[object Uint8ClampedArray]", au = "[object Uint16Array]", nu = "[object Uint32Array]", K = {};
K[Gr] = K[Ll] = K[jl] = K[Vl] = K[Nl] = K[Gl] = K[Zl] = K[Wl] = K[Jl] = K[ql] = K[Xl] = K[$l] = K[Il] = K[Ur] = K[Kl] = K[kl] = K[Hl] = K[Yl] = K[Ql] = K[eu] = K[au] = K[nu] = !0;
K[Fl] = K[Fr] = K[xl] = !1;
function Ze(e, a, n, r, t, s) {
  var o, l = a & Bl;
  if (n && (o = t ? n(e, r, t, s) : n(e)), o !== void 0)
    return o;
  if (!fe(e))
    return e;
  var c = oe(e);
  if (c)
    o = al(e);
  else {
    var p = ue(e), f = p == Fr || p == Ul;
    if (Ya(e))
      return Or(e, l);
    if (p == Ur || p == Gr || f && !t)
      o = {};
    else {
      if (!K[p])
        return t ? e : {};
      o = Dl(e, p, l);
    }
  }
  s || (s = new ze());
  var v = s.get(e);
  if (v)
    return v;
  s.set(e, o), Ol(e) ? e.forEach(function(C) {
    o.add(Ze(C, a, n, C, e, s));
  }) : Rl(e) && e.forEach(function(C, d) {
    o.set(d, Ze(C, a, n, d, e, s));
  });
  var b = Lr, A = c ? void 0 : b(e);
  return Hi(A || e, function(C, d) {
    A && (d = C, C = e[d]), yr(o, d, Ze(C, a, n, d, e, s));
  }), o;
}
function ru(e) {
  return function(a) {
    return a == null ? void 0 : a[e];
  };
}
function tu(e) {
  return function(a) {
    return Tr(a, e);
  };
}
function iu(e) {
  return zr(e) ? ru(Wa(e)) : tu(e);
}
function ou(e) {
  return iu(e);
}
function su(e) {
  return function(a, n, r) {
    for (var t = -1, s = Object(a), o = r(a), l = o.length; l--; ) {
      var c = o[++t];
      if (n(s[c], c, s) === !1)
        break;
    }
    return a;
  };
}
var $r = su();
function lu(e, a) {
  return e && $r(e, a, $o);
}
function uu(e, a) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Ee(n))
      return e(n, r);
    for (var t = n.length, s = -1, o = Object(n); ++s < t && r(o[s], s, o) !== !1; )
      ;
    return n;
  };
}
var cu = uu(lu);
function Ta(e, a, n) {
  (n !== void 0 && !aa(e[a], n) || n === void 0 && !(a in e)) && ka(e, a, n);
}
function du(e) {
  return he(e) && Ee(e);
}
function Ra(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function gu(e) {
  return br(e, ja(e));
}
function mu(e, a, n, r, t, s, o) {
  var l = Ra(e, n), c = Ra(a, n), p = o.get(c);
  if (p) {
    Ta(e, n, p);
    return;
  }
  var f = s ? s(l, c, n + "", e, a, o) : void 0, v = f === void 0;
  if (v) {
    var b = oe(c), A = !b && Ya(c), C = !b && !A && Mr(c);
    f = c, b || A || C ? oe(l) ? f = l : du(l) ? f = Gi(l) : A ? (v = !1, f = Or(c, !0)) : C ? (v = !1, f = Nr(c, !0)) : f = [] : Pr(c) || qe(c) ? (f = l, qe(l) ? f = gu(l) : (!fe(l) || Ka(l)) && (f = wl(c))) : v = !1;
  }
  v && (o.set(c, f), t(f, c, r, s, o), o.delete(c)), Ta(e, n, f);
}
function Ir(e, a, n, r, t) {
  e !== a && $r(a, function(s, o) {
    if (t || (t = new ze()), fe(s))
      mu(e, a, o, n, Ir, r, t);
    else {
      var l = r ? r(Ra(e, o), s, o + "", e, a, t) : void 0;
      l === void 0 && (l = s), Ta(e, o, l);
    }
  }, ja);
}
function pu(e) {
  var a = e == null ? 0 : e.length;
  return a ? e[a - 1] : void 0;
}
function hu(e, a) {
  var n = -1, r = Ee(e) ? Array(e.length) : [];
  return cu(e, function(t, s, o) {
    r[++n] = a(t, s, o);
  }), r;
}
function fu(e, a) {
  var n = oe(e) ? Ia : hu;
  return n(e, ou(a));
}
function yu(e, a) {
  return a.length < 2 ? e : Tr(e, Os(a, 0, -1));
}
var In = qi(function(e, a, n) {
  Ir(e, a, n);
});
function bu(e, a) {
  return a = Za(a, e), e = yu(e, a), e == null || delete e[Wa(pu(a))];
}
function Cu(e) {
  return Pr(e) ? void 0 : e;
}
var _u = 1, Au = 2, vu = 4, de = ws(function(e, a) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  a = Ia(a, function(s) {
    return s = Za(s, e), r || (r = s.length > 1), s;
  }), br(e, Lr(e), n), r && (n = Ze(n, _u | Au | vu, Cu));
  for (var t = a.length; t--; )
    bu(n, a[t]);
  return n;
});
const Pa = {
  AD: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "376",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png",
    iso2: "AD",
    name: "Andorra",
    priority: 0,
    timezone: "Europe/Andorra"
  },
  AE: {
    areaCodes: null,
    currency: "AED",
    dialCode: "971",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png",
    iso2: "AE",
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    priority: 0,
    timezone: "Asia/Dubai"
  },
  AF: {
    areaCodes: null,
    currency: "AFN",
    dialCode: "93",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png",
    iso2: "AF",
    name: "Afghanistan (‫افغانستان‬‎)",
    priority: 0,
    timezone: "Asia/Kabul"
  },
  AG: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png",
    iso2: "AG",
    name: "Antigua and Barbuda",
    priority: 0,
    timezone: "America/Antigua"
  },
  AI: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png",
    iso2: "AI",
    name: "Anguilla",
    priority: 0,
    timezone: "America/Anguilla"
  },
  AL: {
    areaCodes: null,
    currency: "ALL",
    dialCode: "355",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png",
    iso2: "AL",
    name: "Albania (Shqipëri)",
    priority: 0,
    timezone: "Europe/Tirane"
  },
  AM: {
    areaCodes: null,
    currency: "AMD",
    dialCode: "374",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png",
    iso2: "AM",
    name: "Armenia (Հայաստան)",
    priority: 0,
    timezone: "Asia/Yerevan"
  },
  AO: {
    areaCodes: null,
    currency: "AOA",
    dialCode: "244",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png",
    iso2: "AO",
    name: "Angola",
    priority: 0,
    timezone: "Africa/Luanda"
  },
  AR: {
    areaCodes: null,
    currency: "ARS",
    dialCode: "54",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png",
    iso2: "AR",
    name: "Argentina",
    priority: 0,
    timezone: "America/Argentina/Cordoba"
  },
  AS: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1684",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png",
    iso2: "AS",
    name: "American Samoa",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  AT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "43",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png",
    iso2: "AT",
    name: "Austria (Österreich)",
    priority: 0,
    timezone: "Europe/Vienna"
  },
  AU: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png",
    iso2: "AU",
    name: "Australia",
    priority: 0,
    timezone: "Australia/Darwin"
  },
  AW: {
    areaCodes: null,
    currency: "AWG",
    dialCode: "297",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png",
    iso2: "AW",
    name: "Aruba",
    priority: 0,
    timezone: "America/Aruba"
  },
  AX: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png",
    iso2: "AX",
    name: "Åland Islands",
    priority: 1,
    timezone: "Europe/Helsinki"
  },
  AZ: {
    areaCodes: null,
    currency: "AZN",
    dialCode: "994",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png",
    iso2: "AZ",
    name: "Azerbaijan (Azərbaycan)",
    priority: 0,
    timezone: "Asia/Baku"
  },
  BA: {
    areaCodes: null,
    currency: "BAM",
    dialCode: "387",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png",
    iso2: "BA",
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    priority: 0,
    timezone: "Europe/Sarajevo"
  },
  BB: {
    areaCodes: null,
    currency: "BBD",
    dialCode: "1246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png",
    iso2: "BB",
    name: "Barbados",
    priority: 0,
    timezone: "America/Barbados"
  },
  BD: {
    areaCodes: null,
    currency: "BDT",
    dialCode: "880",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png",
    iso2: "BD",
    name: "Bangladesh (বাংলাদেশ)",
    priority: 0,
    timezone: "Asia/Dhaka"
  },
  BE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "32",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png",
    iso2: "BE",
    name: "Belgium (België)",
    priority: 0,
    timezone: "Europe/Brussels"
  },
  BF: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "226",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png",
    iso2: "BF",
    name: "Burkina Faso",
    priority: 0,
    timezone: "Africa/Ouagadougou"
  },
  BG: {
    areaCodes: null,
    currency: "BGN",
    dialCode: "359",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png",
    iso2: "BG",
    name: "Bulgaria (България)",
    priority: 0,
    timezone: "Europe/Sofia"
  },
  BH: {
    areaCodes: null,
    currency: "BHD",
    dialCode: "973",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png",
    iso2: "BH",
    name: "Bahrain (‫البحرين‬‎)",
    priority: 0,
    timezone: "Asia/Bahrain"
  },
  BI: {
    areaCodes: null,
    currency: "BIF",
    dialCode: "257",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png",
    iso2: "BI",
    name: "Burundi (Uburundi)",
    priority: 0,
    timezone: "Africa/Bujumbura"
  },
  BJ: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "229",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png",
    iso2: "BJ",
    name: "Benin (Bénin)",
    priority: 0,
    timezone: "Africa/Porto-Novo"
  },
  BL: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png",
    iso2: "BL",
    name: "Saint Barthélemy",
    priority: 1,
    timezone: "America/St_Barthelemy"
  },
  BM: {
    areaCodes: null,
    currency: "BMD",
    dialCode: "1441",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png",
    iso2: "BM",
    name: "Bermuda",
    priority: 0,
    timezone: "Atlantic/Bermuda"
  },
  BN: {
    areaCodes: null,
    currency: "BND",
    dialCode: "673",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png",
    iso2: "BN",
    name: "Brunei",
    priority: 0,
    timezone: "Asia/Brunei"
  },
  BO: {
    areaCodes: null,
    currency: "BOB",
    dialCode: "591",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png",
    iso2: "BO",
    name: "Bolivia",
    priority: 0,
    timezone: "America/La_Paz"
  },
  BQ: {
    areaCodes: null,
    currency: "USD",
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png",
    iso2: "BQ",
    name: "Caribbean Netherlands",
    priority: 1,
    timezone: "America/Kralendijk"
  },
  BR: {
    areaCodes: null,
    currency: "BRL",
    dialCode: "55",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png",
    iso2: "BR",
    name: "Brazil (Brasil)",
    priority: 0,
    timezone: "America/Cuiaba"
  },
  BS: {
    areaCodes: null,
    currency: "BSD",
    dialCode: "1242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png",
    iso2: "BS",
    name: "Bahamas",
    priority: 0,
    timezone: "America/Nassau"
  },
  BT: {
    areaCodes: null,
    currency: "BTN",
    dialCode: "975",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png",
    iso2: "BT",
    name: "Bhutan (འབྲུག)",
    priority: 0,
    timezone: "Asia/Thimphu"
  },
  BW: {
    areaCodes: null,
    currency: "BWP",
    dialCode: "267",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png",
    iso2: "BW",
    name: "Botswana",
    priority: 0,
    timezone: "Africa/Gaborone"
  },
  BY: {
    areaCodes: null,
    currency: "BYR",
    dialCode: "375",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png",
    iso2: "BY",
    name: "Belarus (Беларусь)",
    priority: 0,
    timezone: "Europe/Minsk"
  },
  BZ: {
    areaCodes: null,
    currency: "BZD",
    dialCode: "501",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png",
    iso2: "BZ",
    name: "Belize",
    priority: 0,
    timezone: "America/Belize"
  },
  CA: {
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ],
    currency: "CAD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png",
    iso2: "CA",
    name: "Canada",
    priority: 1,
    timezone: "America/Rankin_Inlet"
  },
  CC: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png",
    iso2: "CC",
    name: "Cocos (Keeling) Islands",
    priority: 1,
    timezone: "Indian/Cocos"
  },
  CD: {
    areaCodes: null,
    currency: "CDF",
    dialCode: "243",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png",
    iso2: "CD",
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    priority: 0,
    timezone: "Africa/Lubumbashi"
  },
  CF: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "236",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png",
    iso2: "CF",
    name: "Central African Republic (République centrafricaine)",
    priority: 0,
    timezone: "Africa/Bangui"
  },
  CG: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png",
    iso2: "CG",
    name: "Congo (Republic) (Congo-Brazzaville)",
    priority: 0,
    timezone: "Africa/Brazzaville"
  },
  CH: {
    areaCodes: null,
    currency: "CHF",
    dialCode: "41",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png",
    iso2: "CH",
    name: "Switzerland (Schweiz)",
    priority: 0,
    timezone: "Europe/Zurich"
  },
  CI: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "225",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png",
    iso2: "CI",
    name: "Côte d’Ivoire",
    priority: 0,
    timezone: "Africa/Abidjan"
  },
  CK: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "682",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png",
    iso2: "CK",
    name: "Cook Islands",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  CL: {
    areaCodes: null,
    currency: "CLP",
    dialCode: "56",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png",
    iso2: "CL",
    name: "Chile",
    priority: 0,
    timezone: "America/Santiago"
  },
  CM: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "237",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png",
    iso2: "CM",
    name: "Cameroon (Cameroun)",
    priority: 0,
    timezone: "Africa/Douala"
  },
  CN: {
    areaCodes: null,
    currency: "CNY",
    dialCode: "86",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png",
    iso2: "CN",
    name: "China (中国)",
    priority: 0,
    timezone: "Asia/Shanghai"
  },
  CO: {
    areaCodes: null,
    currency: "COP",
    dialCode: "57",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png",
    iso2: "CO",
    name: "Colombia",
    priority: 0,
    timezone: "America/Bogota"
  },
  CR: {
    areaCodes: null,
    currency: "CRC",
    dialCode: "506",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png",
    iso2: "CR",
    name: "Costa Rica",
    priority: 0,
    timezone: "America/Costa_Rica"
  },
  CU: {
    areaCodes: null,
    currency: "CUP",
    dialCode: "53",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png",
    iso2: "CU",
    name: "Cuba",
    priority: 0,
    timezone: "America/Havana"
  },
  CV: {
    areaCodes: null,
    currency: "CVE",
    dialCode: "238",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png",
    iso2: "CV",
    name: "Cape Verde (Kabu Verdi)",
    priority: 0,
    timezone: "Atlantic/Cape_Verde"
  },
  CW: {
    areaCodes: null,
    currency: "ANG",
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png",
    iso2: "CW",
    name: "Curaçao",
    priority: 0,
    timezone: "America/Curacao"
  },
  CX: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png",
    iso2: "CX",
    name: "Christmas Island",
    priority: 2,
    timezone: "Indian/Christmas"
  },
  CY: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "357",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png",
    iso2: "CY",
    name: "Cyprus (Κύπρος)",
    priority: 0,
    timezone: "Asia/Nicosia"
  },
  CZ: {
    areaCodes: null,
    currency: "CZK",
    dialCode: "420",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png",
    iso2: "CZ",
    name: "Czech Republic (Česká republika)",
    priority: 0,
    timezone: "Europe/Prague"
  },
  DE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "49",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png",
    iso2: "DE",
    name: "Germany (Deutschland)",
    priority: 0,
    timezone: "Europe/Berlin"
  },
  DJ: {
    areaCodes: null,
    currency: "DJF",
    dialCode: "253",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png",
    iso2: "DJ",
    name: "Djibouti",
    priority: 0,
    timezone: "Africa/Djibouti"
  },
  DK: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "45",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png",
    iso2: "DK",
    name: "Denmark (Danmark)",
    priority: 0,
    timezone: "Europe/Copenhagen"
  },
  DM: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1767",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png",
    iso2: "DM",
    name: "Dominica",
    priority: 0,
    timezone: "America/Dominica"
  },
  DO: {
    areaCodes: ["809", "829", "849"],
    currency: "DOP",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png",
    iso2: "DO",
    name: "Dominican Republic (República Dominicana)",
    priority: 2,
    timezone: "America/Santo_Domingo"
  },
  DZ: {
    areaCodes: null,
    currency: "DZD",
    dialCode: "213",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png",
    iso2: "DZ",
    name: "Algeria (‫الجزائر‬‎)",
    priority: 0,
    timezone: "Africa/Algiers"
  },
  EC: {
    areaCodes: null,
    currency: "USD",
    dialCode: "593",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png",
    iso2: "EC",
    name: "Ecuador",
    priority: 0,
    timezone: "America/Guayaquil"
  },
  EE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "372",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png",
    iso2: "EE",
    name: "Estonia (Eesti)",
    priority: 0,
    timezone: "Europe/Tallinn"
  },
  EG: {
    areaCodes: null,
    currency: "EGP",
    dialCode: "20",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png",
    iso2: "EG",
    name: "Egypt (‫مصر‬‎)",
    priority: 0,
    timezone: "Africa/Cairo"
  },
  EH: {
    areaCodes: null,
    currency: "MAD",
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png",
    iso2: "EH",
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    priority: 1,
    timezone: "Africa/El_Aaiun"
  },
  ER: {
    areaCodes: null,
    currency: "ERN",
    dialCode: "291",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png",
    iso2: "ER",
    name: "Eritrea",
    priority: 0,
    timezone: "Africa/Asmara"
  },
  ES: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "34",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png",
    iso2: "ES",
    name: "Spain (España)",
    priority: 0,
    timezone: "Europe/Madrid"
  },
  ET: {
    areaCodes: null,
    currency: "ETB",
    dialCode: "251",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png",
    iso2: "ET",
    name: "Ethiopia",
    priority: 0,
    timezone: "Africa/Addis_Ababa"
  },
  FI: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png",
    iso2: "FI",
    name: "Finland (Suomi)",
    priority: 0,
    timezone: "Europe/Helsinki"
  },
  FJ: {
    areaCodes: null,
    currency: "FJD",
    dialCode: "679",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png",
    iso2: "FJ",
    name: "Fiji",
    priority: 0,
    timezone: "Pacific/Fiji"
  },
  FK: {
    areaCodes: null,
    currency: "FKP",
    dialCode: "500",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png",
    iso2: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    priority: 0,
    timezone: "Atlantic/Stanley"
  },
  FM: {
    areaCodes: null,
    currency: "USD",
    dialCode: "691",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png",
    iso2: "FM",
    name: "Micronesia",
    priority: 0,
    timezone: "Etc/GMT-10"
  },
  FO: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "298",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png",
    iso2: "FO",
    name: "Faroe Islands (Føroyar)",
    priority: 0,
    timezone: "Atlantic/Faroe"
  },
  FR: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "33",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png",
    iso2: "FR",
    name: "France",
    priority: 0,
    timezone: "Europe/Paris"
  },
  GA: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "241",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png",
    iso2: "GA",
    name: "Gabon",
    priority: 0,
    timezone: "Africa/Libreville"
  },
  GB: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png",
    iso2: "GB",
    name: "United Kingdom",
    priority: 0,
    timezone: "Etc/GMT"
  },
  GD: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1473",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png",
    iso2: "GD",
    name: "Grenada",
    priority: 0,
    timezone: "America/Grenada"
  },
  GE: {
    areaCodes: null,
    currency: "GEL",
    dialCode: "995",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png",
    iso2: "GE",
    name: "Georgia (საქართველო)",
    priority: 0,
    timezone: "Asia/Tbilisi"
  },
  GF: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "594",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png",
    iso2: "GF",
    name: "French Guiana (Guyane française)",
    priority: 0,
    timezone: "America/Cayenne"
  },
  GG: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png",
    iso2: "GG",
    name: "Guernsey",
    priority: 1,
    timezone: "Europe/Guernsey"
  },
  GH: {
    areaCodes: null,
    currency: "GHS",
    dialCode: "233",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png",
    iso2: "GH",
    name: "Ghana (Gaana)",
    priority: 0,
    timezone: "Africa/Accra"
  },
  GI: {
    areaCodes: null,
    currency: "GIP",
    dialCode: "350",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png",
    iso2: "GI",
    name: "Gibraltar",
    priority: 0,
    timezone: "Europe/Gibraltar"
  },
  GL: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "299",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png",
    iso2: "GL",
    name: "Greenland (Kalaallit Nunaat)",
    priority: 0,
    timezone: "America/Godthab"
  },
  GM: {
    areaCodes: null,
    currency: "GMD",
    dialCode: "220",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png",
    iso2: "GM",
    name: "Gambia",
    priority: 0,
    timezone: "Africa/Banjul"
  },
  GN: {
    areaCodes: null,
    currency: "GNF",
    dialCode: "224",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png",
    iso2: "GN",
    name: "Guinea (Guinée)",
    priority: 0,
    timezone: "Africa/Conakry"
  },
  GP: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png",
    iso2: "GP",
    name: "Guadeloupe",
    priority: 0,
    timezone: "America/Guadeloupe"
  },
  GQ: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "240",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png",
    iso2: "GQ",
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    priority: 0,
    timezone: "Africa/Malabo"
  },
  GR: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "30",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png",
    iso2: "GR",
    name: "Greece (Ελλάδα)",
    priority: 0,
    timezone: "Europe/Athens"
  },
  GT: {
    areaCodes: null,
    currency: "GTQ",
    dialCode: "502",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png",
    iso2: "GT",
    name: "Guatemala",
    priority: 0,
    timezone: "America/Guatemala"
  },
  GU: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1671",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png",
    iso2: "GU",
    name: "Guam",
    priority: 0,
    timezone: "Pacific/Guam"
  },
  GW: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "245",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png",
    iso2: "GW",
    name: "Guinea-Bissau (Guiné Bissau)",
    priority: 0,
    timezone: "Africa/Bissau"
  },
  GY: {
    areaCodes: null,
    currency: "GYD",
    dialCode: "592",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png",
    iso2: "GY",
    name: "Guyana",
    priority: 0,
    timezone: "America/Guyana"
  },
  HK: {
    areaCodes: null,
    currency: "HKD",
    dialCode: "852",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png",
    iso2: "HK",
    name: "Hong Kong (香港)",
    priority: 0,
    timezone: "Asia/Hong_Kong"
  },
  HN: {
    areaCodes: null,
    currency: "HNL",
    dialCode: "504",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png",
    iso2: "HN",
    name: "Honduras",
    priority: 0,
    timezone: "America/Tegucigalpa"
  },
  HR: {
    areaCodes: null,
    currency: "HRK",
    dialCode: "385",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png",
    iso2: "HR",
    name: "Croatia (Hrvatska)",
    priority: 0,
    timezone: "Europe/Zagreb"
  },
  HT: {
    areaCodes: null,
    currency: "HTG",
    dialCode: "509",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png",
    iso2: "HT",
    name: "Haiti",
    priority: 0,
    timezone: "America/Port-au-Prince"
  },
  HU: {
    areaCodes: null,
    currency: "HUF",
    dialCode: "36",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png",
    iso2: "HU",
    name: "Hungary (Magyarország)",
    priority: 0,
    timezone: "Europe/Budapest"
  },
  ID: {
    areaCodes: null,
    currency: "IDR",
    dialCode: "62",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png",
    iso2: "ID",
    name: "Indonesia",
    priority: 0,
    timezone: "Asia/Makassar"
  },
  IE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "353",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png",
    iso2: "IE",
    name: "Ireland",
    priority: 0,
    timezone: "Europe/Dublin"
  },
  IL: {
    areaCodes: null,
    currency: "ILS",
    dialCode: "972",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png",
    iso2: "IL",
    name: "Israel (‫ישראל‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  IM: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png",
    iso2: "IM",
    name: "Isle of Man",
    priority: 2,
    timezone: "Europe/Isle_of_Man"
  },
  IN: {
    areaCodes: null,
    currency: "INR",
    dialCode: "91",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png",
    iso2: "IN",
    name: "India (भारत)",
    priority: 0,
    timezone: "Asia/Kolkata"
  },
  IO: {
    areaCodes: null,
    currency: "USD",
    dialCode: "246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png",
    iso2: "IO",
    name: "British Indian Ocean Territory",
    priority: 0,
    timezone: "Etc/GMT-5"
  },
  IQ: {
    areaCodes: null,
    currency: "IQD",
    dialCode: "964",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png",
    iso2: "IQ",
    name: "Iraq (‫العراق‬‎)",
    priority: 0,
    timezone: "Asia/Baghdad"
  },
  IR: {
    areaCodes: null,
    currency: "IRR",
    dialCode: "98",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png",
    iso2: "IR",
    name: "Iran (‫ایران‬‎)",
    priority: 0,
    timezone: "Asia/Tehran"
  },
  IS: {
    areaCodes: null,
    currency: "ISK",
    dialCode: "354",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png",
    iso2: "IS",
    name: "Iceland (Ísland)",
    priority: 0,
    timezone: "Atlantic/Reykjavik"
  },
  IT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png",
    iso2: "IT",
    name: "Italy (Italia)",
    priority: 0,
    timezone: "Europe/Rome"
  },
  JE: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png",
    iso2: "JE",
    name: "Jersey",
    priority: 3,
    timezone: "Europe/Jersey"
  },
  JM: {
    areaCodes: null,
    currency: "JMD",
    dialCode: "1876",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png",
    iso2: "JM",
    name: "Jamaica",
    priority: 0,
    timezone: "America/Jamaica"
  },
  JO: {
    areaCodes: null,
    currency: "JOD",
    dialCode: "962",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png",
    iso2: "JO",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
    timezone: "Asia/Amman"
  },
  JP: {
    areaCodes: null,
    currency: "JPY",
    dialCode: "81",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png",
    iso2: "JP",
    name: "Japan (日本)",
    priority: 0,
    timezone: "Asia/Tokyo"
  },
  KE: {
    areaCodes: null,
    currency: "KES",
    dialCode: "254",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png",
    iso2: "KE",
    name: "Kenya",
    priority: 0,
    timezone: "Africa/Nairobi"
  },
  KG: {
    areaCodes: null,
    currency: "KGS",
    dialCode: "996",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png",
    iso2: "KG",
    name: "Kyrgyzstan (Кыргызстан)",
    priority: 0,
    timezone: "Asia/Bishkek"
  },
  KH: {
    areaCodes: null,
    currency: "KHR",
    dialCode: "855",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png",
    iso2: "KH",
    name: "Cambodia (កម្ពុជា)",
    priority: 0,
    timezone: "Asia/Phnom_Penh"
  },
  KI: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "686",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png",
    iso2: "KI",
    name: "Kiribati",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  KM: {
    areaCodes: null,
    currency: "KMF",
    dialCode: "269",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png",
    iso2: "KM",
    name: "Comoros (‫جزر القمر‬‎)",
    priority: 0,
    timezone: "Indian/Comoro"
  },
  KN: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1869",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png",
    iso2: "KN",
    name: "Saint Kitts and Nevis",
    priority: 0,
    timezone: "America/St_Kitts"
  },
  KP: {
    areaCodes: null,
    currency: "KPW",
    dialCode: "850",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png",
    iso2: "KP",
    name: "North Korea (조선 민주주의 인민 공화국)",
    priority: 0,
    timezone: "Asia/Pyongyang"
  },
  KR: {
    areaCodes: null,
    currency: "KRW",
    dialCode: "82",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png",
    iso2: "KR",
    name: "South Korea (대한민국)",
    priority: 0,
    timezone: "Asia/Seoul"
  },
  KW: {
    areaCodes: null,
    currency: "KWD",
    dialCode: "965",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png",
    iso2: "KW",
    name: "Kuwait (‫الكويت‬‎)",
    priority: 0,
    timezone: "Asia/Kuwait"
  },
  KY: {
    areaCodes: null,
    currency: "KYD",
    dialCode: "1345",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png",
    iso2: "KY",
    name: "Cayman Islands",
    priority: 0,
    timezone: "Etc/GMT+5"
  },
  KZ: {
    areaCodes: null,
    currency: "KZT",
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png",
    iso2: "KZ",
    name: "Kazakhstan (Казахстан)",
    priority: 1,
    timezone: "Asia/Almaty"
  },
  LA: {
    areaCodes: null,
    currency: "LAK",
    dialCode: "856",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png",
    iso2: "LA",
    name: "Laos (ລາວ)",
    priority: 0,
    timezone: "Asia/Vientiane"
  },
  LB: {
    areaCodes: null,
    currency: "LBP",
    dialCode: "961",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png",
    iso2: "LB",
    name: "Lebanon (‫لبنان‬‎)",
    priority: 0,
    timezone: "Asia/Beirut"
  },
  LC: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1758",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png",
    iso2: "LC",
    name: "Saint Lucia",
    priority: 0,
    timezone: "America/St_Lucia"
  },
  LI: {
    areaCodes: null,
    currency: "CHF",
    dialCode: "423",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png",
    iso2: "LI",
    name: "Liechtenstein",
    priority: 0,
    timezone: "Europe/Vaduz"
  },
  LK: {
    areaCodes: null,
    currency: "LKR",
    dialCode: "94",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png",
    iso2: "LK",
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    priority: 0,
    timezone: "Asia/Colombo"
  },
  LR: {
    areaCodes: null,
    currency: "LRD",
    dialCode: "231",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png",
    iso2: "LR",
    name: "Liberia",
    priority: 0,
    timezone: "Africa/Monrovia"
  },
  LS: {
    areaCodes: null,
    currency: "LSL",
    dialCode: "266",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png",
    iso2: "LS",
    name: "Lesotho",
    priority: 0,
    timezone: "Africa/Maseru"
  },
  LT: {
    areaCodes: null,
    currency: "LTL",
    dialCode: "370",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png",
    iso2: "LT",
    name: "Lithuania (Lietuva)",
    priority: 0,
    timezone: "Europe/Vilnius"
  },
  LU: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "352",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png",
    iso2: "LU",
    name: "Luxembourg",
    priority: 0,
    timezone: "Europe/Luxembourg"
  },
  LV: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "371",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png",
    iso2: "LV",
    name: "Latvia (Latvija)",
    priority: 0,
    timezone: "Europe/Riga"
  },
  LY: {
    areaCodes: null,
    currency: "LYD",
    dialCode: "218",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png",
    iso2: "LY",
    name: "Libya (‫ليبيا‬‎)",
    priority: 0,
    timezone: "Africa/Tripoli"
  },
  MA: {
    areaCodes: null,
    currency: "MAD",
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png",
    iso2: "MA",
    name: "Morocco (‫المغرب‬‎)",
    priority: 0,
    timezone: "Africa/Casablanca"
  },
  MC: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "377",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png",
    iso2: "MC",
    name: "Monaco",
    priority: 0,
    timezone: "Europe/Paris"
  },
  MD: {
    areaCodes: null,
    currency: "MDL",
    dialCode: "373",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png",
    iso2: "MD",
    name: "Moldova (Republica Moldova)",
    priority: 0,
    timezone: "Europe/Chisinau"
  },
  ME: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "382",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png",
    iso2: "ME",
    name: "Montenegro (Crna Gora)",
    priority: 0,
    timezone: "Europe/Podgorica"
  },
  MF: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png",
    iso2: "MF",
    name: "Saint Martin (Saint-Martin (partie française))",
    priority: 2,
    timezone: "America/Marigot"
  },
  MG: {
    areaCodes: null,
    currency: "MGA",
    dialCode: "261",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png",
    iso2: "MG",
    name: "Madagascar (Madagasikara)",
    priority: 0,
    timezone: "Indian/Antananarivo"
  },
  MH: {
    areaCodes: null,
    currency: "USD",
    dialCode: "692",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png",
    iso2: "MH",
    name: "Marshall Islands",
    priority: 0,
    timezone: "Etc/GMT-11"
  },
  MK: {
    areaCodes: null,
    currency: "MKD",
    dialCode: "389",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png",
    iso2: "MK",
    name: "Macedonia (FYROM) (Македонија)",
    priority: 0,
    timezone: "Europe/Skopje"
  },
  ML: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "223",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png",
    iso2: "ML",
    name: "Mali",
    priority: 0,
    timezone: "Africa/Bamako"
  },
  MM: {
    areaCodes: null,
    currency: "MMK",
    dialCode: "95",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png",
    iso2: "MM",
    name: "Myanmar (Burma) (မြန်မာ)",
    priority: 0,
    timezone: "Asia/Yangon"
  },
  MN: {
    areaCodes: null,
    currency: "MNT",
    dialCode: "976",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png",
    iso2: "MN",
    name: "Mongolia (Монгол)",
    priority: 0,
    timezone: "Asia/Ulaanbaatar"
  },
  MO: {
    areaCodes: null,
    currency: "MOP",
    dialCode: "853",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png",
    iso2: "MO",
    name: "Macau (澳門)",
    priority: 0,
    timezone: "Asia/Macau"
  },
  MP: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png",
    iso2: "MP",
    name: "Northern Mariana Islands",
    priority: 0,
    timezone: "Pacific/Saipan"
  },
  MQ: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "596",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png",
    iso2: "MQ",
    name: "Martinique",
    priority: 0,
    timezone: "America/Martinique"
  },
  MR: {
    areaCodes: null,
    currency: "MRO",
    dialCode: "222",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png",
    iso2: "MR",
    name: "Mauritania (‫موريتانيا‬‎)",
    priority: 0,
    timezone: "Africa/Nouakchott"
  },
  MS: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1664",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png",
    iso2: "MS",
    name: "Montserrat",
    priority: 0,
    timezone: "America/Montserrat"
  },
  MT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "356",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png",
    iso2: "MT",
    name: "Malta",
    priority: 0,
    timezone: "Europe/Malta"
  },
  MU: {
    areaCodes: null,
    currency: "MUR",
    dialCode: "230",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png",
    iso2: "MU",
    name: "Mauritius (Moris)",
    priority: 0,
    timezone: "Indian/Mauritius"
  },
  MV: {
    areaCodes: null,
    currency: "MVR",
    dialCode: "960",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png",
    iso2: "MV",
    name: "Maldives",
    priority: 0,
    timezone: "Indian/Maldives"
  },
  MW: {
    areaCodes: null,
    currency: "MWK",
    dialCode: "265",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png",
    iso2: "MW",
    name: "Malawi",
    priority: 0,
    timezone: "Africa/Blantyre"
  },
  MX: {
    areaCodes: null,
    currency: "MXN",
    dialCode: "52",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png",
    iso2: "MX",
    name: "Mexico (México)",
    priority: 0,
    timezone: "America/Mexico_City"
  },
  MY: {
    areaCodes: null,
    currency: "MYR",
    dialCode: "60",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png",
    iso2: "MY",
    name: "Malaysia",
    priority: 0,
    timezone: "Asia/Kuching"
  },
  MZ: {
    areaCodes: null,
    currency: "MZN",
    dialCode: "258",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png",
    iso2: "MZ",
    name: "Mozambique (Moçambique)",
    priority: 0,
    timezone: "Africa/Maputo"
  },
  NA: {
    areaCodes: null,
    currency: "NAD",
    dialCode: "264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png",
    iso2: "NA",
    name: "Namibia (Namibië)",
    priority: 0,
    timezone: "Africa/Windhoek"
  },
  NC: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "687",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png",
    iso2: "NC",
    name: "New Caledonia (Nouvelle-Calédonie)",
    priority: 0,
    timezone: "Pacific/Noumea"
  },
  NE: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "227",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png",
    iso2: "NE",
    name: "Niger (Nijar)",
    priority: 0,
    timezone: "Africa/Niamey"
  },
  NF: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "672",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png",
    iso2: "NF",
    name: "Norfolk Island",
    priority: 0,
    timezone: "Pacific/Norfolk"
  },
  NG: {
    areaCodes: null,
    currency: "NGN",
    dialCode: "234",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png",
    iso2: "NG",
    name: "Nigeria",
    priority: 0,
    timezone: "Africa/Lagos"
  },
  NI: {
    areaCodes: null,
    currency: "NIO",
    dialCode: "505",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png",
    iso2: "NI",
    name: "Nicaragua",
    priority: 0,
    timezone: "America/Managua"
  },
  NL: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "31",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png",
    iso2: "NL",
    name: "Netherlands (Nederland)",
    priority: 0,
    timezone: "Europe/Amsterdam"
  },
  NO: {
    areaCodes: null,
    currency: "NOK",
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png",
    iso2: "NO",
    name: "Norway (Norge)",
    priority: 0,
    timezone: "Europe/Oslo"
  },
  NP: {
    areaCodes: null,
    currency: "NPR",
    dialCode: "977",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png",
    iso2: "NP",
    name: "Nepal (नेपाल)",
    priority: 0,
    timezone: "Asia/Kathmandu"
  },
  NR: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "674",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png",
    iso2: "NR",
    name: "Nauru",
    priority: 0,
    timezone: "Pacific/Nauru"
  },
  NU: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "683",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png",
    iso2: "NU",
    name: "Niue",
    priority: 0,
    timezone: "Pacific/Niue"
  },
  NZ: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "64",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png",
    iso2: "NZ",
    name: "New Zealand",
    priority: 0,
    timezone: "Pacific/Auckland"
  },
  OM: {
    areaCodes: null,
    currency: "OMR",
    dialCode: "968",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png",
    iso2: "OM",
    name: "Oman (‫عُمان‬‎)",
    priority: 0,
    timezone: "Asia/Muscat"
  },
  PA: {
    areaCodes: null,
    currency: "PAB",
    dialCode: "507",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png",
    iso2: "PA",
    name: "Panama (Panamá)",
    priority: 0,
    timezone: "America/Panama"
  },
  PE: {
    areaCodes: null,
    currency: "PEN",
    dialCode: "51",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png",
    iso2: "PE",
    name: "Peru (Perú)",
    priority: 0,
    timezone: "America/Lima"
  },
  PF: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "689",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png",
    iso2: "PF",
    name: "French Polynesia (Polynésie française)",
    priority: 0,
    timezone: "Etc/GMT+9"
  },
  PG: {
    areaCodes: null,
    currency: "PGK",
    dialCode: "675",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png",
    iso2: "PG",
    name: "Papua New Guinea",
    priority: 0,
    timezone: "Pacific/Port_Moresby"
  },
  PH: {
    areaCodes: null,
    currency: "PHP",
    dialCode: "63",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png",
    iso2: "PH",
    name: "Philippines",
    priority: 0,
    timezone: "Asia/Manila"
  },
  PK: {
    areaCodes: null,
    currency: "PKR",
    dialCode: "92",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png",
    iso2: "PK",
    name: "Pakistan (‫پاکستان‬‎)",
    priority: 0,
    timezone: "Asia/Karachi"
  },
  PL: {
    areaCodes: null,
    currency: "PLN",
    dialCode: "48",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png",
    iso2: "PL",
    name: "Poland (Polska)",
    priority: 0,
    timezone: "Europe/Warsaw"
  },
  PM: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "508",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png",
    iso2: "PM",
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    priority: 0,
    timezone: "America/Miquelon"
  },
  PR: {
    areaCodes: ["787", "939"],
    currency: "USD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png",
    iso2: "PR",
    name: "Puerto Rico",
    priority: 3,
    timezone: "America/Puerto_Rico"
  },
  PS: {
    areaCodes: null,
    currency: "ILS",
    dialCode: "970",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png",
    iso2: "PS",
    name: "Palestine (‫فلسطين‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  PT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "351",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png",
    iso2: "PT",
    name: "Portugal",
    priority: 0,
    timezone: "Europe/Lisbon"
  },
  PW: {
    areaCodes: null,
    currency: "USD",
    dialCode: "680",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png",
    iso2: "PW",
    name: "Palau",
    priority: 0,
    timezone: "Etc/GMT-9"
  },
  PY: {
    areaCodes: null,
    currency: "PYG",
    dialCode: "595",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png",
    iso2: "PY",
    name: "Paraguay",
    priority: 0,
    timezone: "America/Asuncion"
  },
  QA: {
    areaCodes: null,
    currency: "QAR",
    dialCode: "974",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png",
    iso2: "QA",
    name: "Qatar (‫قطر‬‎)",
    priority: 0,
    timezone: "Asia/Qatar"
  },
  RE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png",
    iso2: "RE",
    name: "Réunion (La Réunion)",
    priority: 0,
    timezone: "Indian/Reunion"
  },
  RO: {
    areaCodes: null,
    currency: "RON",
    dialCode: "40",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png",
    iso2: "RO",
    name: "Romania (România)",
    priority: 0,
    timezone: "Europe/Bucharest"
  },
  RS: {
    areaCodes: null,
    currency: "RSD",
    dialCode: "381",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png",
    iso2: "RS",
    name: "Serbia (Србија)",
    priority: 0,
    timezone: "Europe/Belgrade"
  },
  RU: {
    areaCodes: null,
    currency: "RUB",
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png",
    iso2: "RU",
    name: "Russia (Россия)",
    priority: 0,
    timezone: "Asia/Krasnoyarsk"
  },
  RW: {
    areaCodes: null,
    currency: "RWF",
    dialCode: "250",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png",
    iso2: "RW",
    name: "Rwanda",
    priority: 0,
    timezone: "Africa/Kigali"
  },
  SA: {
    areaCodes: null,
    currency: "SAR",
    dialCode: "966",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png",
    iso2: "SA",
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    priority: 0,
    timezone: "Asia/Riyadh"
  },
  SB: {
    areaCodes: null,
    currency: "SBD",
    dialCode: "677",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png",
    iso2: "SB",
    name: "Solomon Islands",
    priority: 0,
    timezone: "Pacific/Guadalcanal"
  },
  SC: {
    areaCodes: null,
    currency: "SCR",
    dialCode: "248",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png",
    iso2: "SC",
    name: "Seychelles",
    priority: 0,
    timezone: "Indian/Mahe"
  },
  SD: {
    areaCodes: null,
    currency: "SDG",
    dialCode: "249",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png",
    iso2: "SD",
    name: "Sudan (‫السودان‬‎)",
    priority: 0,
    timezone: "Africa/Khartoum"
  },
  SE: {
    areaCodes: null,
    currency: "SEK",
    dialCode: "46",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png",
    iso2: "SE",
    name: "Sweden (Sverige)",
    priority: 0,
    timezone: "Europe/Stockholm"
  },
  SG: {
    areaCodes: null,
    currency: "SGD",
    dialCode: "65",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png",
    iso2: "SG",
    name: "Singapore",
    priority: 0,
    timezone: "Asia/Singapore"
  },
  SH: {
    areaCodes: null,
    currency: "SHP",
    dialCode: "290",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png",
    iso2: "SH",
    name: "Saint Helena",
    priority: 0,
    timezone: "Atlantic/St_Helena"
  },
  SI: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "386",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png",
    iso2: "SI",
    name: "Slovenia (Slovenija)",
    priority: 0,
    timezone: "Europe/Ljubljana"
  },
  SJ: {
    areaCodes: null,
    currency: "NOK",
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png",
    iso2: "SJ",
    name: "Svalbard and Jan Mayen",
    priority: 1,
    timezone: "Arctic/Longyearbyen"
  },
  SK: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "421",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png",
    iso2: "SK",
    name: "Slovakia (Slovensko)",
    priority: 0,
    timezone: "Europe/Bratislava"
  },
  SL: {
    areaCodes: null,
    currency: "SLL",
    dialCode: "232",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png",
    iso2: "SL",
    name: "Sierra Leone",
    priority: 0,
    timezone: "Africa/Freetown"
  },
  SM: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "378",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png",
    iso2: "SM",
    name: "San Marino",
    priority: 0,
    timezone: "Europe/San_Marino"
  },
  SN: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "221",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png",
    iso2: "SN",
    name: "Senegal (Sénégal)",
    priority: 0,
    timezone: "Africa/Dakar"
  },
  SO: {
    areaCodes: null,
    currency: "SOS",
    dialCode: "252",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png",
    iso2: "SO",
    name: "Somalia (Soomaaliya)",
    priority: 0,
    timezone: "Africa/Mogadishu"
  },
  SR: {
    areaCodes: null,
    currency: "SRD",
    dialCode: "597",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png",
    iso2: "SR",
    name: "Suriname",
    priority: 0,
    timezone: "America/Paramaribo"
  },
  SS: {
    areaCodes: null,
    currency: "SSP",
    dialCode: "211",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png",
    iso2: "SS",
    name: "South Sudan (‫جنوب السودان‬‎)",
    priority: 0,
    timezone: "Africa/Juba"
  },
  ST: {
    areaCodes: null,
    currency: "STD",
    dialCode: "239",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png",
    iso2: "ST",
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    priority: 0,
    timezone: "Africa/Sao_Tome"
  },
  SV: {
    areaCodes: null,
    currency: "USD",
    dialCode: "503",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png",
    iso2: "SV",
    name: "El Salvador",
    priority: 0,
    timezone: "America/El_Salvador"
  },
  SX: {
    areaCodes: null,
    currency: "ANG",
    dialCode: "1721",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png",
    iso2: "SX",
    name: "Sint Maarten",
    priority: 0,
    timezone: "America/Lower_Princes"
  },
  SY: {
    areaCodes: null,
    currency: "SYP",
    dialCode: "963",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png",
    iso2: "SY",
    name: "Syria (‫سوريا‬‎)",
    priority: 0,
    timezone: "Asia/Damascus"
  },
  SZ: {
    areaCodes: null,
    currency: "SZL",
    dialCode: "268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png",
    iso2: "SZ",
    name: "Swaziland",
    priority: 0,
    timezone: "Africa/Mbabane"
  },
  TC: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1649",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png",
    iso2: "TC",
    name: "Turks and Caicos Islands",
    priority: 0,
    timezone: "America/Grand_Turk"
  },
  TD: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "235",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png",
    iso2: "TD",
    name: "Chad (Tchad)",
    priority: 0,
    timezone: "Africa/Ndjamena"
  },
  TG: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "228",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png",
    iso2: "TG",
    name: "Togo",
    priority: 0,
    timezone: "Africa/Lome"
  },
  TH: {
    areaCodes: null,
    currency: "THB",
    dialCode: "66",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png",
    iso2: "TH",
    name: "Thailand (ไทย)",
    priority: 0,
    timezone: "Asia/Bangkok"
  },
  TJ: {
    areaCodes: null,
    currency: "TJS",
    dialCode: "992",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png",
    iso2: "TJ",
    name: "Tajikistan",
    priority: 0,
    timezone: "Asia/Dushanbe"
  },
  TK: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "690",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png",
    iso2: "TK",
    name: "Tokelau",
    priority: 0,
    timezone: "Pacific/Fakaofo"
  },
  TL: {
    areaCodes: null,
    currency: "USD",
    dialCode: "670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png",
    iso2: "TL",
    name: "Timor-Leste",
    priority: 0,
    timezone: "Asia/Dili"
  },
  TM: {
    areaCodes: null,
    currency: "TMT",
    dialCode: "993",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png",
    iso2: "TM",
    name: "Turkmenistan",
    priority: 0,
    timezone: "Asia/Ashgabat"
  },
  TN: {
    areaCodes: null,
    currency: "TND",
    dialCode: "216",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png",
    iso2: "TN",
    name: "Tunisia (‫تونس‬‎)",
    priority: 0,
    timezone: "Africa/Tunis"
  },
  TO: {
    areaCodes: null,
    currency: "TOP",
    dialCode: "676",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png",
    iso2: "TO",
    name: "Tonga",
    priority: 0,
    timezone: "Pacific/Tongatapu"
  },
  TR: {
    areaCodes: null,
    currency: "TRY",
    dialCode: "90",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png",
    iso2: "TR",
    name: "Turkey (Türkiye)",
    priority: 0,
    timezone: "Europe/Istanbul"
  },
  TT: {
    areaCodes: null,
    currency: "TTD",
    dialCode: "1868",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png",
    iso2: "TT",
    name: "Trinidad and Tobago",
    priority: 0,
    timezone: "America/Port_of_Spain"
  },
  TV: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "688",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png",
    iso2: "TV",
    name: "Tuvalu",
    priority: 0,
    timezone: "Etc/GMT-12"
  },
  TW: {
    areaCodes: null,
    currency: "TWD",
    dialCode: "886",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png",
    iso2: "TW",
    name: "Taiwan (台灣)",
    priority: 0,
    timezone: "Asia/Taipei"
  },
  TZ: {
    areaCodes: null,
    currency: "TZS",
    dialCode: "255",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png",
    iso2: "TZ",
    name: "Tanzania",
    priority: 0,
    timezone: "Africa/Dar_es_Salaam"
  },
  UA: {
    areaCodes: null,
    currency: "UAH",
    dialCode: "380",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png",
    iso2: "UA",
    name: "Ukraine (Україна)",
    priority: 0,
    timezone: "Europe/Kiev"
  },
  UG: {
    areaCodes: null,
    currency: "UGX",
    dialCode: "256",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png",
    iso2: "UG",
    name: "Uganda",
    priority: 0,
    timezone: "Africa/Kampala"
  },
  US: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png",
    iso2: "US",
    name: "United States",
    priority: 0,
    timezone: "America/Chicago"
  },
  UY: {
    areaCodes: null,
    currency: "UYU",
    dialCode: "598",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png",
    iso2: "UY",
    name: "Uruguay",
    priority: 0,
    timezone: "America/Montevideo"
  },
  UZ: {
    areaCodes: null,
    currency: "UZS",
    dialCode: "998",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png",
    iso2: "UZ",
    name: "Uzbekistan (Oʻzbekiston)",
    priority: 0,
    timezone: "Asia/Samarkand"
  },
  VA: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png",
    iso2: "VA",
    name: "Vatican City (Città del Vaticano)",
    priority: 1,
    timezone: "Europe/Rome"
  },
  VC: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1784",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png",
    iso2: "VC",
    name: "Saint Vincent and the Grenadines",
    priority: 0,
    timezone: "America/St_Vincent"
  },
  VE: {
    areaCodes: null,
    currency: "VEF",
    dialCode: "58",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png",
    iso2: "VE",
    name: "Venezuela",
    priority: 0,
    timezone: "America/Caracas"
  },
  VG: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1284",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png",
    iso2: "VG",
    name: "British Virgin Islands",
    priority: 0,
    timezone: "America/Tortola"
  },
  VI: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1340",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png",
    iso2: "VI",
    name: "U.S. Virgin Islands",
    priority: 0,
    timezone: "America/St_Thomas"
  },
  VN: {
    areaCodes: null,
    currency: "VND",
    dialCode: "84",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png",
    iso2: "VN",
    name: "Vietnam (Việt Nam)",
    priority: 0,
    timezone: "Asia/Ho_Chi_Minh"
  },
  VU: {
    areaCodes: null,
    currency: "VUV",
    dialCode: "678",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png",
    iso2: "VU",
    name: "Vanuatu",
    priority: 0,
    timezone: "Pacific/Efate"
  },
  WF: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "681",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png",
    iso2: "WF",
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    priority: 0,
    timezone: "Pacific/Wallis"
  },
  WS: {
    areaCodes: null,
    currency: "WST",
    dialCode: "685",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png",
    iso2: "WS",
    name: "Samoa",
    priority: 0,
    timezone: "Pacific/Apia"
  },
  XK: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "383",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png",
    iso2: "XK",
    name: "Kosovo",
    priority: 0,
    timezone: "Europe/Rome"
  },
  YE: {
    areaCodes: null,
    currency: "YER",
    dialCode: "967",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png",
    iso2: "YE",
    name: "Yemen (‫اليمن‬‎)",
    priority: 0,
    timezone: "Asia/Aden"
  },
  YT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png",
    iso2: "YT",
    name: "Mayotte",
    priority: 1,
    timezone: "Indian/Mayotte"
  },
  ZA: {
    areaCodes: null,
    currency: "ZAR",
    dialCode: "27",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png",
    iso2: "ZA",
    name: "South Africa",
    priority: 0,
    timezone: "Africa/Johannesburg"
  },
  ZM: {
    areaCodes: null,
    currency: "ZMK",
    dialCode: "260",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png",
    iso2: "ZM",
    name: "Zambia",
    priority: 0,
    timezone: "Africa/Lusaka"
  },
  ZW: {
    areaCodes: null,
    currency: "ZWL",
    dialCode: "263",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png",
    iso2: "ZW",
    name: "Zimbabwe",
    priority: 0,
    timezone: "Africa/Harare"
  }
};
fu(Pa, "iso2");
const Ea = {
  AED: {
    code: "AED",
    decimal_digits: 2,
    name: "United Arab Emirates Dirham",
    name_plural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbol_native: "د.إ.‏",
    zero_decimal: !1
  },
  AFN: {
    code: "AFN",
    decimal_digits: 0,
    name: "Afghan Afghani",
    name_plural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbol_native: "؋",
    zero_decimal: !1
  },
  ALL: {
    code: "ALL",
    decimal_digits: 0,
    name: "Albanian Lek",
    name_plural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbol_native: "Lek",
    zero_decimal: !1
  },
  AMD: {
    code: "AMD",
    decimal_digits: 0,
    name: "Armenian Dram",
    name_plural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbol_native: "դր.",
    zero_decimal: !1
  },
  ANG: {
    code: "ANG",
    decimal_digits: 2,
    name: "Netherlands Antillean Guilder",
    name_plural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbol_native: "NAf.",
    zero_decimal: !1
  },
  AOA: {
    code: "AOA",
    decimal_digits: 2,
    name: "Angolan Kwanza",
    name_plural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbol_native: "Kz",
    zero_decimal: !1
  },
  ARS: {
    code: "ARS",
    decimal_digits: 2,
    name: "Argentine Peso",
    name_plural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbol_native: "$",
    zero_decimal: !1
  },
  AUD: {
    code: "AUD",
    decimal_digits: 2,
    name: "Australian Dollar",
    name_plural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbol_native: "$",
    zero_decimal: !1
  },
  AWG: {
    code: "AWG",
    decimal_digits: 2,
    name: "Aruban Florin",
    name_plural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbol_native: "Afl.",
    zero_decimal: !1
  },
  AZN: {
    code: "AZN",
    decimal_digits: 2,
    name: "Azerbaijani Manat",
    name_plural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbol_native: "ман.",
    zero_decimal: !1
  },
  BAM: {
    code: "BAM",
    decimal_digits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    name_plural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbol_native: "KM",
    zero_decimal: !1
  },
  BBD: {
    code: "BBD",
    decimal_digits: 2,
    name: "Barbadian Dollar",
    name_plural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BDT: {
    code: "BDT",
    decimal_digits: 2,
    name: "Bangladeshi Taka",
    name_plural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbol_native: "৳",
    zero_decimal: !1
  },
  BGN: {
    code: "BGN",
    decimal_digits: 2,
    name: "Bulgarian Lev",
    name_plural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbol_native: "лв.",
    zero_decimal: !1
  },
  BHD: {
    code: "BHD",
    decimal_digits: 3,
    name: "Bahraini Dinar",
    name_plural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbol_native: "د.ب.‏",
    zero_decimal: !1
  },
  BIF: {
    code: "BIF",
    decimal_digits: 0,
    name: "Burundian Franc",
    name_plural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbol_native: "FBu",
    zero_decimal: !0
  },
  BMD: {
    code: "BMD",
    decimal_digits: 2,
    name: "Bermudan Dollar",
    name_plural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BND: {
    code: "BND",
    decimal_digits: 2,
    name: "Brunei Dollar",
    name_plural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbol_native: "$",
    zero_decimal: !1
  },
  BOB: {
    code: "BOB",
    decimal_digits: 2,
    name: "Bolivian Boliviano",
    name_plural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbol_native: "Bs",
    zero_decimal: !1
  },
  BRL: {
    code: "BRL",
    decimal_digits: 2,
    name: "Brazilian Real",
    name_plural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbol_native: "R$",
    zero_decimal: !1
  },
  BSD: {
    code: "BSD",
    decimal_digits: 2,
    name: "Bahamian Dollar",
    name_plural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BTN: {
    code: "BTN",
    decimal_digits: 2,
    name: "Bhutanese Ngultrum",
    name_plural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbol_native: "Nu.",
    zero_decimal: !1
  },
  BWP: {
    code: "BWP",
    decimal_digits: 2,
    name: "Botswanan Pula",
    name_plural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbol_native: "P",
    zero_decimal: !1
  },
  BYN: {
    code: "BYN",
    decimal_digits: 2,
    name: "Belarusian Ruble",
    name_plural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbol_native: "руб.",
    zero_decimal: !1
  },
  BZD: {
    code: "BZD",
    decimal_digits: 2,
    name: "Belize Dollar",
    name_plural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CAD: {
    code: "CAD",
    decimal_digits: 2,
    name: "Canadian Dollar",
    name_plural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CDF: {
    code: "CDF",
    decimal_digits: 2,
    name: "Congolese Franc",
    name_plural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbol_native: "FrCD",
    zero_decimal: !1
  },
  CHF: {
    code: "CHF",
    decimal_digits: 2,
    name: "Swiss Franc",
    name_plural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbol_native: "CHF",
    zero_decimal: !1
  },
  CLF: {
    code: "CLF",
    decimal_digits: 4,
    name: "Chilean Unit of Account (UF)",
    name_plural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbol_native: "CLF",
    zero_decimal: !1
  },
  CLP: {
    code: "CLP",
    decimal_digits: 0,
    name: "Chilean Peso",
    name_plural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbol_native: "$",
    zero_decimal: !0
  },
  CNY: {
    code: "CNY",
    decimal_digits: 2,
    name: "Chinese Yuan",
    name_plural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbol_native: "CN¥",
    zero_decimal: !1
  },
  COP: {
    code: "COP",
    decimal_digits: 0,
    name: "Colombian Peso",
    name_plural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CRC: {
    code: "CRC",
    decimal_digits: 0,
    name: "Costa Rican Colón",
    name_plural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbol_native: "₡",
    zero_decimal: !1
  },
  CUC: {
    code: "CUC",
    decimal_digits: 2,
    name: "Cuban Convertible Peso",
    name_plural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbol_native: "CUC",
    zero_decimal: !1
  },
  CUP: {
    code: "CUP",
    decimal_digits: 2,
    name: "Cuban Peso",
    name_plural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbol_native: "$",
    zero_decimal: !1
  },
  CVE: {
    code: "CVE",
    decimal_digits: 2,
    name: "Cape Verdean Escudo",
    name_plural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbol_native: "CV$",
    zero_decimal: !1
  },
  CZK: {
    code: "CZK",
    decimal_digits: 2,
    name: "Czech Republic Koruna",
    name_plural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbol_native: "Kč",
    zero_decimal: !1
  },
  DJF: {
    code: "DJF",
    decimal_digits: 0,
    name: "Djiboutian Franc",
    name_plural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbol_native: "Fdj",
    zero_decimal: !0
  },
  DKK: {
    code: "DKK",
    decimal_digits: 2,
    name: "Danish Krone",
    name_plural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  DOP: {
    code: "DOP",
    decimal_digits: 2,
    name: "Dominican Peso",
    name_plural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbol_native: "RD$",
    zero_decimal: !1
  },
  DZD: {
    code: "DZD",
    decimal_digits: 2,
    name: "Algerian Dinar",
    name_plural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbol_native: "د.ج.‏",
    zero_decimal: !1
  },
  EEK: {
    code: "EEK",
    decimal_digits: 2,
    name: "Estonian Kroon",
    name_plural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  EGP: {
    code: "EGP",
    decimal_digits: 2,
    name: "Egyptian Pound",
    name_plural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbol_native: "ج.م.‏",
    zero_decimal: !1
  },
  ERN: {
    code: "ERN",
    decimal_digits: 2,
    name: "Eritrean Nakfa",
    name_plural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbol_native: "Nfk",
    zero_decimal: !1
  },
  ETB: {
    code: "ETB",
    decimal_digits: 2,
    name: "Ethiopian Birr",
    name_plural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbol_native: "Br",
    zero_decimal: !1
  },
  EUR: {
    code: "EUR",
    decimal_digits: 2,
    name: "Euro",
    name_plural: "euros",
    rounding: 0,
    symbol: "€",
    symbol_native: "€",
    zero_decimal: !1
  },
  FJD: {
    code: "FJD",
    decimal_digits: 2,
    name: "Fijian Dollar",
    name_plural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbol_native: "$",
    zero_decimal: !1
  },
  FKP: {
    code: "FKP",
    decimal_digits: 2,
    name: "Falkland Islands Pound",
    name_plural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbol_native: "£",
    zero_decimal: !1
  },
  GBP: {
    code: "GBP",
    decimal_digits: 2,
    name: "British Pound Sterling",
    name_plural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbol_native: "£",
    zero_decimal: !1
  },
  GEL: {
    code: "GEL",
    decimal_digits: 2,
    name: "Georgian Lari",
    name_plural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbol_native: "GEL",
    zero_decimal: !1
  },
  GHS: {
    code: "GHS",
    decimal_digits: 2,
    name: "Ghanaian Cedi",
    name_plural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbol_native: "GH₵",
    zero_decimal: !1
  },
  GIP: {
    code: "GIP",
    decimal_digits: 2,
    name: "Gibraltar Pound",
    name_plural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbol_native: "£",
    zero_decimal: !1
  },
  GMD: {
    code: "GMD",
    decimal_digits: 2,
    name: "Gambian Dalasi",
    name_plural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbol_native: "D",
    zero_decimal: !1
  },
  GNF: {
    code: "GNF",
    decimal_digits: 0,
    name: "Guinean Franc",
    name_plural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbol_native: "FG",
    zero_decimal: !0
  },
  GTQ: {
    code: "GTQ",
    decimal_digits: 2,
    name: "Guatemalan Quetzal",
    name_plural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbol_native: "Q",
    zero_decimal: !1
  },
  GYD: {
    code: "GYD",
    decimal_digits: 0,
    name: "Guyanaese Dollar",
    name_plural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbol_native: "$",
    zero_decimal: !1
  },
  HKD: {
    code: "HKD",
    decimal_digits: 2,
    name: "Hong Kong Dollar",
    name_plural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbol_native: "$",
    zero_decimal: !1
  },
  HNL: {
    code: "HNL",
    decimal_digits: 2,
    name: "Honduran Lempira",
    name_plural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbol_native: "L",
    zero_decimal: !1
  },
  HRK: {
    code: "HRK",
    decimal_digits: 2,
    name: "Croatian Kuna",
    name_plural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbol_native: "kn",
    zero_decimal: !1
  },
  HTG: {
    code: "HTG",
    decimal_digits: 2,
    name: "Haitian Gourde",
    name_plural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbol_native: "G",
    zero_decimal: !1
  },
  HUF: {
    code: "HUF",
    decimal_digits: 0,
    name: "Hungarian Forint",
    name_plural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbol_native: "Ft",
    zero_decimal: !1
  },
  IDR: {
    code: "IDR",
    decimal_digits: 0,
    name: "Indonesian Rupiah",
    name_plural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbol_native: "Rp",
    zero_decimal: !1
  },
  ILS: {
    code: "ILS",
    decimal_digits: 2,
    name: "Israeli New Sheqel",
    name_plural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbol_native: "₪",
    zero_decimal: !1
  },
  INR: {
    code: "INR",
    decimal_digits: 2,
    name: "Indian Rupee",
    name_plural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbol_native: "টকা",
    zero_decimal: !1
  },
  IQD: {
    code: "IQD",
    decimal_digits: 0,
    name: "Iraqi Dinar",
    name_plural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbol_native: "د.ع.‏",
    zero_decimal: !1
  },
  IRR: {
    code: "IRR",
    decimal_digits: 0,
    name: "Iranian Rial",
    name_plural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbol_native: "﷼",
    zero_decimal: !0
  },
  ISK: {
    code: "ISK",
    decimal_digits: 0,
    name: "Icelandic Króna",
    name_plural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  JMD: {
    code: "JMD",
    decimal_digits: 2,
    name: "Jamaican Dollar",
    name_plural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbol_native: "$",
    zero_decimal: !1
  },
  JOD: {
    code: "JOD",
    decimal_digits: 3,
    name: "Jordanian Dinar",
    name_plural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbol_native: "د.أ.‏",
    zero_decimal: !1
  },
  JPY: {
    code: "JPY",
    decimal_digits: 0,
    name: "Japanese Yen",
    name_plural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbol_native: "￥",
    zero_decimal: !0
  },
  KES: {
    code: "KES",
    decimal_digits: 2,
    name: "Kenyan Shilling",
    name_plural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbol_native: "Ksh",
    zero_decimal: !1
  },
  KGS: {
    code: "KGS",
    decimal_digits: 2,
    name: "Kyrgystani Som",
    name_plural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbol_native: "сом",
    zero_decimal: !1
  },
  KHR: {
    code: "KHR",
    decimal_digits: 2,
    name: "Cambodian Riel",
    name_plural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbol_native: "៛",
    zero_decimal: !1
  },
  KMF: {
    code: "KMF",
    decimal_digits: 0,
    name: "Comorian Franc",
    name_plural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbol_native: "FC",
    zero_decimal: !0
  },
  KPW: {
    code: "KPW",
    decimal_digits: 0,
    name: "North Korean Won",
    name_plural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbol_native: "KPW",
    zero_decimal: !1
  },
  KRW: {
    code: "KRW",
    decimal_digits: 0,
    name: "South Korean Won",
    name_plural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbol_native: "₩",
    zero_decimal: !0
  },
  KWD: {
    code: "KWD",
    decimal_digits: 3,
    name: "Kuwaiti Dinar",
    name_plural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbol_native: "د.ك.‏",
    zero_decimal: !1
  },
  KYD: {
    code: "KYD",
    decimal_digits: 2,
    name: "Cayman Islands Dollar",
    name_plural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbol_native: "$",
    zero_decimal: !1
  },
  KZT: {
    code: "KZT",
    decimal_digits: 2,
    name: "Kazakhstani Tenge",
    name_plural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbol_native: "тңг.",
    zero_decimal: !1
  },
  LAK: {
    code: "LAK",
    decimal_digits: 0,
    name: "Laotian Kip",
    name_plural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbol_native: "₭",
    zero_decimal: !1
  },
  LBP: {
    code: "LBP",
    decimal_digits: 0,
    name: "Lebanese Pound",
    name_plural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbol_native: "ل.ل.‏",
    zero_decimal: !1
  },
  LKR: {
    code: "LKR",
    decimal_digits: 2,
    name: "Sri Lankan Rupee",
    name_plural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbol_native: "SL Re",
    zero_decimal: !1
  },
  LRD: {
    code: "LRD",
    decimal_digits: 2,
    name: "Liberian Dollar",
    name_plural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbol_native: "$",
    zero_decimal: !1
  },
  LSL: {
    code: "LSL",
    decimal_digits: 2,
    name: "Lesotho Loti",
    name_plural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbol_native: "LSL",
    zero_decimal: !1
  },
  LTL: {
    code: "LTL",
    decimal_digits: 2,
    name: "Lithuanian Litas",
    name_plural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbol_native: "Lt",
    zero_decimal: !1
  },
  LVL: {
    code: "LVL",
    decimal_digits: 2,
    name: "Latvian Lats",
    name_plural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbol_native: "Ls",
    zero_decimal: !1
  },
  LYD: {
    code: "LYD",
    decimal_digits: 3,
    name: "Libyan Dinar",
    name_plural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbol_native: "د.ل.‏",
    zero_decimal: !1
  },
  MAD: {
    code: "MAD",
    decimal_digits: 2,
    name: "Moroccan Dirham",
    name_plural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbol_native: "د.م.‏",
    zero_decimal: !1
  },
  MDL: {
    code: "MDL",
    decimal_digits: 2,
    name: "Moldovan Leu",
    name_plural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbol_native: "MDL",
    zero_decimal: !1
  },
  MGA: {
    code: "MGA",
    decimal_digits: 0,
    name: "Malagasy Ariary",
    name_plural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbol_native: "MGA",
    zero_decimal: !0
  },
  MKD: {
    code: "MKD",
    decimal_digits: 2,
    name: "Macedonian Denar",
    name_plural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbol_native: "MKD",
    zero_decimal: !1
  },
  MMK: {
    code: "MMK",
    decimal_digits: 0,
    name: "Myanma Kyat",
    name_plural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbol_native: "K",
    zero_decimal: !1
  },
  MNT: {
    code: "MNT",
    decimal_digits: 0,
    name: "Mongolian Tugrik",
    name_plural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbol_native: "₮",
    zero_decimal: !1
  },
  MOP: {
    code: "MOP",
    decimal_digits: 2,
    name: "Macanese Pataca",
    name_plural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbol_native: "MOP$",
    zero_decimal: !1
  },
  MRO: {
    code: "MRO",
    decimal_digits: 0,
    name: "Mauritanian Ouguiya",
    name_plural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbol_native: "أ.م.‏",
    zero_decimal: !1
  },
  MUR: {
    code: "MUR",
    decimal_digits: 0,
    name: "Mauritian Rupee",
    name_plural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbol_native: "MURs",
    zero_decimal: !1
  },
  MVR: {
    code: "MVR",
    decimal_digits: 0,
    name: "Maldivian rufiyaa",
    name_plural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbol_native: "Rf",
    zero_decimal: !1
  },
  MWK: {
    code: "MWK",
    decimal_digits: 2,
    name: "Malawian Kwacha",
    name_plural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbol_native: "MK",
    zero_decimal: !1
  },
  MXN: {
    code: "MXN",
    decimal_digits: 2,
    name: "Mexican Peso",
    name_plural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbol_native: "$",
    zero_decimal: !1
  },
  MYR: {
    code: "MYR",
    decimal_digits: 2,
    name: "Malaysian Ringgit",
    name_plural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbol_native: "RM",
    zero_decimal: !1
  },
  MZN: {
    code: "MZN",
    decimal_digits: 2,
    name: "Mozambican Metical",
    name_plural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbol_native: "MTn",
    zero_decimal: !1
  },
  NAD: {
    code: "NAD",
    decimal_digits: 2,
    name: "Namibian Dollar",
    name_plural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbol_native: "N$",
    zero_decimal: !1
  },
  NGN: {
    code: "NGN",
    decimal_digits: 2,
    name: "Nigerian Naira",
    name_plural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbol_native: "₦",
    zero_decimal: !1
  },
  NIO: {
    code: "NIO",
    decimal_digits: 2,
    name: "Nicaraguan Córdoba",
    name_plural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbol_native: "C$",
    zero_decimal: !1
  },
  NOK: {
    code: "NOK",
    decimal_digits: 2,
    name: "Norwegian Krone",
    name_plural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  NPR: {
    code: "NPR",
    decimal_digits: 2,
    name: "Nepalese Rupee",
    name_plural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbol_native: "नेरू",
    zero_decimal: !1
  },
  NZD: {
    code: "NZD",
    decimal_digits: 2,
    name: "New Zealand Dollar",
    name_plural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbol_native: "$",
    zero_decimal: !1
  },
  OMR: {
    code: "OMR",
    decimal_digits: 3,
    name: "Omani Rial",
    name_plural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbol_native: "ر.ع.‏",
    zero_decimal: !1
  },
  PAB: {
    code: "PAB",
    decimal_digits: 2,
    name: "Panamanian Balboa",
    name_plural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbol_native: "B/.",
    zero_decimal: !1
  },
  PEN: {
    code: "PEN",
    decimal_digits: 2,
    name: "Peruvian Nuevo Sol",
    name_plural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbol_native: "S/.",
    zero_decimal: !1
  },
  PGK: {
    code: "PGK",
    decimal_digits: 2,
    name: "Papua New Guinean Kina",
    name_plural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbol_native: "K",
    zero_decimal: !1
  },
  PHP: {
    code: "PHP",
    decimal_digits: 2,
    name: "Philippine Peso",
    name_plural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbol_native: "₱",
    zero_decimal: !1
  },
  PKR: {
    code: "PKR",
    decimal_digits: 0,
    name: "Pakistani Rupee",
    name_plural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbol_native: "₨",
    zero_decimal: !1
  },
  PLN: {
    code: "PLN",
    decimal_digits: 2,
    name: "Polish Zloty",
    name_plural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbol_native: "zł",
    zero_decimal: !1
  },
  PYG: {
    code: "PYG",
    decimal_digits: 0,
    name: "Paraguayan Guarani",
    name_plural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbol_native: "₲",
    zero_decimal: !0
  },
  QAR: {
    code: "QAR",
    decimal_digits: 2,
    name: "Qatari Rial",
    name_plural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbol_native: "ر.ق.‏",
    zero_decimal: !1
  },
  RON: {
    code: "RON",
    decimal_digits: 2,
    name: "Romanian Leu",
    name_plural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbol_native: "RON",
    zero_decimal: !1
  },
  RSD: {
    code: "RSD",
    decimal_digits: 0,
    name: "Serbian Dinar",
    name_plural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbol_native: "дин.",
    zero_decimal: !1
  },
  RUB: {
    code: "RUB",
    decimal_digits: 2,
    name: "Russian Ruble",
    name_plural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbol_native: "₽.",
    zero_decimal: !1
  },
  RWF: {
    code: "RWF",
    decimal_digits: 0,
    name: "Rwandan Franc",
    name_plural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbol_native: "FR",
    zero_decimal: !0
  },
  SAR: {
    code: "SAR",
    decimal_digits: 2,
    name: "Saudi Riyal",
    name_plural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbol_native: "ر.س.‏",
    zero_decimal: !1
  },
  SBD: {
    code: "SBD",
    decimal_digits: 2,
    name: "Solomon Islands Dollar",
    name_plural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbol_native: "$",
    zero_decimal: !1
  },
  SCR: {
    code: "SCR",
    decimal_digits: 2,
    name: "Seychellois Rupee",
    name_plural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbol_native: "SR",
    zero_decimal: !1
  },
  SDG: {
    code: "SDG",
    decimal_digits: 2,
    name: "Sudanese Pound",
    name_plural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbol_native: "SDG",
    zero_decimal: !1
  },
  SEK: {
    code: "SEK",
    decimal_digits: 2,
    name: "Swedish Krona",
    name_plural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  SGD: {
    code: "SGD",
    decimal_digits: 2,
    name: "Singapore Dollar",
    name_plural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbol_native: "$",
    zero_decimal: !1
  },
  SHP: {
    code: "SHP",
    decimal_digits: 2,
    name: "St. Helena Pound",
    name_plural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbol_native: "£",
    zero_decimal: !1
  },
  SLL: {
    code: "SLL",
    decimal_digits: 0,
    name: "Sierra Leonean Leone",
    name_plural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbol_native: "Le",
    zero_decimal: !1
  },
  SOS: {
    code: "SOS",
    decimal_digits: 0,
    name: "Somali Shilling",
    name_plural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbol_native: "Ssh",
    zero_decimal: !1
  },
  SRD: {
    code: "SRD",
    decimal_digits: 2,
    name: "Surinamese Dollar",
    name_plural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbol_native: "$",
    zero_decimal: !1
  },
  STD: {
    code: "STN",
    decimal_digits: 2,
    name: "Dobra",
    name_plural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbol_native: "Db",
    zero_decimal: !1
  },
  SYP: {
    code: "SYP",
    decimal_digits: 0,
    name: "Syrian Pound",
    name_plural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbol_native: "ل.س.‏",
    zero_decimal: !1
  },
  SZL: {
    code: "SZL",
    decimal_digits: 2,
    name: "Swazi Lilangeni",
    name_plural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbol_native: "E",
    zero_decimal: !1
  },
  THB: {
    code: "THB",
    decimal_digits: 2,
    name: "Thai Baht",
    name_plural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbol_native: "฿",
    zero_decimal: !1
  },
  TJS: {
    code: "TJS",
    decimal_digits: 2,
    name: "Tajikistani Somoni",
    name_plural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbol_native: "сом.",
    zero_decimal: !1
  },
  TND: {
    code: "TND",
    decimal_digits: 3,
    name: "Tunisian Dinar",
    name_plural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbol_native: "د.ت.‏",
    zero_decimal: !1
  },
  TOP: {
    code: "TOP",
    decimal_digits: 2,
    name: "Tongan Paʻanga",
    name_plural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbol_native: "T$",
    zero_decimal: !1
  },
  TRY: {
    code: "TRY",
    decimal_digits: 2,
    name: "Turkish Lira",
    name_plural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbol_native: "TL",
    zero_decimal: !1
  },
  TTD: {
    code: "TTD",
    decimal_digits: 2,
    name: "Trinidad and Tobago Dollar",
    name_plural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbol_native: "$",
    zero_decimal: !1
  },
  TWD: {
    code: "TWD",
    decimal_digits: 2,
    name: "New Taiwan Dollar",
    name_plural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbol_native: "NT$",
    zero_decimal: !1
  },
  TZS: {
    code: "TZS",
    decimal_digits: 0,
    name: "Tanzanian Shilling",
    name_plural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbol_native: "TSh",
    zero_decimal: !1
  },
  UAH: {
    code: "UAH",
    decimal_digits: 2,
    name: "Ukrainian Hryvnia",
    name_plural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbol_native: "₴",
    zero_decimal: !1
  },
  UGX: {
    code: "UGX",
    decimal_digits: 0,
    name: "Ugandan Shilling",
    name_plural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbol_native: "USh",
    zero_decimal: !0
  },
  USD: {
    code: "USD",
    decimal_digits: 2,
    name: "US Dollar",
    name_plural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbol_native: "$",
    zero_decimal: !1
  },
  UYU: {
    code: "UYU",
    decimal_digits: 2,
    name: "Uruguayan Peso",
    name_plural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbol_native: "$",
    zero_decimal: !1
  },
  UZS: {
    code: "UZS",
    decimal_digits: 0,
    name: "Uzbekistan Som",
    name_plural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbol_native: "UZS",
    zero_decimal: !1
  },
  VEF: {
    code: "VEF",
    decimal_digits: 2,
    name: "Venezuelan Bolívar",
    name_plural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbol_native: "Bs.F.",
    zero_decimal: !1
  },
  VND: {
    code: "VND",
    decimal_digits: 0,
    name: "Vietnamese Dong",
    name_plural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbol_native: "₫",
    zero_decimal: !0
  },
  VUV: {
    code: "VUV",
    decimal_digits: 0,
    name: "Vanuatu Vatu",
    name_plural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbol_native: "VT",
    zero_decimal: !0
  },
  WST: {
    code: "WST",
    decimal_digits: 2,
    name: "Samoan Tala",
    name_plural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbol_native: "WS$",
    zero_decimal: !1
  },
  XAF: {
    code: "XAF",
    decimal_digits: 0,
    name: "CFA Franc BEAC",
    name_plural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbol_native: "FCFA",
    zero_decimal: !0
  },
  XCD: {
    code: "XCD",
    decimal_digits: 2,
    name: "East Caribbean Dollar",
    name_plural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbol_native: "$",
    zero_decimal: !1
  },
  XOF: {
    code: "XOF",
    decimal_digits: 0,
    name: "CFA Franc BCEAO",
    name_plural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbol_native: "CFA",
    zero_decimal: !0
  },
  XPF: {
    code: "XPF",
    decimal_digits: 0,
    name: "CFP Franc",
    name_plural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbol_native: "FCFP",
    zero_decimal: !0
  },
  YER: {
    code: "YER",
    decimal_digits: 0,
    name: "Yemeni Rial",
    name_plural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbol_native: "ر.ي.‏",
    zero_decimal: !1
  },
  ZAR: {
    code: "ZAR",
    decimal_digits: 2,
    name: "South African Rand",
    name_plural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbol_native: "R",
    zero_decimal: !1
  },
  ZMK: {
    code: "ZMK",
    decimal_digits: 0,
    name: "Zambian Kwacha",
    name_plural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbol_native: "ZK",
    zero_decimal: !0
  },
  ZMW: {
    code: "ZMW",
    decimal_digits: 2,
    name: "Zambian Kwacha",
    name_plural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbol_native: "K",
    zero_decimal: !1
  },
  ZWL: {
    code: "ZWL",
    decimal_digits: 0,
    name: "Zimbabwean Dollar",
    name_plural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbol_native: "ZWL$",
    zero_decimal: !0
  }
};
var _e = /* @__PURE__ */ ((e) => (e.Production = "LIVE", e.Sandbox = "SANDBOX", e.Staging = "STAGING", e.CiCd = "CI-CD", e.Local = "LOCAL", e))(_e || {});
const Oe = 50;
var te = /* @__PURE__ */ ((e) => (e.de_DE = "de-DE", e.en_US = "en-US", e.es_ES = "es-ES", e.fr_FR = "fr-FR", e.it_IT = "it-IT", e.nl_NL = "nl-NL", e.pt_PT = "pt-PT", e))(te || {});
const Kr = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BHD",
  "BGN",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRO",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "STD",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW"
], Ca = Object.fromEntries(
  Kr.map((e) => [
    e,
    Ea[e]
  ])
);
Object.keys(
  Ca
).filter(
  (e) => Ca[e].zero_decimal
).map(
  (e) => Ca[e].code
);
const Oa = Object.fromEntries(
  Kr.filter(
    (e) => Ea[e].decimal_digits !== 3
  ).map((e) => [e, Ea[e]])
), Su = {
  lg: {
    name: "LG",
    styles: {
      height: "900px",
      width: "1192px"
    }
  },
  md: {
    name: "MD",
    styles: {
      height: "900px",
      width: "968px"
    }
  },
  sm: {
    name: "SM",
    styles: {
      height: "900px",
      width: "776px"
    }
  },
  xl: {
    name: "XL",
    styles: {
      height: "900px",
      width: "1600px"
    }
  },
  xs: {
    name: "XS",
    styles: {
      height: "900px",
      width: "576px"
    }
  }
}, Cp = {
  actions: { argTypesRegex: "^on[A-Z].*" },
  controls: {
    expanded: !0,
    matchers: {
      color: /(background|color)$/iu,
      date: /Date$/u
    },
    sort: "alpha"
  },
  layout: "fullscreen",
  viewport: {
    viewports: Su
  }
}, _p = (e) => {
  const a = [
    {
      title: "Local",
      value: _e.Local
    },
    {
      title: "Sandbox",
      value: _e.Sandbox
    },
    {
      title: "Staging",
      value: _e.Staging
    },
    {
      title: "Live",
      value: _e.Production
    }
  ];
  return {
    apiEnvironment: {
      defaultValue: _e.Sandbox,
      name: "API Environment",
      store: "session",
      toolbar: {
        dynamicTitle: !0,
        icon: "cog",
        items: e != null && e.apiEnvironments ? a.filter(
          (n) => {
            var r;
            return (r = e == null ? void 0 : e.apiEnvironments) == null ? void 0 : r.includes(n.title);
          }
        ) : a,
        showName: !0,
        title: "API Environment"
      }
    },
    apiKey: {
      control: {
        type: "text"
      },
      description: "ApiKey Description",
      name: "ApiKey"
    },
    currency: {
      defaultValue: Oa.EUR.code,
      description: "Internationalization currency",
      name: "Currency",
      store: "session",
      toolbar: {
        icon: "credit",
        items: Object.values(Oa).map((n) => ({
          right: `(${n.name})`,
          title: n.code,
          value: n.code
        })),
        showName: !0,
        title: "Currency"
      }
    },
    lang: {
      defaultValue: te.en_US,
      description: "Internationalization Lang",
      name: "Lang",
      store: "session",
      toolbar: {
        icon: "globe",
        items: [
          {
            right: "🇺🇸",
            title: "English",
            value: te.en_US
          },
          {
            right: "🇫🇷",
            title: "Français",
            value: te.fr_FR
          },
          {
            right: "🇩🇪",
            title: "Deutsch",
            value: te.de_DE
          },
          {
            right: "🇪🇸",
            title: "Español",
            value: te.es_ES
          },
          {
            right: "🇮🇹",
            title: "Italiano",
            value: te.it_IT
          },
          {
            right: "🇳🇱",
            title: "Nederlands",
            value: te.nl_NL
          },
          {
            right: "🇵🇹",
            title: "Português",
            value: te.pt_PT
          }
        ],
        showName: !0,
        title: "Lang"
      }
    }
  };
};
var Mu = Object.defineProperty, Du = (e, a, n) => a in e ? Mu(e, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[a] = n, We = (e, a, n) => Du(e, typeof a != "symbol" ? a + "" : a, n), kr = typeof global == "object" && global && global.Object === Object && global, wu = typeof self == "object" && self && self.Object === Object && self, Be = kr || wu || Function("return this")(), Pe = Be.Symbol, Hr = Object.prototype, zu = Hr.hasOwnProperty, Tu = Hr.toString, Ue = Pe ? Pe.toStringTag : void 0;
function Ru(e) {
  var a = zu.call(e, Ue), n = e[Ue];
  try {
    e[Ue] = void 0;
    var r = !0;
  } catch {
  }
  var t = Tu.call(e);
  return r && (a ? e[Ue] = n : delete e[Ue]), t;
}
var Pu = Object.prototype, Eu = Pu.toString;
function Ou(e) {
  return Eu.call(e);
}
var Bu = "[object Null]", Lu = "[object Undefined]", Kn = Pe ? Pe.toStringTag : void 0;
function xe(e) {
  return e == null ? e === void 0 ? Lu : Bu : Kn && Kn in Object(e) ? Ru(e) : Ou(e);
}
function Le(e) {
  return e != null && typeof e == "object";
}
var Nu = "[object Symbol]";
function Qa(e) {
  return typeof e == "symbol" || Le(e) && xe(e) == Nu;
}
function Yr(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length, t = Array(r); ++n < r; )
    t[n] = a(e[n], n, e);
  return t;
}
var ve = Array.isArray, kn = Pe ? Pe.prototype : void 0, Hn = kn ? kn.toString : void 0;
function xr(e) {
  if (typeof e == "string")
    return e;
  if (ve(e))
    return Yr(e, xr) + "";
  if (Qa(e))
    return Hn ? Hn.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function Te(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function jr(e) {
  return e;
}
var Gu = "[object AsyncFunction]", Fu = "[object Function]", Uu = "[object GeneratorFunction]", $u = "[object Proxy]";
function en(e) {
  if (!Te(e))
    return !1;
  var a = xe(e);
  return a == Fu || a == Uu || a == Gu || a == $u;
}
var _a = Be["__core-js_shared__"], Yn = function() {
  var e = /[^.]+$/.exec(_a && _a.keys && _a.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Iu(e) {
  return !!Yn && Yn in e;
}
var Ku = Function.prototype, ku = Ku.toString;
function Hu(e) {
  if (e != null) {
    try {
      return ku.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Yu = /[\\^$.*+?()[\]{}|]/g, xu = /^\[object .+?Constructor\]$/, ju = Function.prototype, Vu = Object.prototype, Zu = ju.toString, Wu = Vu.hasOwnProperty, Ju = RegExp(
  "^" + Zu.call(Wu).replace(Yu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function qu(e) {
  if (!Te(e) || Iu(e))
    return !1;
  var a = en(e) ? Ju : xu;
  return a.test(Hu(e));
}
function Xu(e, a) {
  return e == null ? void 0 : e[a];
}
function an(e, a) {
  var n = Xu(e, a);
  return qu(n) ? n : void 0;
}
var xn = Object.create, Qu = /* @__PURE__ */ function() {
  function e() {
  }
  return function(a) {
    if (!Te(a))
      return {};
    if (xn)
      return xn(a);
    e.prototype = a;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function ec(e, a, n) {
  switch (n.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, n[0]);
    case 2:
      return e.call(a, n[0], n[1]);
    case 3:
      return e.call(a, n[0], n[1], n[2]);
  }
  return e.apply(a, n);
}
function ac(e, a) {
  var n = -1, r = e.length;
  for (a || (a = Array(r)); ++n < r; )
    a[n] = e[n];
  return a;
}
var nc = 800, rc = 16, tc = Date.now;
function ic(e) {
  var a = 0, n = 0;
  return function() {
    var r = tc(), t = rc - (r - n);
    if (n = r, t > 0) {
      if (++a >= nc)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function oc(e) {
  return function() {
    return e;
  };
}
var Xe = function() {
  try {
    var e = an(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), sc = Xe ? function(e, a) {
  return Xe(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: oc(a),
    writable: !0
  });
} : jr, lc = ic(sc), uc = 9007199254740991, cc = /^(?:0|[1-9]\d*)$/;
function Vr(e, a) {
  var n = typeof e;
  return a = a ?? uc, !!a && (n == "number" || n != "symbol" && cc.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function nn(e, a, n) {
  a == "__proto__" && Xe ? Xe(e, a, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[a] = n;
}
function ta(e, a) {
  return e === a || e !== e && a !== a;
}
var dc = Object.prototype, gc = dc.hasOwnProperty;
function mc(e, a, n) {
  var r = e[a];
  (!(gc.call(e, a) && ta(r, n)) || n === void 0 && !(a in e)) && nn(e, a, n);
}
function pc(e, a, n, r) {
  var t = !n;
  n || (n = {});
  for (var s = -1, o = a.length; ++s < o; ) {
    var l = a[s], c = void 0;
    c === void 0 && (c = e[l]), t ? nn(n, l, c) : mc(n, l, c);
  }
  return n;
}
var jn = Math.max;
function hc(e, a, n) {
  return a = jn(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var r = arguments, t = -1, s = jn(r.length - a, 0), o = Array(s); ++t < s; )
      o[t] = r[a + t];
    t = -1;
    for (var l = Array(a + 1); ++t < a; )
      l[t] = r[t];
    return l[a] = n(o), ec(e, this, l);
  };
}
function fc(e, a) {
  return lc(hc(e, a, jr), e + "");
}
var yc = 9007199254740991;
function Zr(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yc;
}
function Ne(e) {
  return e != null && Zr(e.length) && !en(e);
}
function bc(e, a, n) {
  if (!Te(n))
    return !1;
  var r = typeof a;
  return (r == "number" ? Ne(n) && Vr(a, n.length) : r == "string" && a in n) ? ta(n[a], e) : !1;
}
function Cc(e) {
  return fc(function(a, n) {
    var r = -1, t = n.length, s = t > 1 ? n[t - 1] : void 0, o = t > 2 ? n[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (t--, s) : void 0, o && bc(n[0], n[1], o) && (s = t < 3 ? void 0 : s, t = 1), a = Object(a); ++r < t; ) {
      var l = n[r];
      l && e(a, l, r, s);
    }
    return a;
  });
}
var _c = Object.prototype;
function rn(e) {
  var a = e && e.constructor, n = typeof a == "function" && a.prototype || _c;
  return e === n;
}
function Ac(e, a) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = a(n);
  return r;
}
var vc = "[object Arguments]";
function Vn(e) {
  return Le(e) && xe(e) == vc;
}
var Wr = Object.prototype, Sc = Wr.hasOwnProperty, Mc = Wr.propertyIsEnumerable, Ba = Vn(/* @__PURE__ */ function() {
  return arguments;
}()) ? Vn : function(e) {
  return Le(e) && Sc.call(e, "callee") && !Mc.call(e, "callee");
};
function Dc() {
  return !1;
}
var Jr = typeof exports == "object" && exports && !exports.nodeType && exports, Zn = Jr && typeof module == "object" && module && !module.nodeType && module, wc = Zn && Zn.exports === Jr, Wn = wc ? Be.Buffer : void 0, zc = Wn ? Wn.isBuffer : void 0, qr = zc || Dc, Tc = "[object Arguments]", Rc = "[object Array]", Pc = "[object Boolean]", Ec = "[object Date]", Oc = "[object Error]", Bc = "[object Function]", Lc = "[object Map]", Nc = "[object Number]", Gc = "[object Object]", Fc = "[object RegExp]", Uc = "[object Set]", $c = "[object String]", Ic = "[object WeakMap]", Kc = "[object ArrayBuffer]", kc = "[object DataView]", Hc = "[object Float32Array]", Yc = "[object Float64Array]", xc = "[object Int8Array]", jc = "[object Int16Array]", Vc = "[object Int32Array]", Zc = "[object Uint8Array]", Wc = "[object Uint8ClampedArray]", Jc = "[object Uint16Array]", qc = "[object Uint32Array]", H = {};
H[Hc] = H[Yc] = H[xc] = H[jc] = H[Vc] = H[Zc] = H[Wc] = H[Jc] = H[qc] = !0;
H[Tc] = H[Rc] = H[Kc] = H[Pc] = H[kc] = H[Ec] = H[Oc] = H[Bc] = H[Lc] = H[Nc] = H[Gc] = H[Fc] = H[Uc] = H[$c] = H[Ic] = !1;
function Xc(e) {
  return Le(e) && Zr(e.length) && !!H[xe(e)];
}
function Qc(e) {
  return function(a) {
    return e(a);
  };
}
var Xr = typeof exports == "object" && exports && !exports.nodeType && exports, Ke = Xr && typeof module == "object" && module && !module.nodeType && module, ed = Ke && Ke.exports === Xr, Aa = ed && kr.process, Jn = function() {
  try {
    var e = Ke && Ke.require && Ke.require("util").types;
    return e || Aa && Aa.binding && Aa.binding("util");
  } catch {
  }
}(), qn = Jn && Jn.isTypedArray, Qr = qn ? Qc(qn) : Xc, ad = Object.prototype, nd = ad.hasOwnProperty;
function et(e, a) {
  var n = ve(e), r = !n && Ba(e), t = !n && !r && qr(e), s = !n && !r && !t && Qr(e), o = n || r || t || s, l = o ? Ac(e.length, String) : [], c = l.length;
  for (var p in e)
    (a || nd.call(e, p)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    t && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    Vr(p, c))) && l.push(p);
  return l;
}
function at(e, a) {
  return function(n) {
    return e(a(n));
  };
}
var rd = at(Object.keys, Object), td = Object.prototype, id = td.hasOwnProperty;
function od(e) {
  if (!rn(e))
    return rd(e);
  var a = [];
  for (var n in Object(e))
    id.call(e, n) && n != "constructor" && a.push(n);
  return a;
}
function sd(e) {
  return Ne(e) ? et(e) : od(e);
}
function ld(e) {
  var a = [];
  if (e != null)
    for (var n in Object(e))
      a.push(n);
  return a;
}
var ud = Object.prototype, cd = ud.hasOwnProperty;
function dd(e) {
  if (!Te(e))
    return ld(e);
  var a = rn(e), n = [];
  for (var r in e)
    r == "constructor" && (a || !cd.call(e, r)) || n.push(r);
  return n;
}
function nt(e) {
  return Ne(e) ? et(e, !0) : dd(e);
}
var gd = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, md = /^\w*$/;
function rt(e, a) {
  if (ve(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Qa(e) ? !0 : md.test(e) || !gd.test(e) || a != null && e in Object(a);
}
var Ye = an(Object, "create");
function pd() {
  this.__data__ = Ye ? Ye(null) : {}, this.size = 0;
}
function hd(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var fd = "__lodash_hash_undefined__", yd = Object.prototype, bd = yd.hasOwnProperty;
function Cd(e) {
  var a = this.__data__;
  if (Ye) {
    var n = a[e];
    return n === fd ? void 0 : n;
  }
  return bd.call(a, e) ? a[e] : void 0;
}
var _d = Object.prototype, Ad = _d.hasOwnProperty;
function vd(e) {
  var a = this.__data__;
  return Ye ? a[e] !== void 0 : Ad.call(a, e);
}
var Sd = "__lodash_hash_undefined__";
function Md(e, a) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ye && a === void 0 ? Sd : a, this;
}
function Se(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
Se.prototype.clear = pd;
Se.prototype.delete = hd;
Se.prototype.get = Cd;
Se.prototype.has = vd;
Se.prototype.set = Md;
function Dd() {
  this.__data__ = [], this.size = 0;
}
function ia(e, a) {
  for (var n = e.length; n--; )
    if (ta(e[n][0], a))
      return n;
  return -1;
}
var wd = Array.prototype, zd = wd.splice;
function Td(e) {
  var a = this.__data__, n = ia(a, e);
  if (n < 0)
    return !1;
  var r = a.length - 1;
  return n == r ? a.pop() : zd.call(a, n, 1), --this.size, !0;
}
function Rd(e) {
  var a = this.__data__, n = ia(a, e);
  return n < 0 ? void 0 : a[n][1];
}
function Pd(e) {
  return ia(this.__data__, e) > -1;
}
function Ed(e, a) {
  var n = this.__data__, r = ia(n, e);
  return r < 0 ? (++this.size, n.push([e, a])) : n[r][1] = a, this;
}
function me(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
me.prototype.clear = Dd;
me.prototype.delete = Td;
me.prototype.get = Rd;
me.prototype.has = Pd;
me.prototype.set = Ed;
var tt = an(Be, "Map");
function Od() {
  this.size = 0, this.__data__ = {
    hash: new Se(),
    map: new (tt || me)(),
    string: new Se()
  };
}
function Bd(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function oa(e, a) {
  var n = e.__data__;
  return Bd(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
}
function Ld(e) {
  var a = oa(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function Nd(e) {
  return oa(this, e).get(e);
}
function Gd(e) {
  return oa(this, e).has(e);
}
function Fd(e, a) {
  var n = oa(this, e), r = n.size;
  return n.set(e, a), this.size += n.size == r ? 0 : 1, this;
}
function be(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
be.prototype.clear = Od;
be.prototype.delete = Ld;
be.prototype.get = Nd;
be.prototype.has = Gd;
be.prototype.set = Fd;
var Ud = "Expected a function";
function tn(e, a) {
  if (typeof e != "function" || a != null && typeof a != "function")
    throw new TypeError(Ud);
  var n = function() {
    var r = arguments, t = a ? a.apply(this, r) : r[0], s = n.cache;
    if (s.has(t))
      return s.get(t);
    var o = e.apply(this, r);
    return n.cache = s.set(t, o) || s, o;
  };
  return n.cache = new (tn.Cache || be)(), n;
}
tn.Cache = be;
var $d = 500;
function Id(e) {
  var a = tn(e, function(r) {
    return n.size === $d && n.clear(), r;
  }), n = a.cache;
  return a;
}
var Kd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, kd = /\\(\\)?/g, Hd = Id(function(e) {
  var a = [];
  return e.charCodeAt(0) === 46 && a.push(""), e.replace(Kd, function(n, r, t, s) {
    a.push(t ? s.replace(kd, "$1") : r || n);
  }), a;
});
function Yd(e) {
  return e == null ? "" : xr(e);
}
function xd(e, a) {
  return ve(e) ? e : rt(e, a) ? [e] : Hd(Yd(e));
}
function it(e) {
  if (typeof e == "string" || Qa(e))
    return e;
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function jd(e, a) {
  a = xd(a, e);
  for (var n = 0, r = a.length; e != null && n < r; )
    e = e[it(a[n++])];
  return n && n == r ? e : void 0;
}
var ot = at(Object.getPrototypeOf, Object), Vd = "[object Object]", Zd = Function.prototype, Wd = Object.prototype, st = Zd.toString, Jd = Wd.hasOwnProperty, qd = st.call(Object);
function Xd(e) {
  if (!Le(e) || xe(e) != Vd)
    return !1;
  var a = ot(e);
  if (a === null)
    return !0;
  var n = Jd.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && st.call(n) == qd;
}
function Qd() {
  this.__data__ = new me(), this.size = 0;
}
function eg(e) {
  var a = this.__data__, n = a.delete(e);
  return this.size = a.size, n;
}
function ag(e) {
  return this.__data__.get(e);
}
function ng(e) {
  return this.__data__.has(e);
}
var rg = 200;
function tg(e, a) {
  var n = this.__data__;
  if (n instanceof me) {
    var r = n.__data__;
    if (!tt || r.length < rg - 1)
      return r.push([e, a]), this.size = ++n.size, this;
    n = this.__data__ = new be(r);
  }
  return n.set(e, a), this.size = n.size, this;
}
function Ge(e) {
  var a = this.__data__ = new me(e);
  this.size = a.size;
}
Ge.prototype.clear = Qd;
Ge.prototype.delete = eg;
Ge.prototype.get = ag;
Ge.prototype.has = ng;
Ge.prototype.set = tg;
var lt = typeof exports == "object" && exports && !exports.nodeType && exports, Xn = lt && typeof module == "object" && module && !module.nodeType && module, ig = Xn && Xn.exports === lt, Qn = ig ? Be.Buffer : void 0;
Qn && Qn.allocUnsafe;
function og(e, a) {
  return e.slice();
}
var er = Be.Uint8Array;
function sg(e) {
  var a = new e.constructor(e.byteLength);
  return new er(a).set(new er(e)), a;
}
function lg(e, a) {
  var n = sg(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
function ug(e) {
  return typeof e.constructor == "function" && !rn(e) ? Qu(ot(e)) : {};
}
function cg(e) {
  return function(a) {
    return a == null ? void 0 : a[e];
  };
}
function dg(e) {
  return function(a) {
    return jd(a, e);
  };
}
function gg(e) {
  return rt(e) ? cg(it(e)) : dg(e);
}
function mg(e) {
  return gg(e);
}
function pg(e) {
  return function(a, n, r) {
    for (var t = -1, s = Object(a), o = r(a), l = o.length; l--; ) {
      var c = o[++t];
      if (n(s[c], c, s) === !1)
        break;
    }
    return a;
  };
}
var ut = pg();
function hg(e, a) {
  return e && ut(e, a, sd);
}
function fg(e, a) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Ne(n))
      return e(n, r);
    for (var t = n.length, s = -1, o = Object(n); ++s < t && r(o[s], s, o) !== !1; )
      ;
    return n;
  };
}
var yg = fg(hg);
function La(e, a, n) {
  (n !== void 0 && !ta(e[a], n) || n === void 0 && !(a in e)) && nn(e, a, n);
}
function bg(e) {
  return Le(e) && Ne(e);
}
function Na(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function Cg(e) {
  return pc(e, nt(e));
}
function _g(e, a, n, r, t, s, o) {
  var l = Na(e, n), c = Na(a, n), p = o.get(c);
  if (p) {
    La(e, n, p);
    return;
  }
  var f = s ? s(l, c, n + "", e, a, o) : void 0, v = f === void 0;
  if (v) {
    var b = ve(c), A = !b && qr(c), C = !b && !A && Qr(c);
    f = c, b || A || C ? ve(l) ? f = l : bg(l) ? f = ac(l) : A ? (v = !1, f = og(c)) : C ? (v = !1, f = lg(c)) : f = [] : Xd(c) || Ba(c) ? (f = l, Ba(l) ? f = Cg(l) : (!Te(l) || en(l)) && (f = ug(c))) : v = !1;
  }
  v && (o.set(c, f), t(f, c, r, s, o), o.delete(c)), La(e, n, f);
}
function ct(e, a, n, r, t) {
  e !== a && ut(a, function(s, o) {
    if (t || (t = new Ge()), Te(s))
      _g(e, a, o, n, ct, r, t);
    else {
      var l = r ? r(Na(e, o), s, o + "", e, a, t) : void 0;
      l === void 0 && (l = s), La(e, o, l);
    }
  }, nt);
}
function Ag(e, a) {
  var n = -1, r = Ne(e) ? Array(e.length) : [];
  return yg(e, function(t, s, o) {
    r[++n] = a(t, s, o);
  }), r;
}
function vg(e, a) {
  var n = ve(e) ? Yr : Ag;
  return n(e, mg(a));
}
Cc(function(e, a, n) {
  ct(e, a, n);
});
const Sg = {
  Dr: "dr",
  Mr: "mr",
  Mrs: "mrs",
  Ms: "ms",
  NotSpecified: "notSpecified",
  Prof: "prof"
}, Mg = {
  NotIncluded: "NOT_INCLUDED"
}, Qe = {
  Coupon: "COUPON",
  CreditCard: "CREDIT_CARD",
  DepositAccount: "DEPOSIT_ACCOUNT"
}, sa = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, Dg = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), wg = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), zg = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), Tg = /[^\p{L}\d]+/giu, ar = "$1\0$2", nr = "";
function dt(e) {
  let a = e.trim();
  a = a.replace(Dg, ar).replace(wg, ar), a = a.replace(Tg, "\0");
  let n = 0, r = a.length;
  for (; a.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; a.charAt(r - 1) === "\0"; )
    r--;
  return a.slice(n, r).split(/\0/g);
}
function Rg(e) {
  const a = dt(e);
  for (let n = 0; n < a.length; n++) {
    const r = a[n], t = zg.exec(r);
    if (t) {
      const s = t.index + (t[1] ?? t[2]).length;
      a.splice(n, 1, r.slice(0, s), r.slice(s));
    }
  }
  return a;
}
function gt(e, a) {
  const [n, r, t] = ua(e, a);
  return n + r.map(la(a == null ? void 0 : a.locale)).join((a == null ? void 0 : a.delimiter) ?? " ") + t;
}
function Pg(e, a) {
  const [n, r, t] = ua(e, a), s = la(a == null ? void 0 : a.locale), o = on(a == null ? void 0 : a.locale), l = a != null && a.mergeAmbiguousCharacters ? sn(s, o) : pt(s, o);
  return n + r.map((c, p) => p === 0 ? s(c) : l(c, p)).join((a == null ? void 0 : a.delimiter) ?? "") + t;
}
function Eg(e, a) {
  const [n, r, t] = ua(e, a), s = la(a == null ? void 0 : a.locale), o = on(a == null ? void 0 : a.locale), l = a != null && a.mergeAmbiguousCharacters ? sn(s, o) : pt(s, o);
  return n + r.map(l).join((a == null ? void 0 : a.delimiter) ?? "") + t;
}
function Og(e, a) {
  const [n, r, t] = ua(e, a), s = la(a == null ? void 0 : a.locale), o = on(a == null ? void 0 : a.locale);
  return n + r.map(sn(s, o)).join((a == null ? void 0 : a.delimiter) ?? " ") + t;
}
function mt(e, a) {
  return gt(e, { delimiter: "-", ...a });
}
function Bg(e, a) {
  return gt(e, { delimiter: "_", ...a });
}
function la(e) {
  return e === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e);
}
function on(e) {
  return e === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e);
}
function sn(e, a) {
  return (n) => `${a(n[0])}${e(n.slice(1))}`;
}
function pt(e, a) {
  return (n, r) => {
    const t = n[0];
    return (r > 0 && t >= "0" && t <= "9" ? "_" + t : a(t)) + e(n.slice(1));
  };
}
function ua(e, a = {}) {
  const n = a.split ?? (a.separateNumbers ? Rg : dt), r = a.prefixCharacters ?? nr, t = a.suffixCharacters ?? nr;
  let s = 0, o = e.length;
  for (; s < e.length; ) {
    const l = e.charAt(s);
    if (!r.includes(l))
      break;
    s++;
  }
  for (; o > s; ) {
    const l = o - 1, c = e.charAt(l);
    if (!t.includes(c))
      break;
    o = l;
  }
  return [
    e.slice(0, s),
    n(e.slice(s, o)),
    e.slice(o)
  ];
}
var V = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ht = { exports: {} };
(function(e, a) {
  (function(n, r, t) {
    e.exports = t(), e.exports.default = t();
  })("slugify", V, function() {
    var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), r = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
    function t(s, o) {
      if (typeof s != "string")
        throw new Error("slugify: string argument expected");
      o = typeof o == "string" ? { replacement: o } : o || {};
      var l = r[o.locale] || {}, c = o.replacement === void 0 ? "-" : o.replacement, p = o.trim === void 0 ? !0 : o.trim, f = s.normalize().split("").reduce(function(v, b) {
        var A = l[b];
        return A === void 0 && (A = n[b]), A === void 0 && (A = b), A === c && (A = " "), v + A.replace(o.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
      }, "");
      return o.strict && (f = f.replace(/[^A-Za-z0-9\s]/g, "")), p && (f = f.trim()), f = f.replace(/\s+/g, c), o.lower && (f = f.toLowerCase()), f;
    }
    return t.extend = function(s) {
      Object.assign(n, s);
    }, t;
  });
})(ht);
var Lg = ht.exports;
const Ng = /* @__PURE__ */ ae(Lg);
function Gg(e) {
  return Ng(mt(e), {
    lower: !0,
    strict: !0
  });
}
var ft = /* @__PURE__ */ ((e) => (e.Camel = "camelCase", e.Capital = "capitalCase", e.Param = "paramCase", e.Pascal = "pascalCase", e.Slug = "slugCase", e.Snake = "snakeCase", e))(ft || {});
const Fg = {
  camelCase: Pg,
  capitalCase: Og,
  paramCase: mt,
  pascalCase: Eg,
  slugCase: Gg,
  snakeCase: Bg
};
function Ug(e, a) {
  return e.some(
    (n) => typeof n == "string" ? n === a : n.test(a)
  );
}
function $g(e) {
  return e === Object(e) && !Array.isArray(e) && typeof e != "function";
}
function Ga(e, a, n = { deep: !0 }) {
  return $g(e) ? Object.keys(e).reduce((r, t) => {
    const s = n != null && n.exclude && Ug(n.exclude, t) ? t : Fg[a](t);
    return r[s] = n.deep ? Ga(e[t], a, n) : e[t], r;
  }, {}) : Array.isArray(e) ? e.map((r) => Ga(r, a, n)) : e;
}
const Ig = {
  AD: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "376",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png",
    iso2: "AD",
    name: "Andorra",
    priority: 0,
    timezone: "Europe/Andorra"
  },
  AE: {
    areaCodes: null,
    currency: "AED",
    dialCode: "971",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png",
    iso2: "AE",
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    priority: 0,
    timezone: "Asia/Dubai"
  },
  AF: {
    areaCodes: null,
    currency: "AFN",
    dialCode: "93",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png",
    iso2: "AF",
    name: "Afghanistan (‫افغانستان‬‎)",
    priority: 0,
    timezone: "Asia/Kabul"
  },
  AG: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png",
    iso2: "AG",
    name: "Antigua and Barbuda",
    priority: 0,
    timezone: "America/Antigua"
  },
  AI: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png",
    iso2: "AI",
    name: "Anguilla",
    priority: 0,
    timezone: "America/Anguilla"
  },
  AL: {
    areaCodes: null,
    currency: "ALL",
    dialCode: "355",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png",
    iso2: "AL",
    name: "Albania (Shqipëri)",
    priority: 0,
    timezone: "Europe/Tirane"
  },
  AM: {
    areaCodes: null,
    currency: "AMD",
    dialCode: "374",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png",
    iso2: "AM",
    name: "Armenia (Հայաստան)",
    priority: 0,
    timezone: "Asia/Yerevan"
  },
  AO: {
    areaCodes: null,
    currency: "AOA",
    dialCode: "244",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png",
    iso2: "AO",
    name: "Angola",
    priority: 0,
    timezone: "Africa/Luanda"
  },
  AR: {
    areaCodes: null,
    currency: "ARS",
    dialCode: "54",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png",
    iso2: "AR",
    name: "Argentina",
    priority: 0,
    timezone: "America/Argentina/Cordoba"
  },
  AS: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1684",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png",
    iso2: "AS",
    name: "American Samoa",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  AT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "43",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png",
    iso2: "AT",
    name: "Austria (Österreich)",
    priority: 0,
    timezone: "Europe/Vienna"
  },
  AU: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png",
    iso2: "AU",
    name: "Australia",
    priority: 0,
    timezone: "Australia/Darwin"
  },
  AW: {
    areaCodes: null,
    currency: "AWG",
    dialCode: "297",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png",
    iso2: "AW",
    name: "Aruba",
    priority: 0,
    timezone: "America/Aruba"
  },
  AX: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png",
    iso2: "AX",
    name: "Åland Islands",
    priority: 1,
    timezone: "Europe/Helsinki"
  },
  AZ: {
    areaCodes: null,
    currency: "AZN",
    dialCode: "994",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png",
    iso2: "AZ",
    name: "Azerbaijan (Azərbaycan)",
    priority: 0,
    timezone: "Asia/Baku"
  },
  BA: {
    areaCodes: null,
    currency: "BAM",
    dialCode: "387",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png",
    iso2: "BA",
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    priority: 0,
    timezone: "Europe/Sarajevo"
  },
  BB: {
    areaCodes: null,
    currency: "BBD",
    dialCode: "1246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png",
    iso2: "BB",
    name: "Barbados",
    priority: 0,
    timezone: "America/Barbados"
  },
  BD: {
    areaCodes: null,
    currency: "BDT",
    dialCode: "880",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png",
    iso2: "BD",
    name: "Bangladesh (বাংলাদেশ)",
    priority: 0,
    timezone: "Asia/Dhaka"
  },
  BE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "32",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png",
    iso2: "BE",
    name: "Belgium (België)",
    priority: 0,
    timezone: "Europe/Brussels"
  },
  BF: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "226",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png",
    iso2: "BF",
    name: "Burkina Faso",
    priority: 0,
    timezone: "Africa/Ouagadougou"
  },
  BG: {
    areaCodes: null,
    currency: "BGN",
    dialCode: "359",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png",
    iso2: "BG",
    name: "Bulgaria (България)",
    priority: 0,
    timezone: "Europe/Sofia"
  },
  BH: {
    areaCodes: null,
    currency: "BHD",
    dialCode: "973",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png",
    iso2: "BH",
    name: "Bahrain (‫البحرين‬‎)",
    priority: 0,
    timezone: "Asia/Bahrain"
  },
  BI: {
    areaCodes: null,
    currency: "BIF",
    dialCode: "257",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png",
    iso2: "BI",
    name: "Burundi (Uburundi)",
    priority: 0,
    timezone: "Africa/Bujumbura"
  },
  BJ: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "229",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png",
    iso2: "BJ",
    name: "Benin (Bénin)",
    priority: 0,
    timezone: "Africa/Porto-Novo"
  },
  BL: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png",
    iso2: "BL",
    name: "Saint Barthélemy",
    priority: 1,
    timezone: "America/St_Barthelemy"
  },
  BM: {
    areaCodes: null,
    currency: "BMD",
    dialCode: "1441",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png",
    iso2: "BM",
    name: "Bermuda",
    priority: 0,
    timezone: "Atlantic/Bermuda"
  },
  BN: {
    areaCodes: null,
    currency: "BND",
    dialCode: "673",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png",
    iso2: "BN",
    name: "Brunei",
    priority: 0,
    timezone: "Asia/Brunei"
  },
  BO: {
    areaCodes: null,
    currency: "BOB",
    dialCode: "591",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png",
    iso2: "BO",
    name: "Bolivia",
    priority: 0,
    timezone: "America/La_Paz"
  },
  BQ: {
    areaCodes: null,
    currency: "USD",
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png",
    iso2: "BQ",
    name: "Caribbean Netherlands",
    priority: 1,
    timezone: "America/Kralendijk"
  },
  BR: {
    areaCodes: null,
    currency: "BRL",
    dialCode: "55",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png",
    iso2: "BR",
    name: "Brazil (Brasil)",
    priority: 0,
    timezone: "America/Cuiaba"
  },
  BS: {
    areaCodes: null,
    currency: "BSD",
    dialCode: "1242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png",
    iso2: "BS",
    name: "Bahamas",
    priority: 0,
    timezone: "America/Nassau"
  },
  BT: {
    areaCodes: null,
    currency: "BTN",
    dialCode: "975",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png",
    iso2: "BT",
    name: "Bhutan (འབྲུག)",
    priority: 0,
    timezone: "Asia/Thimphu"
  },
  BW: {
    areaCodes: null,
    currency: "BWP",
    dialCode: "267",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png",
    iso2: "BW",
    name: "Botswana",
    priority: 0,
    timezone: "Africa/Gaborone"
  },
  BY: {
    areaCodes: null,
    currency: "BYR",
    dialCode: "375",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png",
    iso2: "BY",
    name: "Belarus (Беларусь)",
    priority: 0,
    timezone: "Europe/Minsk"
  },
  BZ: {
    areaCodes: null,
    currency: "BZD",
    dialCode: "501",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png",
    iso2: "BZ",
    name: "Belize",
    priority: 0,
    timezone: "America/Belize"
  },
  CA: {
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ],
    currency: "CAD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png",
    iso2: "CA",
    name: "Canada",
    priority: 1,
    timezone: "America/Rankin_Inlet"
  },
  CC: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png",
    iso2: "CC",
    name: "Cocos (Keeling) Islands",
    priority: 1,
    timezone: "Indian/Cocos"
  },
  CD: {
    areaCodes: null,
    currency: "CDF",
    dialCode: "243",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png",
    iso2: "CD",
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    priority: 0,
    timezone: "Africa/Lubumbashi"
  },
  CF: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "236",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png",
    iso2: "CF",
    name: "Central African Republic (République centrafricaine)",
    priority: 0,
    timezone: "Africa/Bangui"
  },
  CG: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png",
    iso2: "CG",
    name: "Congo (Republic) (Congo-Brazzaville)",
    priority: 0,
    timezone: "Africa/Brazzaville"
  },
  CH: {
    areaCodes: null,
    currency: "CHF",
    dialCode: "41",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png",
    iso2: "CH",
    name: "Switzerland (Schweiz)",
    priority: 0,
    timezone: "Europe/Zurich"
  },
  CI: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "225",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png",
    iso2: "CI",
    name: "Côte d’Ivoire",
    priority: 0,
    timezone: "Africa/Abidjan"
  },
  CK: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "682",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png",
    iso2: "CK",
    name: "Cook Islands",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  CL: {
    areaCodes: null,
    currency: "CLP",
    dialCode: "56",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png",
    iso2: "CL",
    name: "Chile",
    priority: 0,
    timezone: "America/Santiago"
  },
  CM: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "237",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png",
    iso2: "CM",
    name: "Cameroon (Cameroun)",
    priority: 0,
    timezone: "Africa/Douala"
  },
  CN: {
    areaCodes: null,
    currency: "CNY",
    dialCode: "86",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png",
    iso2: "CN",
    name: "China (中国)",
    priority: 0,
    timezone: "Asia/Shanghai"
  },
  CO: {
    areaCodes: null,
    currency: "COP",
    dialCode: "57",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png",
    iso2: "CO",
    name: "Colombia",
    priority: 0,
    timezone: "America/Bogota"
  },
  CR: {
    areaCodes: null,
    currency: "CRC",
    dialCode: "506",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png",
    iso2: "CR",
    name: "Costa Rica",
    priority: 0,
    timezone: "America/Costa_Rica"
  },
  CU: {
    areaCodes: null,
    currency: "CUP",
    dialCode: "53",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png",
    iso2: "CU",
    name: "Cuba",
    priority: 0,
    timezone: "America/Havana"
  },
  CV: {
    areaCodes: null,
    currency: "CVE",
    dialCode: "238",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png",
    iso2: "CV",
    name: "Cape Verde (Kabu Verdi)",
    priority: 0,
    timezone: "Atlantic/Cape_Verde"
  },
  CW: {
    areaCodes: null,
    currency: "ANG",
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png",
    iso2: "CW",
    name: "Curaçao",
    priority: 0,
    timezone: "America/Curacao"
  },
  CX: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png",
    iso2: "CX",
    name: "Christmas Island",
    priority: 2,
    timezone: "Indian/Christmas"
  },
  CY: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "357",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png",
    iso2: "CY",
    name: "Cyprus (Κύπρος)",
    priority: 0,
    timezone: "Asia/Nicosia"
  },
  CZ: {
    areaCodes: null,
    currency: "CZK",
    dialCode: "420",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png",
    iso2: "CZ",
    name: "Czech Republic (Česká republika)",
    priority: 0,
    timezone: "Europe/Prague"
  },
  DE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "49",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png",
    iso2: "DE",
    name: "Germany (Deutschland)",
    priority: 0,
    timezone: "Europe/Berlin"
  },
  DJ: {
    areaCodes: null,
    currency: "DJF",
    dialCode: "253",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png",
    iso2: "DJ",
    name: "Djibouti",
    priority: 0,
    timezone: "Africa/Djibouti"
  },
  DK: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "45",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png",
    iso2: "DK",
    name: "Denmark (Danmark)",
    priority: 0,
    timezone: "Europe/Copenhagen"
  },
  DM: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1767",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png",
    iso2: "DM",
    name: "Dominica",
    priority: 0,
    timezone: "America/Dominica"
  },
  DO: {
    areaCodes: ["809", "829", "849"],
    currency: "DOP",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png",
    iso2: "DO",
    name: "Dominican Republic (República Dominicana)",
    priority: 2,
    timezone: "America/Santo_Domingo"
  },
  DZ: {
    areaCodes: null,
    currency: "DZD",
    dialCode: "213",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png",
    iso2: "DZ",
    name: "Algeria (‫الجزائر‬‎)",
    priority: 0,
    timezone: "Africa/Algiers"
  },
  EC: {
    areaCodes: null,
    currency: "USD",
    dialCode: "593",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png",
    iso2: "EC",
    name: "Ecuador",
    priority: 0,
    timezone: "America/Guayaquil"
  },
  EE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "372",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png",
    iso2: "EE",
    name: "Estonia (Eesti)",
    priority: 0,
    timezone: "Europe/Tallinn"
  },
  EG: {
    areaCodes: null,
    currency: "EGP",
    dialCode: "20",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png",
    iso2: "EG",
    name: "Egypt (‫مصر‬‎)",
    priority: 0,
    timezone: "Africa/Cairo"
  },
  EH: {
    areaCodes: null,
    currency: "MAD",
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png",
    iso2: "EH",
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    priority: 1,
    timezone: "Africa/El_Aaiun"
  },
  ER: {
    areaCodes: null,
    currency: "ERN",
    dialCode: "291",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png",
    iso2: "ER",
    name: "Eritrea",
    priority: 0,
    timezone: "Africa/Asmara"
  },
  ES: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "34",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png",
    iso2: "ES",
    name: "Spain (España)",
    priority: 0,
    timezone: "Europe/Madrid"
  },
  ET: {
    areaCodes: null,
    currency: "ETB",
    dialCode: "251",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png",
    iso2: "ET",
    name: "Ethiopia",
    priority: 0,
    timezone: "Africa/Addis_Ababa"
  },
  FI: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png",
    iso2: "FI",
    name: "Finland (Suomi)",
    priority: 0,
    timezone: "Europe/Helsinki"
  },
  FJ: {
    areaCodes: null,
    currency: "FJD",
    dialCode: "679",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png",
    iso2: "FJ",
    name: "Fiji",
    priority: 0,
    timezone: "Pacific/Fiji"
  },
  FK: {
    areaCodes: null,
    currency: "FKP",
    dialCode: "500",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png",
    iso2: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    priority: 0,
    timezone: "Atlantic/Stanley"
  },
  FM: {
    areaCodes: null,
    currency: "USD",
    dialCode: "691",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png",
    iso2: "FM",
    name: "Micronesia",
    priority: 0,
    timezone: "Etc/GMT-10"
  },
  FO: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "298",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png",
    iso2: "FO",
    name: "Faroe Islands (Føroyar)",
    priority: 0,
    timezone: "Atlantic/Faroe"
  },
  FR: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "33",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png",
    iso2: "FR",
    name: "France",
    priority: 0,
    timezone: "Europe/Paris"
  },
  GA: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "241",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png",
    iso2: "GA",
    name: "Gabon",
    priority: 0,
    timezone: "Africa/Libreville"
  },
  GB: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png",
    iso2: "GB",
    name: "United Kingdom",
    priority: 0,
    timezone: "Etc/GMT"
  },
  GD: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1473",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png",
    iso2: "GD",
    name: "Grenada",
    priority: 0,
    timezone: "America/Grenada"
  },
  GE: {
    areaCodes: null,
    currency: "GEL",
    dialCode: "995",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png",
    iso2: "GE",
    name: "Georgia (საქართველო)",
    priority: 0,
    timezone: "Asia/Tbilisi"
  },
  GF: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "594",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png",
    iso2: "GF",
    name: "French Guiana (Guyane française)",
    priority: 0,
    timezone: "America/Cayenne"
  },
  GG: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png",
    iso2: "GG",
    name: "Guernsey",
    priority: 1,
    timezone: "Europe/Guernsey"
  },
  GH: {
    areaCodes: null,
    currency: "GHS",
    dialCode: "233",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png",
    iso2: "GH",
    name: "Ghana (Gaana)",
    priority: 0,
    timezone: "Africa/Accra"
  },
  GI: {
    areaCodes: null,
    currency: "GIP",
    dialCode: "350",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png",
    iso2: "GI",
    name: "Gibraltar",
    priority: 0,
    timezone: "Europe/Gibraltar"
  },
  GL: {
    areaCodes: null,
    currency: "DKK",
    dialCode: "299",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png",
    iso2: "GL",
    name: "Greenland (Kalaallit Nunaat)",
    priority: 0,
    timezone: "America/Godthab"
  },
  GM: {
    areaCodes: null,
    currency: "GMD",
    dialCode: "220",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png",
    iso2: "GM",
    name: "Gambia",
    priority: 0,
    timezone: "Africa/Banjul"
  },
  GN: {
    areaCodes: null,
    currency: "GNF",
    dialCode: "224",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png",
    iso2: "GN",
    name: "Guinea (Guinée)",
    priority: 0,
    timezone: "Africa/Conakry"
  },
  GP: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png",
    iso2: "GP",
    name: "Guadeloupe",
    priority: 0,
    timezone: "America/Guadeloupe"
  },
  GQ: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "240",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png",
    iso2: "GQ",
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    priority: 0,
    timezone: "Africa/Malabo"
  },
  GR: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "30",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png",
    iso2: "GR",
    name: "Greece (Ελλάδα)",
    priority: 0,
    timezone: "Europe/Athens"
  },
  GT: {
    areaCodes: null,
    currency: "GTQ",
    dialCode: "502",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png",
    iso2: "GT",
    name: "Guatemala",
    priority: 0,
    timezone: "America/Guatemala"
  },
  GU: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1671",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png",
    iso2: "GU",
    name: "Guam",
    priority: 0,
    timezone: "Pacific/Guam"
  },
  GW: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "245",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png",
    iso2: "GW",
    name: "Guinea-Bissau (Guiné Bissau)",
    priority: 0,
    timezone: "Africa/Bissau"
  },
  GY: {
    areaCodes: null,
    currency: "GYD",
    dialCode: "592",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png",
    iso2: "GY",
    name: "Guyana",
    priority: 0,
    timezone: "America/Guyana"
  },
  HK: {
    areaCodes: null,
    currency: "HKD",
    dialCode: "852",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png",
    iso2: "HK",
    name: "Hong Kong (香港)",
    priority: 0,
    timezone: "Asia/Hong_Kong"
  },
  HN: {
    areaCodes: null,
    currency: "HNL",
    dialCode: "504",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png",
    iso2: "HN",
    name: "Honduras",
    priority: 0,
    timezone: "America/Tegucigalpa"
  },
  HR: {
    areaCodes: null,
    currency: "HRK",
    dialCode: "385",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png",
    iso2: "HR",
    name: "Croatia (Hrvatska)",
    priority: 0,
    timezone: "Europe/Zagreb"
  },
  HT: {
    areaCodes: null,
    currency: "HTG",
    dialCode: "509",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png",
    iso2: "HT",
    name: "Haiti",
    priority: 0,
    timezone: "America/Port-au-Prince"
  },
  HU: {
    areaCodes: null,
    currency: "HUF",
    dialCode: "36",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png",
    iso2: "HU",
    name: "Hungary (Magyarország)",
    priority: 0,
    timezone: "Europe/Budapest"
  },
  ID: {
    areaCodes: null,
    currency: "IDR",
    dialCode: "62",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png",
    iso2: "ID",
    name: "Indonesia",
    priority: 0,
    timezone: "Asia/Makassar"
  },
  IE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "353",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png",
    iso2: "IE",
    name: "Ireland",
    priority: 0,
    timezone: "Europe/Dublin"
  },
  IL: {
    areaCodes: null,
    currency: "ILS",
    dialCode: "972",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png",
    iso2: "IL",
    name: "Israel (‫ישראל‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  IM: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png",
    iso2: "IM",
    name: "Isle of Man",
    priority: 2,
    timezone: "Europe/Isle_of_Man"
  },
  IN: {
    areaCodes: null,
    currency: "INR",
    dialCode: "91",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png",
    iso2: "IN",
    name: "India (भारत)",
    priority: 0,
    timezone: "Asia/Kolkata"
  },
  IO: {
    areaCodes: null,
    currency: "USD",
    dialCode: "246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png",
    iso2: "IO",
    name: "British Indian Ocean Territory",
    priority: 0,
    timezone: "Etc/GMT-5"
  },
  IQ: {
    areaCodes: null,
    currency: "IQD",
    dialCode: "964",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png",
    iso2: "IQ",
    name: "Iraq (‫العراق‬‎)",
    priority: 0,
    timezone: "Asia/Baghdad"
  },
  IR: {
    areaCodes: null,
    currency: "IRR",
    dialCode: "98",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png",
    iso2: "IR",
    name: "Iran (‫ایران‬‎)",
    priority: 0,
    timezone: "Asia/Tehran"
  },
  IS: {
    areaCodes: null,
    currency: "ISK",
    dialCode: "354",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png",
    iso2: "IS",
    name: "Iceland (Ísland)",
    priority: 0,
    timezone: "Atlantic/Reykjavik"
  },
  IT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png",
    iso2: "IT",
    name: "Italy (Italia)",
    priority: 0,
    timezone: "Europe/Rome"
  },
  JE: {
    areaCodes: null,
    currency: "GBP",
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png",
    iso2: "JE",
    name: "Jersey",
    priority: 3,
    timezone: "Europe/Jersey"
  },
  JM: {
    areaCodes: null,
    currency: "JMD",
    dialCode: "1876",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png",
    iso2: "JM",
    name: "Jamaica",
    priority: 0,
    timezone: "America/Jamaica"
  },
  JO: {
    areaCodes: null,
    currency: "JOD",
    dialCode: "962",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png",
    iso2: "JO",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
    timezone: "Asia/Amman"
  },
  JP: {
    areaCodes: null,
    currency: "JPY",
    dialCode: "81",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png",
    iso2: "JP",
    name: "Japan (日本)",
    priority: 0,
    timezone: "Asia/Tokyo"
  },
  KE: {
    areaCodes: null,
    currency: "KES",
    dialCode: "254",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png",
    iso2: "KE",
    name: "Kenya",
    priority: 0,
    timezone: "Africa/Nairobi"
  },
  KG: {
    areaCodes: null,
    currency: "KGS",
    dialCode: "996",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png",
    iso2: "KG",
    name: "Kyrgyzstan (Кыргызстан)",
    priority: 0,
    timezone: "Asia/Bishkek"
  },
  KH: {
    areaCodes: null,
    currency: "KHR",
    dialCode: "855",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png",
    iso2: "KH",
    name: "Cambodia (កម្ពុជា)",
    priority: 0,
    timezone: "Asia/Phnom_Penh"
  },
  KI: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "686",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png",
    iso2: "KI",
    name: "Kiribati",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  KM: {
    areaCodes: null,
    currency: "KMF",
    dialCode: "269",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png",
    iso2: "KM",
    name: "Comoros (‫جزر القمر‬‎)",
    priority: 0,
    timezone: "Indian/Comoro"
  },
  KN: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1869",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png",
    iso2: "KN",
    name: "Saint Kitts and Nevis",
    priority: 0,
    timezone: "America/St_Kitts"
  },
  KP: {
    areaCodes: null,
    currency: "KPW",
    dialCode: "850",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png",
    iso2: "KP",
    name: "North Korea (조선 민주주의 인민 공화국)",
    priority: 0,
    timezone: "Asia/Pyongyang"
  },
  KR: {
    areaCodes: null,
    currency: "KRW",
    dialCode: "82",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png",
    iso2: "KR",
    name: "South Korea (대한민국)",
    priority: 0,
    timezone: "Asia/Seoul"
  },
  KW: {
    areaCodes: null,
    currency: "KWD",
    dialCode: "965",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png",
    iso2: "KW",
    name: "Kuwait (‫الكويت‬‎)",
    priority: 0,
    timezone: "Asia/Kuwait"
  },
  KY: {
    areaCodes: null,
    currency: "KYD",
    dialCode: "1345",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png",
    iso2: "KY",
    name: "Cayman Islands",
    priority: 0,
    timezone: "Etc/GMT+5"
  },
  KZ: {
    areaCodes: null,
    currency: "KZT",
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png",
    iso2: "KZ",
    name: "Kazakhstan (Казахстан)",
    priority: 1,
    timezone: "Asia/Almaty"
  },
  LA: {
    areaCodes: null,
    currency: "LAK",
    dialCode: "856",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png",
    iso2: "LA",
    name: "Laos (ລາວ)",
    priority: 0,
    timezone: "Asia/Vientiane"
  },
  LB: {
    areaCodes: null,
    currency: "LBP",
    dialCode: "961",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png",
    iso2: "LB",
    name: "Lebanon (‫لبنان‬‎)",
    priority: 0,
    timezone: "Asia/Beirut"
  },
  LC: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1758",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png",
    iso2: "LC",
    name: "Saint Lucia",
    priority: 0,
    timezone: "America/St_Lucia"
  },
  LI: {
    areaCodes: null,
    currency: "CHF",
    dialCode: "423",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png",
    iso2: "LI",
    name: "Liechtenstein",
    priority: 0,
    timezone: "Europe/Vaduz"
  },
  LK: {
    areaCodes: null,
    currency: "LKR",
    dialCode: "94",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png",
    iso2: "LK",
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    priority: 0,
    timezone: "Asia/Colombo"
  },
  LR: {
    areaCodes: null,
    currency: "LRD",
    dialCode: "231",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png",
    iso2: "LR",
    name: "Liberia",
    priority: 0,
    timezone: "Africa/Monrovia"
  },
  LS: {
    areaCodes: null,
    currency: "LSL",
    dialCode: "266",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png",
    iso2: "LS",
    name: "Lesotho",
    priority: 0,
    timezone: "Africa/Maseru"
  },
  LT: {
    areaCodes: null,
    currency: "LTL",
    dialCode: "370",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png",
    iso2: "LT",
    name: "Lithuania (Lietuva)",
    priority: 0,
    timezone: "Europe/Vilnius"
  },
  LU: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "352",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png",
    iso2: "LU",
    name: "Luxembourg",
    priority: 0,
    timezone: "Europe/Luxembourg"
  },
  LV: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "371",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png",
    iso2: "LV",
    name: "Latvia (Latvija)",
    priority: 0,
    timezone: "Europe/Riga"
  },
  LY: {
    areaCodes: null,
    currency: "LYD",
    dialCode: "218",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png",
    iso2: "LY",
    name: "Libya (‫ليبيا‬‎)",
    priority: 0,
    timezone: "Africa/Tripoli"
  },
  MA: {
    areaCodes: null,
    currency: "MAD",
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png",
    iso2: "MA",
    name: "Morocco (‫المغرب‬‎)",
    priority: 0,
    timezone: "Africa/Casablanca"
  },
  MC: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "377",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png",
    iso2: "MC",
    name: "Monaco",
    priority: 0,
    timezone: "Europe/Paris"
  },
  MD: {
    areaCodes: null,
    currency: "MDL",
    dialCode: "373",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png",
    iso2: "MD",
    name: "Moldova (Republica Moldova)",
    priority: 0,
    timezone: "Europe/Chisinau"
  },
  ME: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "382",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png",
    iso2: "ME",
    name: "Montenegro (Crna Gora)",
    priority: 0,
    timezone: "Europe/Podgorica"
  },
  MF: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png",
    iso2: "MF",
    name: "Saint Martin (Saint-Martin (partie française))",
    priority: 2,
    timezone: "America/Marigot"
  },
  MG: {
    areaCodes: null,
    currency: "MGA",
    dialCode: "261",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png",
    iso2: "MG",
    name: "Madagascar (Madagasikara)",
    priority: 0,
    timezone: "Indian/Antananarivo"
  },
  MH: {
    areaCodes: null,
    currency: "USD",
    dialCode: "692",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png",
    iso2: "MH",
    name: "Marshall Islands",
    priority: 0,
    timezone: "Etc/GMT-11"
  },
  MK: {
    areaCodes: null,
    currency: "MKD",
    dialCode: "389",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png",
    iso2: "MK",
    name: "Macedonia (FYROM) (Македонија)",
    priority: 0,
    timezone: "Europe/Skopje"
  },
  ML: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "223",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png",
    iso2: "ML",
    name: "Mali",
    priority: 0,
    timezone: "Africa/Bamako"
  },
  MM: {
    areaCodes: null,
    currency: "MMK",
    dialCode: "95",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png",
    iso2: "MM",
    name: "Myanmar (Burma) (မြန်မာ)",
    priority: 0,
    timezone: "Asia/Yangon"
  },
  MN: {
    areaCodes: null,
    currency: "MNT",
    dialCode: "976",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png",
    iso2: "MN",
    name: "Mongolia (Монгол)",
    priority: 0,
    timezone: "Asia/Ulaanbaatar"
  },
  MO: {
    areaCodes: null,
    currency: "MOP",
    dialCode: "853",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png",
    iso2: "MO",
    name: "Macau (澳門)",
    priority: 0,
    timezone: "Asia/Macau"
  },
  MP: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png",
    iso2: "MP",
    name: "Northern Mariana Islands",
    priority: 0,
    timezone: "Pacific/Saipan"
  },
  MQ: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "596",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png",
    iso2: "MQ",
    name: "Martinique",
    priority: 0,
    timezone: "America/Martinique"
  },
  MR: {
    areaCodes: null,
    currency: "MRO",
    dialCode: "222",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png",
    iso2: "MR",
    name: "Mauritania (‫موريتانيا‬‎)",
    priority: 0,
    timezone: "Africa/Nouakchott"
  },
  MS: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1664",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png",
    iso2: "MS",
    name: "Montserrat",
    priority: 0,
    timezone: "America/Montserrat"
  },
  MT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "356",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png",
    iso2: "MT",
    name: "Malta",
    priority: 0,
    timezone: "Europe/Malta"
  },
  MU: {
    areaCodes: null,
    currency: "MUR",
    dialCode: "230",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png",
    iso2: "MU",
    name: "Mauritius (Moris)",
    priority: 0,
    timezone: "Indian/Mauritius"
  },
  MV: {
    areaCodes: null,
    currency: "MVR",
    dialCode: "960",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png",
    iso2: "MV",
    name: "Maldives",
    priority: 0,
    timezone: "Indian/Maldives"
  },
  MW: {
    areaCodes: null,
    currency: "MWK",
    dialCode: "265",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png",
    iso2: "MW",
    name: "Malawi",
    priority: 0,
    timezone: "Africa/Blantyre"
  },
  MX: {
    areaCodes: null,
    currency: "MXN",
    dialCode: "52",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png",
    iso2: "MX",
    name: "Mexico (México)",
    priority: 0,
    timezone: "America/Mexico_City"
  },
  MY: {
    areaCodes: null,
    currency: "MYR",
    dialCode: "60",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png",
    iso2: "MY",
    name: "Malaysia",
    priority: 0,
    timezone: "Asia/Kuching"
  },
  MZ: {
    areaCodes: null,
    currency: "MZN",
    dialCode: "258",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png",
    iso2: "MZ",
    name: "Mozambique (Moçambique)",
    priority: 0,
    timezone: "Africa/Maputo"
  },
  NA: {
    areaCodes: null,
    currency: "NAD",
    dialCode: "264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png",
    iso2: "NA",
    name: "Namibia (Namibië)",
    priority: 0,
    timezone: "Africa/Windhoek"
  },
  NC: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "687",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png",
    iso2: "NC",
    name: "New Caledonia (Nouvelle-Calédonie)",
    priority: 0,
    timezone: "Pacific/Noumea"
  },
  NE: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "227",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png",
    iso2: "NE",
    name: "Niger (Nijar)",
    priority: 0,
    timezone: "Africa/Niamey"
  },
  NF: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "672",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png",
    iso2: "NF",
    name: "Norfolk Island",
    priority: 0,
    timezone: "Pacific/Norfolk"
  },
  NG: {
    areaCodes: null,
    currency: "NGN",
    dialCode: "234",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png",
    iso2: "NG",
    name: "Nigeria",
    priority: 0,
    timezone: "Africa/Lagos"
  },
  NI: {
    areaCodes: null,
    currency: "NIO",
    dialCode: "505",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png",
    iso2: "NI",
    name: "Nicaragua",
    priority: 0,
    timezone: "America/Managua"
  },
  NL: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "31",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png",
    iso2: "NL",
    name: "Netherlands (Nederland)",
    priority: 0,
    timezone: "Europe/Amsterdam"
  },
  NO: {
    areaCodes: null,
    currency: "NOK",
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png",
    iso2: "NO",
    name: "Norway (Norge)",
    priority: 0,
    timezone: "Europe/Oslo"
  },
  NP: {
    areaCodes: null,
    currency: "NPR",
    dialCode: "977",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png",
    iso2: "NP",
    name: "Nepal (नेपाल)",
    priority: 0,
    timezone: "Asia/Kathmandu"
  },
  NR: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "674",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png",
    iso2: "NR",
    name: "Nauru",
    priority: 0,
    timezone: "Pacific/Nauru"
  },
  NU: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "683",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png",
    iso2: "NU",
    name: "Niue",
    priority: 0,
    timezone: "Pacific/Niue"
  },
  NZ: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "64",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png",
    iso2: "NZ",
    name: "New Zealand",
    priority: 0,
    timezone: "Pacific/Auckland"
  },
  OM: {
    areaCodes: null,
    currency: "OMR",
    dialCode: "968",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png",
    iso2: "OM",
    name: "Oman (‫عُمان‬‎)",
    priority: 0,
    timezone: "Asia/Muscat"
  },
  PA: {
    areaCodes: null,
    currency: "PAB",
    dialCode: "507",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png",
    iso2: "PA",
    name: "Panama (Panamá)",
    priority: 0,
    timezone: "America/Panama"
  },
  PE: {
    areaCodes: null,
    currency: "PEN",
    dialCode: "51",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png",
    iso2: "PE",
    name: "Peru (Perú)",
    priority: 0,
    timezone: "America/Lima"
  },
  PF: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "689",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png",
    iso2: "PF",
    name: "French Polynesia (Polynésie française)",
    priority: 0,
    timezone: "Etc/GMT+9"
  },
  PG: {
    areaCodes: null,
    currency: "PGK",
    dialCode: "675",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png",
    iso2: "PG",
    name: "Papua New Guinea",
    priority: 0,
    timezone: "Pacific/Port_Moresby"
  },
  PH: {
    areaCodes: null,
    currency: "PHP",
    dialCode: "63",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png",
    iso2: "PH",
    name: "Philippines",
    priority: 0,
    timezone: "Asia/Manila"
  },
  PK: {
    areaCodes: null,
    currency: "PKR",
    dialCode: "92",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png",
    iso2: "PK",
    name: "Pakistan (‫پاکستان‬‎)",
    priority: 0,
    timezone: "Asia/Karachi"
  },
  PL: {
    areaCodes: null,
    currency: "PLN",
    dialCode: "48",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png",
    iso2: "PL",
    name: "Poland (Polska)",
    priority: 0,
    timezone: "Europe/Warsaw"
  },
  PM: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "508",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png",
    iso2: "PM",
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    priority: 0,
    timezone: "America/Miquelon"
  },
  PR: {
    areaCodes: ["787", "939"],
    currency: "USD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png",
    iso2: "PR",
    name: "Puerto Rico",
    priority: 3,
    timezone: "America/Puerto_Rico"
  },
  PS: {
    areaCodes: null,
    currency: "ILS",
    dialCode: "970",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png",
    iso2: "PS",
    name: "Palestine (‫فلسطين‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  PT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "351",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png",
    iso2: "PT",
    name: "Portugal",
    priority: 0,
    timezone: "Europe/Lisbon"
  },
  PW: {
    areaCodes: null,
    currency: "USD",
    dialCode: "680",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png",
    iso2: "PW",
    name: "Palau",
    priority: 0,
    timezone: "Etc/GMT-9"
  },
  PY: {
    areaCodes: null,
    currency: "PYG",
    dialCode: "595",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png",
    iso2: "PY",
    name: "Paraguay",
    priority: 0,
    timezone: "America/Asuncion"
  },
  QA: {
    areaCodes: null,
    currency: "QAR",
    dialCode: "974",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png",
    iso2: "QA",
    name: "Qatar (‫قطر‬‎)",
    priority: 0,
    timezone: "Asia/Qatar"
  },
  RE: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png",
    iso2: "RE",
    name: "Réunion (La Réunion)",
    priority: 0,
    timezone: "Indian/Reunion"
  },
  RO: {
    areaCodes: null,
    currency: "RON",
    dialCode: "40",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png",
    iso2: "RO",
    name: "Romania (România)",
    priority: 0,
    timezone: "Europe/Bucharest"
  },
  RS: {
    areaCodes: null,
    currency: "RSD",
    dialCode: "381",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png",
    iso2: "RS",
    name: "Serbia (Србија)",
    priority: 0,
    timezone: "Europe/Belgrade"
  },
  RU: {
    areaCodes: null,
    currency: "RUB",
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png",
    iso2: "RU",
    name: "Russia (Россия)",
    priority: 0,
    timezone: "Asia/Krasnoyarsk"
  },
  RW: {
    areaCodes: null,
    currency: "RWF",
    dialCode: "250",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png",
    iso2: "RW",
    name: "Rwanda",
    priority: 0,
    timezone: "Africa/Kigali"
  },
  SA: {
    areaCodes: null,
    currency: "SAR",
    dialCode: "966",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png",
    iso2: "SA",
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    priority: 0,
    timezone: "Asia/Riyadh"
  },
  SB: {
    areaCodes: null,
    currency: "SBD",
    dialCode: "677",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png",
    iso2: "SB",
    name: "Solomon Islands",
    priority: 0,
    timezone: "Pacific/Guadalcanal"
  },
  SC: {
    areaCodes: null,
    currency: "SCR",
    dialCode: "248",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png",
    iso2: "SC",
    name: "Seychelles",
    priority: 0,
    timezone: "Indian/Mahe"
  },
  SD: {
    areaCodes: null,
    currency: "SDG",
    dialCode: "249",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png",
    iso2: "SD",
    name: "Sudan (‫السودان‬‎)",
    priority: 0,
    timezone: "Africa/Khartoum"
  },
  SE: {
    areaCodes: null,
    currency: "SEK",
    dialCode: "46",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png",
    iso2: "SE",
    name: "Sweden (Sverige)",
    priority: 0,
    timezone: "Europe/Stockholm"
  },
  SG: {
    areaCodes: null,
    currency: "SGD",
    dialCode: "65",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png",
    iso2: "SG",
    name: "Singapore",
    priority: 0,
    timezone: "Asia/Singapore"
  },
  SH: {
    areaCodes: null,
    currency: "SHP",
    dialCode: "290",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png",
    iso2: "SH",
    name: "Saint Helena",
    priority: 0,
    timezone: "Atlantic/St_Helena"
  },
  SI: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "386",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png",
    iso2: "SI",
    name: "Slovenia (Slovenija)",
    priority: 0,
    timezone: "Europe/Ljubljana"
  },
  SJ: {
    areaCodes: null,
    currency: "NOK",
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png",
    iso2: "SJ",
    name: "Svalbard and Jan Mayen",
    priority: 1,
    timezone: "Arctic/Longyearbyen"
  },
  SK: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "421",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png",
    iso2: "SK",
    name: "Slovakia (Slovensko)",
    priority: 0,
    timezone: "Europe/Bratislava"
  },
  SL: {
    areaCodes: null,
    currency: "SLL",
    dialCode: "232",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png",
    iso2: "SL",
    name: "Sierra Leone",
    priority: 0,
    timezone: "Africa/Freetown"
  },
  SM: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "378",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png",
    iso2: "SM",
    name: "San Marino",
    priority: 0,
    timezone: "Europe/San_Marino"
  },
  SN: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "221",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png",
    iso2: "SN",
    name: "Senegal (Sénégal)",
    priority: 0,
    timezone: "Africa/Dakar"
  },
  SO: {
    areaCodes: null,
    currency: "SOS",
    dialCode: "252",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png",
    iso2: "SO",
    name: "Somalia (Soomaaliya)",
    priority: 0,
    timezone: "Africa/Mogadishu"
  },
  SR: {
    areaCodes: null,
    currency: "SRD",
    dialCode: "597",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png",
    iso2: "SR",
    name: "Suriname",
    priority: 0,
    timezone: "America/Paramaribo"
  },
  SS: {
    areaCodes: null,
    currency: "SSP",
    dialCode: "211",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png",
    iso2: "SS",
    name: "South Sudan (‫جنوب السودان‬‎)",
    priority: 0,
    timezone: "Africa/Juba"
  },
  ST: {
    areaCodes: null,
    currency: "STD",
    dialCode: "239",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png",
    iso2: "ST",
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    priority: 0,
    timezone: "Africa/Sao_Tome"
  },
  SV: {
    areaCodes: null,
    currency: "USD",
    dialCode: "503",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png",
    iso2: "SV",
    name: "El Salvador",
    priority: 0,
    timezone: "America/El_Salvador"
  },
  SX: {
    areaCodes: null,
    currency: "ANG",
    dialCode: "1721",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png",
    iso2: "SX",
    name: "Sint Maarten",
    priority: 0,
    timezone: "America/Lower_Princes"
  },
  SY: {
    areaCodes: null,
    currency: "SYP",
    dialCode: "963",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png",
    iso2: "SY",
    name: "Syria (‫سوريا‬‎)",
    priority: 0,
    timezone: "Asia/Damascus"
  },
  SZ: {
    areaCodes: null,
    currency: "SZL",
    dialCode: "268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png",
    iso2: "SZ",
    name: "Swaziland",
    priority: 0,
    timezone: "Africa/Mbabane"
  },
  TC: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1649",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png",
    iso2: "TC",
    name: "Turks and Caicos Islands",
    priority: 0,
    timezone: "America/Grand_Turk"
  },
  TD: {
    areaCodes: null,
    currency: "XAF",
    dialCode: "235",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png",
    iso2: "TD",
    name: "Chad (Tchad)",
    priority: 0,
    timezone: "Africa/Ndjamena"
  },
  TG: {
    areaCodes: null,
    currency: "XOF",
    dialCode: "228",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png",
    iso2: "TG",
    name: "Togo",
    priority: 0,
    timezone: "Africa/Lome"
  },
  TH: {
    areaCodes: null,
    currency: "THB",
    dialCode: "66",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png",
    iso2: "TH",
    name: "Thailand (ไทย)",
    priority: 0,
    timezone: "Asia/Bangkok"
  },
  TJ: {
    areaCodes: null,
    currency: "TJS",
    dialCode: "992",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png",
    iso2: "TJ",
    name: "Tajikistan",
    priority: 0,
    timezone: "Asia/Dushanbe"
  },
  TK: {
    areaCodes: null,
    currency: "NZD",
    dialCode: "690",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png",
    iso2: "TK",
    name: "Tokelau",
    priority: 0,
    timezone: "Pacific/Fakaofo"
  },
  TL: {
    areaCodes: null,
    currency: "USD",
    dialCode: "670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png",
    iso2: "TL",
    name: "Timor-Leste",
    priority: 0,
    timezone: "Asia/Dili"
  },
  TM: {
    areaCodes: null,
    currency: "TMT",
    dialCode: "993",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png",
    iso2: "TM",
    name: "Turkmenistan",
    priority: 0,
    timezone: "Asia/Ashgabat"
  },
  TN: {
    areaCodes: null,
    currency: "TND",
    dialCode: "216",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png",
    iso2: "TN",
    name: "Tunisia (‫تونس‬‎)",
    priority: 0,
    timezone: "Africa/Tunis"
  },
  TO: {
    areaCodes: null,
    currency: "TOP",
    dialCode: "676",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png",
    iso2: "TO",
    name: "Tonga",
    priority: 0,
    timezone: "Pacific/Tongatapu"
  },
  TR: {
    areaCodes: null,
    currency: "TRY",
    dialCode: "90",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png",
    iso2: "TR",
    name: "Turkey (Türkiye)",
    priority: 0,
    timezone: "Europe/Istanbul"
  },
  TT: {
    areaCodes: null,
    currency: "TTD",
    dialCode: "1868",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png",
    iso2: "TT",
    name: "Trinidad and Tobago",
    priority: 0,
    timezone: "America/Port_of_Spain"
  },
  TV: {
    areaCodes: null,
    currency: "AUD",
    dialCode: "688",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png",
    iso2: "TV",
    name: "Tuvalu",
    priority: 0,
    timezone: "Etc/GMT-12"
  },
  TW: {
    areaCodes: null,
    currency: "TWD",
    dialCode: "886",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png",
    iso2: "TW",
    name: "Taiwan (台灣)",
    priority: 0,
    timezone: "Asia/Taipei"
  },
  TZ: {
    areaCodes: null,
    currency: "TZS",
    dialCode: "255",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png",
    iso2: "TZ",
    name: "Tanzania",
    priority: 0,
    timezone: "Africa/Dar_es_Salaam"
  },
  UA: {
    areaCodes: null,
    currency: "UAH",
    dialCode: "380",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png",
    iso2: "UA",
    name: "Ukraine (Україна)",
    priority: 0,
    timezone: "Europe/Kiev"
  },
  UG: {
    areaCodes: null,
    currency: "UGX",
    dialCode: "256",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png",
    iso2: "UG",
    name: "Uganda",
    priority: 0,
    timezone: "Africa/Kampala"
  },
  US: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png",
    iso2: "US",
    name: "United States",
    priority: 0,
    timezone: "America/Chicago"
  },
  UY: {
    areaCodes: null,
    currency: "UYU",
    dialCode: "598",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png",
    iso2: "UY",
    name: "Uruguay",
    priority: 0,
    timezone: "America/Montevideo"
  },
  UZ: {
    areaCodes: null,
    currency: "UZS",
    dialCode: "998",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png",
    iso2: "UZ",
    name: "Uzbekistan (Oʻzbekiston)",
    priority: 0,
    timezone: "Asia/Samarkand"
  },
  VA: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png",
    iso2: "VA",
    name: "Vatican City (Città del Vaticano)",
    priority: 1,
    timezone: "Europe/Rome"
  },
  VC: {
    areaCodes: null,
    currency: "XCD",
    dialCode: "1784",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png",
    iso2: "VC",
    name: "Saint Vincent and the Grenadines",
    priority: 0,
    timezone: "America/St_Vincent"
  },
  VE: {
    areaCodes: null,
    currency: "VEF",
    dialCode: "58",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png",
    iso2: "VE",
    name: "Venezuela",
    priority: 0,
    timezone: "America/Caracas"
  },
  VG: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1284",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png",
    iso2: "VG",
    name: "British Virgin Islands",
    priority: 0,
    timezone: "America/Tortola"
  },
  VI: {
    areaCodes: null,
    currency: "USD",
    dialCode: "1340",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png",
    iso2: "VI",
    name: "U.S. Virgin Islands",
    priority: 0,
    timezone: "America/St_Thomas"
  },
  VN: {
    areaCodes: null,
    currency: "VND",
    dialCode: "84",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png",
    iso2: "VN",
    name: "Vietnam (Việt Nam)",
    priority: 0,
    timezone: "Asia/Ho_Chi_Minh"
  },
  VU: {
    areaCodes: null,
    currency: "VUV",
    dialCode: "678",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png",
    iso2: "VU",
    name: "Vanuatu",
    priority: 0,
    timezone: "Pacific/Efate"
  },
  WF: {
    areaCodes: null,
    currency: "XPF",
    dialCode: "681",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png",
    iso2: "WF",
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    priority: 0,
    timezone: "Pacific/Wallis"
  },
  WS: {
    areaCodes: null,
    currency: "WST",
    dialCode: "685",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png",
    iso2: "WS",
    name: "Samoa",
    priority: 0,
    timezone: "Pacific/Apia"
  },
  XK: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "383",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png",
    iso2: "XK",
    name: "Kosovo",
    priority: 0,
    timezone: "Europe/Rome"
  },
  YE: {
    areaCodes: null,
    currency: "YER",
    dialCode: "967",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png",
    iso2: "YE",
    name: "Yemen (‫اليمن‬‎)",
    priority: 0,
    timezone: "Asia/Aden"
  },
  YT: {
    areaCodes: null,
    currency: "EUR",
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png",
    iso2: "YT",
    name: "Mayotte",
    priority: 1,
    timezone: "Indian/Mayotte"
  },
  ZA: {
    areaCodes: null,
    currency: "ZAR",
    dialCode: "27",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png",
    iso2: "ZA",
    name: "South Africa",
    priority: 0,
    timezone: "Africa/Johannesburg"
  },
  ZM: {
    areaCodes: null,
    currency: "ZMK",
    dialCode: "260",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png",
    iso2: "ZM",
    name: "Zambia",
    priority: 0,
    timezone: "Africa/Lusaka"
  },
  ZW: {
    areaCodes: null,
    currency: "ZWL",
    dialCode: "263",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png",
    iso2: "ZW",
    name: "Zimbabwe",
    priority: 0,
    timezone: "Africa/Harare"
  }
};
vg(Ig, "iso2");
const Fa = {
  AED: {
    code: "AED",
    decimal_digits: 2,
    name: "United Arab Emirates Dirham",
    name_plural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbol_native: "د.إ.‏",
    zero_decimal: !1
  },
  AFN: {
    code: "AFN",
    decimal_digits: 0,
    name: "Afghan Afghani",
    name_plural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbol_native: "؋",
    zero_decimal: !1
  },
  ALL: {
    code: "ALL",
    decimal_digits: 0,
    name: "Albanian Lek",
    name_plural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbol_native: "Lek",
    zero_decimal: !1
  },
  AMD: {
    code: "AMD",
    decimal_digits: 0,
    name: "Armenian Dram",
    name_plural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbol_native: "դր.",
    zero_decimal: !1
  },
  ANG: {
    code: "ANG",
    decimal_digits: 2,
    name: "Netherlands Antillean Guilder",
    name_plural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbol_native: "NAf.",
    zero_decimal: !1
  },
  AOA: {
    code: "AOA",
    decimal_digits: 2,
    name: "Angolan Kwanza",
    name_plural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbol_native: "Kz",
    zero_decimal: !1
  },
  ARS: {
    code: "ARS",
    decimal_digits: 2,
    name: "Argentine Peso",
    name_plural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbol_native: "$",
    zero_decimal: !1
  },
  AUD: {
    code: "AUD",
    decimal_digits: 2,
    name: "Australian Dollar",
    name_plural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbol_native: "$",
    zero_decimal: !1
  },
  AWG: {
    code: "AWG",
    decimal_digits: 2,
    name: "Aruban Florin",
    name_plural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbol_native: "Afl.",
    zero_decimal: !1
  },
  AZN: {
    code: "AZN",
    decimal_digits: 2,
    name: "Azerbaijani Manat",
    name_plural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbol_native: "ман.",
    zero_decimal: !1
  },
  BAM: {
    code: "BAM",
    decimal_digits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    name_plural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbol_native: "KM",
    zero_decimal: !1
  },
  BBD: {
    code: "BBD",
    decimal_digits: 2,
    name: "Barbadian Dollar",
    name_plural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BDT: {
    code: "BDT",
    decimal_digits: 2,
    name: "Bangladeshi Taka",
    name_plural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbol_native: "৳",
    zero_decimal: !1
  },
  BGN: {
    code: "BGN",
    decimal_digits: 2,
    name: "Bulgarian Lev",
    name_plural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbol_native: "лв.",
    zero_decimal: !1
  },
  BHD: {
    code: "BHD",
    decimal_digits: 3,
    name: "Bahraini Dinar",
    name_plural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbol_native: "د.ب.‏",
    zero_decimal: !1
  },
  BIF: {
    code: "BIF",
    decimal_digits: 0,
    name: "Burundian Franc",
    name_plural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbol_native: "FBu",
    zero_decimal: !0
  },
  BMD: {
    code: "BMD",
    decimal_digits: 2,
    name: "Bermudan Dollar",
    name_plural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BND: {
    code: "BND",
    decimal_digits: 2,
    name: "Brunei Dollar",
    name_plural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbol_native: "$",
    zero_decimal: !1
  },
  BOB: {
    code: "BOB",
    decimal_digits: 2,
    name: "Bolivian Boliviano",
    name_plural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbol_native: "Bs",
    zero_decimal: !1
  },
  BRL: {
    code: "BRL",
    decimal_digits: 2,
    name: "Brazilian Real",
    name_plural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbol_native: "R$",
    zero_decimal: !1
  },
  BSD: {
    code: "BSD",
    decimal_digits: 2,
    name: "Bahamian Dollar",
    name_plural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbol_native: "$",
    zero_decimal: !1
  },
  BTN: {
    code: "BTN",
    decimal_digits: 2,
    name: "Bhutanese Ngultrum",
    name_plural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbol_native: "Nu.",
    zero_decimal: !1
  },
  BWP: {
    code: "BWP",
    decimal_digits: 2,
    name: "Botswanan Pula",
    name_plural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbol_native: "P",
    zero_decimal: !1
  },
  BYN: {
    code: "BYN",
    decimal_digits: 2,
    name: "Belarusian Ruble",
    name_plural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbol_native: "руб.",
    zero_decimal: !1
  },
  BZD: {
    code: "BZD",
    decimal_digits: 2,
    name: "Belize Dollar",
    name_plural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CAD: {
    code: "CAD",
    decimal_digits: 2,
    name: "Canadian Dollar",
    name_plural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CDF: {
    code: "CDF",
    decimal_digits: 2,
    name: "Congolese Franc",
    name_plural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbol_native: "FrCD",
    zero_decimal: !1
  },
  CHF: {
    code: "CHF",
    decimal_digits: 2,
    name: "Swiss Franc",
    name_plural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbol_native: "CHF",
    zero_decimal: !1
  },
  CLF: {
    code: "CLF",
    decimal_digits: 4,
    name: "Chilean Unit of Account (UF)",
    name_plural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbol_native: "CLF",
    zero_decimal: !1
  },
  CLP: {
    code: "CLP",
    decimal_digits: 0,
    name: "Chilean Peso",
    name_plural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbol_native: "$",
    zero_decimal: !0
  },
  CNY: {
    code: "CNY",
    decimal_digits: 2,
    name: "Chinese Yuan",
    name_plural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbol_native: "CN¥",
    zero_decimal: !1
  },
  COP: {
    code: "COP",
    decimal_digits: 0,
    name: "Colombian Peso",
    name_plural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbol_native: "$",
    zero_decimal: !1
  },
  CRC: {
    code: "CRC",
    decimal_digits: 0,
    name: "Costa Rican Colón",
    name_plural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbol_native: "₡",
    zero_decimal: !1
  },
  CUC: {
    code: "CUC",
    decimal_digits: 2,
    name: "Cuban Convertible Peso",
    name_plural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbol_native: "CUC",
    zero_decimal: !1
  },
  CUP: {
    code: "CUP",
    decimal_digits: 2,
    name: "Cuban Peso",
    name_plural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbol_native: "$",
    zero_decimal: !1
  },
  CVE: {
    code: "CVE",
    decimal_digits: 2,
    name: "Cape Verdean Escudo",
    name_plural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbol_native: "CV$",
    zero_decimal: !1
  },
  CZK: {
    code: "CZK",
    decimal_digits: 2,
    name: "Czech Republic Koruna",
    name_plural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbol_native: "Kč",
    zero_decimal: !1
  },
  DJF: {
    code: "DJF",
    decimal_digits: 0,
    name: "Djiboutian Franc",
    name_plural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbol_native: "Fdj",
    zero_decimal: !0
  },
  DKK: {
    code: "DKK",
    decimal_digits: 2,
    name: "Danish Krone",
    name_plural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  DOP: {
    code: "DOP",
    decimal_digits: 2,
    name: "Dominican Peso",
    name_plural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbol_native: "RD$",
    zero_decimal: !1
  },
  DZD: {
    code: "DZD",
    decimal_digits: 2,
    name: "Algerian Dinar",
    name_plural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbol_native: "د.ج.‏",
    zero_decimal: !1
  },
  EEK: {
    code: "EEK",
    decimal_digits: 2,
    name: "Estonian Kroon",
    name_plural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  EGP: {
    code: "EGP",
    decimal_digits: 2,
    name: "Egyptian Pound",
    name_plural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbol_native: "ج.م.‏",
    zero_decimal: !1
  },
  ERN: {
    code: "ERN",
    decimal_digits: 2,
    name: "Eritrean Nakfa",
    name_plural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbol_native: "Nfk",
    zero_decimal: !1
  },
  ETB: {
    code: "ETB",
    decimal_digits: 2,
    name: "Ethiopian Birr",
    name_plural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbol_native: "Br",
    zero_decimal: !1
  },
  EUR: {
    code: "EUR",
    decimal_digits: 2,
    name: "Euro",
    name_plural: "euros",
    rounding: 0,
    symbol: "€",
    symbol_native: "€",
    zero_decimal: !1
  },
  FJD: {
    code: "FJD",
    decimal_digits: 2,
    name: "Fijian Dollar",
    name_plural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbol_native: "$",
    zero_decimal: !1
  },
  FKP: {
    code: "FKP",
    decimal_digits: 2,
    name: "Falkland Islands Pound",
    name_plural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbol_native: "£",
    zero_decimal: !1
  },
  GBP: {
    code: "GBP",
    decimal_digits: 2,
    name: "British Pound Sterling",
    name_plural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbol_native: "£",
    zero_decimal: !1
  },
  GEL: {
    code: "GEL",
    decimal_digits: 2,
    name: "Georgian Lari",
    name_plural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbol_native: "GEL",
    zero_decimal: !1
  },
  GHS: {
    code: "GHS",
    decimal_digits: 2,
    name: "Ghanaian Cedi",
    name_plural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbol_native: "GH₵",
    zero_decimal: !1
  },
  GIP: {
    code: "GIP",
    decimal_digits: 2,
    name: "Gibraltar Pound",
    name_plural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbol_native: "£",
    zero_decimal: !1
  },
  GMD: {
    code: "GMD",
    decimal_digits: 2,
    name: "Gambian Dalasi",
    name_plural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbol_native: "D",
    zero_decimal: !1
  },
  GNF: {
    code: "GNF",
    decimal_digits: 0,
    name: "Guinean Franc",
    name_plural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbol_native: "FG",
    zero_decimal: !0
  },
  GTQ: {
    code: "GTQ",
    decimal_digits: 2,
    name: "Guatemalan Quetzal",
    name_plural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbol_native: "Q",
    zero_decimal: !1
  },
  GYD: {
    code: "GYD",
    decimal_digits: 0,
    name: "Guyanaese Dollar",
    name_plural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbol_native: "$",
    zero_decimal: !1
  },
  HKD: {
    code: "HKD",
    decimal_digits: 2,
    name: "Hong Kong Dollar",
    name_plural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbol_native: "$",
    zero_decimal: !1
  },
  HNL: {
    code: "HNL",
    decimal_digits: 2,
    name: "Honduran Lempira",
    name_plural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbol_native: "L",
    zero_decimal: !1
  },
  HRK: {
    code: "HRK",
    decimal_digits: 2,
    name: "Croatian Kuna",
    name_plural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbol_native: "kn",
    zero_decimal: !1
  },
  HTG: {
    code: "HTG",
    decimal_digits: 2,
    name: "Haitian Gourde",
    name_plural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbol_native: "G",
    zero_decimal: !1
  },
  HUF: {
    code: "HUF",
    decimal_digits: 0,
    name: "Hungarian Forint",
    name_plural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbol_native: "Ft",
    zero_decimal: !1
  },
  IDR: {
    code: "IDR",
    decimal_digits: 0,
    name: "Indonesian Rupiah",
    name_plural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbol_native: "Rp",
    zero_decimal: !1
  },
  ILS: {
    code: "ILS",
    decimal_digits: 2,
    name: "Israeli New Sheqel",
    name_plural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbol_native: "₪",
    zero_decimal: !1
  },
  INR: {
    code: "INR",
    decimal_digits: 2,
    name: "Indian Rupee",
    name_plural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbol_native: "টকা",
    zero_decimal: !1
  },
  IQD: {
    code: "IQD",
    decimal_digits: 0,
    name: "Iraqi Dinar",
    name_plural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbol_native: "د.ع.‏",
    zero_decimal: !1
  },
  IRR: {
    code: "IRR",
    decimal_digits: 0,
    name: "Iranian Rial",
    name_plural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbol_native: "﷼",
    zero_decimal: !0
  },
  ISK: {
    code: "ISK",
    decimal_digits: 0,
    name: "Icelandic Króna",
    name_plural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  JMD: {
    code: "JMD",
    decimal_digits: 2,
    name: "Jamaican Dollar",
    name_plural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbol_native: "$",
    zero_decimal: !1
  },
  JOD: {
    code: "JOD",
    decimal_digits: 3,
    name: "Jordanian Dinar",
    name_plural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbol_native: "د.أ.‏",
    zero_decimal: !1
  },
  JPY: {
    code: "JPY",
    decimal_digits: 0,
    name: "Japanese Yen",
    name_plural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbol_native: "￥",
    zero_decimal: !0
  },
  KES: {
    code: "KES",
    decimal_digits: 2,
    name: "Kenyan Shilling",
    name_plural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbol_native: "Ksh",
    zero_decimal: !1
  },
  KGS: {
    code: "KGS",
    decimal_digits: 2,
    name: "Kyrgystani Som",
    name_plural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbol_native: "сом",
    zero_decimal: !1
  },
  KHR: {
    code: "KHR",
    decimal_digits: 2,
    name: "Cambodian Riel",
    name_plural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbol_native: "៛",
    zero_decimal: !1
  },
  KMF: {
    code: "KMF",
    decimal_digits: 0,
    name: "Comorian Franc",
    name_plural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbol_native: "FC",
    zero_decimal: !0
  },
  KPW: {
    code: "KPW",
    decimal_digits: 0,
    name: "North Korean Won",
    name_plural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbol_native: "KPW",
    zero_decimal: !1
  },
  KRW: {
    code: "KRW",
    decimal_digits: 0,
    name: "South Korean Won",
    name_plural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbol_native: "₩",
    zero_decimal: !0
  },
  KWD: {
    code: "KWD",
    decimal_digits: 3,
    name: "Kuwaiti Dinar",
    name_plural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbol_native: "د.ك.‏",
    zero_decimal: !1
  },
  KYD: {
    code: "KYD",
    decimal_digits: 2,
    name: "Cayman Islands Dollar",
    name_plural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbol_native: "$",
    zero_decimal: !1
  },
  KZT: {
    code: "KZT",
    decimal_digits: 2,
    name: "Kazakhstani Tenge",
    name_plural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbol_native: "тңг.",
    zero_decimal: !1
  },
  LAK: {
    code: "LAK",
    decimal_digits: 0,
    name: "Laotian Kip",
    name_plural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbol_native: "₭",
    zero_decimal: !1
  },
  LBP: {
    code: "LBP",
    decimal_digits: 0,
    name: "Lebanese Pound",
    name_plural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbol_native: "ل.ل.‏",
    zero_decimal: !1
  },
  LKR: {
    code: "LKR",
    decimal_digits: 2,
    name: "Sri Lankan Rupee",
    name_plural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbol_native: "SL Re",
    zero_decimal: !1
  },
  LRD: {
    code: "LRD",
    decimal_digits: 2,
    name: "Liberian Dollar",
    name_plural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbol_native: "$",
    zero_decimal: !1
  },
  LSL: {
    code: "LSL",
    decimal_digits: 2,
    name: "Lesotho Loti",
    name_plural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbol_native: "LSL",
    zero_decimal: !1
  },
  LTL: {
    code: "LTL",
    decimal_digits: 2,
    name: "Lithuanian Litas",
    name_plural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbol_native: "Lt",
    zero_decimal: !1
  },
  LVL: {
    code: "LVL",
    decimal_digits: 2,
    name: "Latvian Lats",
    name_plural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbol_native: "Ls",
    zero_decimal: !1
  },
  LYD: {
    code: "LYD",
    decimal_digits: 3,
    name: "Libyan Dinar",
    name_plural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbol_native: "د.ل.‏",
    zero_decimal: !1
  },
  MAD: {
    code: "MAD",
    decimal_digits: 2,
    name: "Moroccan Dirham",
    name_plural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbol_native: "د.م.‏",
    zero_decimal: !1
  },
  MDL: {
    code: "MDL",
    decimal_digits: 2,
    name: "Moldovan Leu",
    name_plural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbol_native: "MDL",
    zero_decimal: !1
  },
  MGA: {
    code: "MGA",
    decimal_digits: 0,
    name: "Malagasy Ariary",
    name_plural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbol_native: "MGA",
    zero_decimal: !0
  },
  MKD: {
    code: "MKD",
    decimal_digits: 2,
    name: "Macedonian Denar",
    name_plural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbol_native: "MKD",
    zero_decimal: !1
  },
  MMK: {
    code: "MMK",
    decimal_digits: 0,
    name: "Myanma Kyat",
    name_plural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbol_native: "K",
    zero_decimal: !1
  },
  MNT: {
    code: "MNT",
    decimal_digits: 0,
    name: "Mongolian Tugrik",
    name_plural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbol_native: "₮",
    zero_decimal: !1
  },
  MOP: {
    code: "MOP",
    decimal_digits: 2,
    name: "Macanese Pataca",
    name_plural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbol_native: "MOP$",
    zero_decimal: !1
  },
  MRO: {
    code: "MRO",
    decimal_digits: 0,
    name: "Mauritanian Ouguiya",
    name_plural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbol_native: "أ.م.‏",
    zero_decimal: !1
  },
  MUR: {
    code: "MUR",
    decimal_digits: 0,
    name: "Mauritian Rupee",
    name_plural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbol_native: "MURs",
    zero_decimal: !1
  },
  MVR: {
    code: "MVR",
    decimal_digits: 0,
    name: "Maldivian rufiyaa",
    name_plural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbol_native: "Rf",
    zero_decimal: !1
  },
  MWK: {
    code: "MWK",
    decimal_digits: 2,
    name: "Malawian Kwacha",
    name_plural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbol_native: "MK",
    zero_decimal: !1
  },
  MXN: {
    code: "MXN",
    decimal_digits: 2,
    name: "Mexican Peso",
    name_plural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbol_native: "$",
    zero_decimal: !1
  },
  MYR: {
    code: "MYR",
    decimal_digits: 2,
    name: "Malaysian Ringgit",
    name_plural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbol_native: "RM",
    zero_decimal: !1
  },
  MZN: {
    code: "MZN",
    decimal_digits: 2,
    name: "Mozambican Metical",
    name_plural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbol_native: "MTn",
    zero_decimal: !1
  },
  NAD: {
    code: "NAD",
    decimal_digits: 2,
    name: "Namibian Dollar",
    name_plural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbol_native: "N$",
    zero_decimal: !1
  },
  NGN: {
    code: "NGN",
    decimal_digits: 2,
    name: "Nigerian Naira",
    name_plural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbol_native: "₦",
    zero_decimal: !1
  },
  NIO: {
    code: "NIO",
    decimal_digits: 2,
    name: "Nicaraguan Córdoba",
    name_plural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbol_native: "C$",
    zero_decimal: !1
  },
  NOK: {
    code: "NOK",
    decimal_digits: 2,
    name: "Norwegian Krone",
    name_plural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  NPR: {
    code: "NPR",
    decimal_digits: 2,
    name: "Nepalese Rupee",
    name_plural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbol_native: "नेरू",
    zero_decimal: !1
  },
  NZD: {
    code: "NZD",
    decimal_digits: 2,
    name: "New Zealand Dollar",
    name_plural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbol_native: "$",
    zero_decimal: !1
  },
  OMR: {
    code: "OMR",
    decimal_digits: 3,
    name: "Omani Rial",
    name_plural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbol_native: "ر.ع.‏",
    zero_decimal: !1
  },
  PAB: {
    code: "PAB",
    decimal_digits: 2,
    name: "Panamanian Balboa",
    name_plural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbol_native: "B/.",
    zero_decimal: !1
  },
  PEN: {
    code: "PEN",
    decimal_digits: 2,
    name: "Peruvian Nuevo Sol",
    name_plural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbol_native: "S/.",
    zero_decimal: !1
  },
  PGK: {
    code: "PGK",
    decimal_digits: 2,
    name: "Papua New Guinean Kina",
    name_plural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbol_native: "K",
    zero_decimal: !1
  },
  PHP: {
    code: "PHP",
    decimal_digits: 2,
    name: "Philippine Peso",
    name_plural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbol_native: "₱",
    zero_decimal: !1
  },
  PKR: {
    code: "PKR",
    decimal_digits: 0,
    name: "Pakistani Rupee",
    name_plural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbol_native: "₨",
    zero_decimal: !1
  },
  PLN: {
    code: "PLN",
    decimal_digits: 2,
    name: "Polish Zloty",
    name_plural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbol_native: "zł",
    zero_decimal: !1
  },
  PYG: {
    code: "PYG",
    decimal_digits: 0,
    name: "Paraguayan Guarani",
    name_plural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbol_native: "₲",
    zero_decimal: !0
  },
  QAR: {
    code: "QAR",
    decimal_digits: 2,
    name: "Qatari Rial",
    name_plural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbol_native: "ر.ق.‏",
    zero_decimal: !1
  },
  RON: {
    code: "RON",
    decimal_digits: 2,
    name: "Romanian Leu",
    name_plural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbol_native: "RON",
    zero_decimal: !1
  },
  RSD: {
    code: "RSD",
    decimal_digits: 0,
    name: "Serbian Dinar",
    name_plural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbol_native: "дин.",
    zero_decimal: !1
  },
  RUB: {
    code: "RUB",
    decimal_digits: 2,
    name: "Russian Ruble",
    name_plural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbol_native: "₽.",
    zero_decimal: !1
  },
  RWF: {
    code: "RWF",
    decimal_digits: 0,
    name: "Rwandan Franc",
    name_plural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbol_native: "FR",
    zero_decimal: !0
  },
  SAR: {
    code: "SAR",
    decimal_digits: 2,
    name: "Saudi Riyal",
    name_plural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbol_native: "ر.س.‏",
    zero_decimal: !1
  },
  SBD: {
    code: "SBD",
    decimal_digits: 2,
    name: "Solomon Islands Dollar",
    name_plural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbol_native: "$",
    zero_decimal: !1
  },
  SCR: {
    code: "SCR",
    decimal_digits: 2,
    name: "Seychellois Rupee",
    name_plural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbol_native: "SR",
    zero_decimal: !1
  },
  SDG: {
    code: "SDG",
    decimal_digits: 2,
    name: "Sudanese Pound",
    name_plural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbol_native: "SDG",
    zero_decimal: !1
  },
  SEK: {
    code: "SEK",
    decimal_digits: 2,
    name: "Swedish Krona",
    name_plural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbol_native: "kr",
    zero_decimal: !1
  },
  SGD: {
    code: "SGD",
    decimal_digits: 2,
    name: "Singapore Dollar",
    name_plural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbol_native: "$",
    zero_decimal: !1
  },
  SHP: {
    code: "SHP",
    decimal_digits: 2,
    name: "St. Helena Pound",
    name_plural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbol_native: "£",
    zero_decimal: !1
  },
  SLL: {
    code: "SLL",
    decimal_digits: 0,
    name: "Sierra Leonean Leone",
    name_plural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbol_native: "Le",
    zero_decimal: !1
  },
  SOS: {
    code: "SOS",
    decimal_digits: 0,
    name: "Somali Shilling",
    name_plural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbol_native: "Ssh",
    zero_decimal: !1
  },
  SRD: {
    code: "SRD",
    decimal_digits: 2,
    name: "Surinamese Dollar",
    name_plural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbol_native: "$",
    zero_decimal: !1
  },
  STD: {
    code: "STN",
    decimal_digits: 2,
    name: "Dobra",
    name_plural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbol_native: "Db",
    zero_decimal: !1
  },
  SYP: {
    code: "SYP",
    decimal_digits: 0,
    name: "Syrian Pound",
    name_plural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbol_native: "ل.س.‏",
    zero_decimal: !1
  },
  SZL: {
    code: "SZL",
    decimal_digits: 2,
    name: "Swazi Lilangeni",
    name_plural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbol_native: "E",
    zero_decimal: !1
  },
  THB: {
    code: "THB",
    decimal_digits: 2,
    name: "Thai Baht",
    name_plural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbol_native: "฿",
    zero_decimal: !1
  },
  TJS: {
    code: "TJS",
    decimal_digits: 2,
    name: "Tajikistani Somoni",
    name_plural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbol_native: "сом.",
    zero_decimal: !1
  },
  TND: {
    code: "TND",
    decimal_digits: 3,
    name: "Tunisian Dinar",
    name_plural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbol_native: "د.ت.‏",
    zero_decimal: !1
  },
  TOP: {
    code: "TOP",
    decimal_digits: 2,
    name: "Tongan Paʻanga",
    name_plural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbol_native: "T$",
    zero_decimal: !1
  },
  TRY: {
    code: "TRY",
    decimal_digits: 2,
    name: "Turkish Lira",
    name_plural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbol_native: "TL",
    zero_decimal: !1
  },
  TTD: {
    code: "TTD",
    decimal_digits: 2,
    name: "Trinidad and Tobago Dollar",
    name_plural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbol_native: "$",
    zero_decimal: !1
  },
  TWD: {
    code: "TWD",
    decimal_digits: 2,
    name: "New Taiwan Dollar",
    name_plural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbol_native: "NT$",
    zero_decimal: !1
  },
  TZS: {
    code: "TZS",
    decimal_digits: 0,
    name: "Tanzanian Shilling",
    name_plural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbol_native: "TSh",
    zero_decimal: !1
  },
  UAH: {
    code: "UAH",
    decimal_digits: 2,
    name: "Ukrainian Hryvnia",
    name_plural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbol_native: "₴",
    zero_decimal: !1
  },
  UGX: {
    code: "UGX",
    decimal_digits: 0,
    name: "Ugandan Shilling",
    name_plural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbol_native: "USh",
    zero_decimal: !0
  },
  USD: {
    code: "USD",
    decimal_digits: 2,
    name: "US Dollar",
    name_plural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbol_native: "$",
    zero_decimal: !1
  },
  UYU: {
    code: "UYU",
    decimal_digits: 2,
    name: "Uruguayan Peso",
    name_plural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbol_native: "$",
    zero_decimal: !1
  },
  UZS: {
    code: "UZS",
    decimal_digits: 0,
    name: "Uzbekistan Som",
    name_plural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbol_native: "UZS",
    zero_decimal: !1
  },
  VEF: {
    code: "VEF",
    decimal_digits: 2,
    name: "Venezuelan Bolívar",
    name_plural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbol_native: "Bs.F.",
    zero_decimal: !1
  },
  VND: {
    code: "VND",
    decimal_digits: 0,
    name: "Vietnamese Dong",
    name_plural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbol_native: "₫",
    zero_decimal: !0
  },
  VUV: {
    code: "VUV",
    decimal_digits: 0,
    name: "Vanuatu Vatu",
    name_plural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbol_native: "VT",
    zero_decimal: !0
  },
  WST: {
    code: "WST",
    decimal_digits: 2,
    name: "Samoan Tala",
    name_plural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbol_native: "WS$",
    zero_decimal: !1
  },
  XAF: {
    code: "XAF",
    decimal_digits: 0,
    name: "CFA Franc BEAC",
    name_plural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbol_native: "FCFA",
    zero_decimal: !0
  },
  XCD: {
    code: "XCD",
    decimal_digits: 2,
    name: "East Caribbean Dollar",
    name_plural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbol_native: "$",
    zero_decimal: !1
  },
  XOF: {
    code: "XOF",
    decimal_digits: 0,
    name: "CFA Franc BCEAO",
    name_plural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbol_native: "CFA",
    zero_decimal: !0
  },
  XPF: {
    code: "XPF",
    decimal_digits: 0,
    name: "CFP Franc",
    name_plural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbol_native: "FCFP",
    zero_decimal: !0
  },
  YER: {
    code: "YER",
    decimal_digits: 0,
    name: "Yemeni Rial",
    name_plural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbol_native: "ر.ي.‏",
    zero_decimal: !1
  },
  ZAR: {
    code: "ZAR",
    decimal_digits: 2,
    name: "South African Rand",
    name_plural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbol_native: "R",
    zero_decimal: !1
  },
  ZMK: {
    code: "ZMK",
    decimal_digits: 0,
    name: "Zambian Kwacha",
    name_plural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbol_native: "ZK",
    zero_decimal: !0
  },
  ZMW: {
    code: "ZMW",
    decimal_digits: 2,
    name: "Zambian Kwacha",
    name_plural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbol_native: "K",
    zero_decimal: !1
  },
  ZWL: {
    code: "ZWL",
    decimal_digits: 0,
    name: "Zimbabwean Dollar",
    name_plural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbol_native: "ZWL$",
    zero_decimal: !0
  }
}, yt = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BHD",
  "BGN",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRO",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "STD",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW"
], va = Object.fromEntries(
  yt.map((e) => [
    e,
    Fa[e]
  ])
);
Object.keys(
  va
).filter(
  (e) => va[e].zero_decimal
).map(
  (e) => va[e].code
);
Object.fromEntries(
  yt.filter(
    (e) => Fa[e].decimal_digits !== 3
  ).map((e) => [e, Fa[e]])
);
var bt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    var n = 1e3, r = 6e4, t = 36e5, s = "millisecond", o = "second", l = "minute", c = "hour", p = "day", f = "week", v = "month", b = "quarter", A = "year", C = "date", d = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, R = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(_) {
      var i = ["th", "st", "nd", "rd"], u = _ % 100;
      return "[" + _ + (i[(u - 20) % 10] || i[u] || i[0]) + "]";
    } }, z = function(_, i, u) {
      var m = String(_);
      return !m || m.length >= i ? _ : "" + Array(i + 1 - m.length).join(u) + _;
    }, L = { s: z, z: function(_) {
      var i = -_.utcOffset(), u = Math.abs(i), m = Math.floor(u / 60), g = u % 60;
      return (i <= 0 ? "+" : "-") + z(m, 2, "0") + ":" + z(g, 2, "0");
    }, m: function _(i, u) {
      if (i.date() < u.date()) return -_(u, i);
      var m = 12 * (u.year() - i.year()) + (u.month() - i.month()), g = i.clone().add(m, v), y = u - g < 0, h = i.clone().add(m + (y ? -1 : 1), v);
      return +(-(m + (u - g) / (y ? g - h : h - g)) || 0);
    }, a: function(_) {
      return _ < 0 ? Math.ceil(_) || 0 : Math.floor(_);
    }, p: function(_) {
      return { M: v, y: A, w: f, d: p, D: C, h: c, m: l, s: o, ms: s, Q: b }[_] || String(_ || "").toLowerCase().replace(/s$/, "");
    }, u: function(_) {
      return _ === void 0;
    } }, D = "en", O = {};
    O[D] = R;
    var G = "$isDayjsObject", U = function(_) {
      return _ instanceof Y || !(!_ || !_[G]);
    }, F = function _(i, u, m) {
      var g;
      if (!i) return D;
      if (typeof i == "string") {
        var y = i.toLowerCase();
        O[y] && (g = y), u && (O[y] = u, g = y);
        var h = i.split("-");
        if (!g && h.length > 1) return _(h[0]);
      } else {
        var w = i.name;
        O[w] = i, g = w;
      }
      return !m && g && (D = g), g || !m && D;
    }, T = function(_, i) {
      if (U(_)) return _.clone();
      var u = typeof i == "object" ? i : {};
      return u.date = _, u.args = arguments, new Y(u);
    }, M = L;
    M.l = F, M.i = U, M.w = function(_, i) {
      return T(_, { locale: i.$L, utc: i.$u, x: i.$x, $offset: i.$offset });
    };
    var Y = function() {
      function _(u) {
        this.$L = F(u.locale, null, !0), this.parse(u), this.$x = this.$x || u.x || {}, this[G] = !0;
      }
      var i = _.prototype;
      return i.parse = function(u) {
        this.$d = function(m) {
          var g = m.date, y = m.utc;
          if (g === null) return /* @__PURE__ */ new Date(NaN);
          if (M.u(g)) return /* @__PURE__ */ new Date();
          if (g instanceof Date) return new Date(g);
          if (typeof g == "string" && !/Z$/i.test(g)) {
            var h = g.match(S);
            if (h) {
              var w = h[2] - 1 || 0, B = (h[7] || "0").substring(0, 3);
              return y ? new Date(Date.UTC(h[1], w, h[3] || 1, h[4] || 0, h[5] || 0, h[6] || 0, B)) : new Date(h[1], w, h[3] || 1, h[4] || 0, h[5] || 0, h[6] || 0, B);
            }
          }
          return new Date(g);
        }(u), this.init();
      }, i.init = function() {
        var u = this.$d;
        this.$y = u.getFullYear(), this.$M = u.getMonth(), this.$D = u.getDate(), this.$W = u.getDay(), this.$H = u.getHours(), this.$m = u.getMinutes(), this.$s = u.getSeconds(), this.$ms = u.getMilliseconds();
      }, i.$utils = function() {
        return M;
      }, i.isValid = function() {
        return this.$d.toString() !== d;
      }, i.isSame = function(u, m) {
        var g = T(u);
        return this.startOf(m) <= g && g <= this.endOf(m);
      }, i.isAfter = function(u, m) {
        return T(u) < this.startOf(m);
      }, i.isBefore = function(u, m) {
        return this.endOf(m) < T(u);
      }, i.$g = function(u, m, g) {
        return M.u(u) ? this[m] : this.set(g, u);
      }, i.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, i.valueOf = function() {
        return this.$d.getTime();
      }, i.startOf = function(u, m) {
        var g = this, y = !!M.u(m) || m, h = M.p(u), w = function(J, I) {
          var x = M.w(g.$u ? Date.UTC(g.$y, I, J) : new Date(g.$y, I, J), g);
          return y ? x : x.endOf(p);
        }, B = function(J, I) {
          return M.w(g.toDate()[J].apply(g.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(I)), g);
        }, N = this.$W, P = this.$M, $ = this.$D, q = "set" + (this.$u ? "UTC" : "");
        switch (h) {
          case A:
            return y ? w(1, 0) : w(31, 11);
          case v:
            return y ? w(1, P) : w(0, P + 1);
          case f:
            var W = this.$locale().weekStart || 0, Q = (N < W ? N + 7 : N) - W;
            return w(y ? $ - Q : $ + (6 - Q), P);
          case p:
          case C:
            return B(q + "Hours", 0);
          case c:
            return B(q + "Minutes", 1);
          case l:
            return B(q + "Seconds", 2);
          case o:
            return B(q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, i.endOf = function(u) {
        return this.startOf(u, !1);
      }, i.$set = function(u, m) {
        var g, y = M.p(u), h = "set" + (this.$u ? "UTC" : ""), w = (g = {}, g[p] = h + "Date", g[C] = h + "Date", g[v] = h + "Month", g[A] = h + "FullYear", g[c] = h + "Hours", g[l] = h + "Minutes", g[o] = h + "Seconds", g[s] = h + "Milliseconds", g)[y], B = y === p ? this.$D + (m - this.$W) : m;
        if (y === v || y === A) {
          var N = this.clone().set(C, 1);
          N.$d[w](B), N.init(), this.$d = N.set(C, Math.min(this.$D, N.daysInMonth())).$d;
        } else w && this.$d[w](B);
        return this.init(), this;
      }, i.set = function(u, m) {
        return this.clone().$set(u, m);
      }, i.get = function(u) {
        return this[M.p(u)]();
      }, i.add = function(u, m) {
        var g, y = this;
        u = Number(u);
        var h = M.p(m), w = function(P) {
          var $ = T(y);
          return M.w($.date($.date() + Math.round(P * u)), y);
        };
        if (h === v) return this.set(v, this.$M + u);
        if (h === A) return this.set(A, this.$y + u);
        if (h === p) return w(1);
        if (h === f) return w(7);
        var B = (g = {}, g[l] = r, g[c] = t, g[o] = n, g)[h] || 1, N = this.$d.getTime() + u * B;
        return M.w(N, this);
      }, i.subtract = function(u, m) {
        return this.add(-1 * u, m);
      }, i.format = function(u) {
        var m = this, g = this.$locale();
        if (!this.isValid()) return g.invalidDate || d;
        var y = u || "YYYY-MM-DDTHH:mm:ssZ", h = M.z(this), w = this.$H, B = this.$m, N = this.$M, P = g.weekdays, $ = g.months, q = g.meridiem, W = function(I, x, ee, le) {
          return I && (I[x] || I(m, y)) || ee[x].slice(0, le);
        }, Q = function(I) {
          return M.s(w % 12 || 12, I, "0");
        }, J = q || function(I, x, ee) {
          var le = I < 12 ? "AM" : "PM";
          return ee ? le.toLowerCase() : le;
        };
        return y.replace(E, function(I, x) {
          return x || function(ee) {
            switch (ee) {
              case "YY":
                return String(m.$y).slice(-2);
              case "YYYY":
                return M.s(m.$y, 4, "0");
              case "M":
                return N + 1;
              case "MM":
                return M.s(N + 1, 2, "0");
              case "MMM":
                return W(g.monthsShort, N, $, 3);
              case "MMMM":
                return W($, N);
              case "D":
                return m.$D;
              case "DD":
                return M.s(m.$D, 2, "0");
              case "d":
                return String(m.$W);
              case "dd":
                return W(g.weekdaysMin, m.$W, P, 2);
              case "ddd":
                return W(g.weekdaysShort, m.$W, P, 3);
              case "dddd":
                return P[m.$W];
              case "H":
                return String(w);
              case "HH":
                return M.s(w, 2, "0");
              case "h":
                return Q(1);
              case "hh":
                return Q(2);
              case "a":
                return J(w, B, !0);
              case "A":
                return J(w, B, !1);
              case "m":
                return String(B);
              case "mm":
                return M.s(B, 2, "0");
              case "s":
                return String(m.$s);
              case "ss":
                return M.s(m.$s, 2, "0");
              case "SSS":
                return M.s(m.$ms, 3, "0");
              case "Z":
                return h;
            }
            return null;
          }(I) || h.replace(":", "");
        });
      }, i.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, i.diff = function(u, m, g) {
        var y, h = this, w = M.p(m), B = T(u), N = (B.utcOffset() - this.utcOffset()) * r, P = this - B, $ = function() {
          return M.m(h, B);
        };
        switch (w) {
          case A:
            y = $() / 12;
            break;
          case v:
            y = $();
            break;
          case b:
            y = $() / 3;
            break;
          case f:
            y = (P - N) / 6048e5;
            break;
          case p:
            y = (P - N) / 864e5;
            break;
          case c:
            y = P / t;
            break;
          case l:
            y = P / r;
            break;
          case o:
            y = P / n;
            break;
          default:
            y = P;
        }
        return g ? y : M.a(y);
      }, i.daysInMonth = function() {
        return this.endOf(v).$D;
      }, i.$locale = function() {
        return O[this.$L];
      }, i.locale = function(u, m) {
        if (!u) return this.$L;
        var g = this.clone(), y = F(u, m, !0);
        return y && (g.$L = y), g;
      }, i.clone = function() {
        return M.w(this.$d, this);
      }, i.toDate = function() {
        return new Date(this.valueOf());
      }, i.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, i.toISOString = function() {
        return this.$d.toISOString();
      }, i.toString = function() {
        return this.$d.toUTCString();
      }, _;
    }(), Ce = Y.prototype;
    return T.prototype = Ce, [["$ms", s], ["$s", o], ["$m", l], ["$H", c], ["$W", p], ["$M", v], ["$y", A], ["$D", C]].forEach(function(_) {
      Ce[_[1]] = function(i) {
        return this.$g(i, _[0], _[1]);
      };
    }), T.extend = function(_, i) {
      return _.$i || (_(i, Y, T), _.$i = !0), T;
    }, T.locale = F, T.isDayjs = U, T.unix = function(_) {
      return T(1e3 * _);
    }, T.en = O[D], T.Ls = O, T.p = {}, T;
  });
})(bt);
var Ct = bt.exports;
const pe = /* @__PURE__ */ ae(Ct);
var _t = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r) {
      var t = r.prototype, s = t.format;
      t.format = function(o) {
        var l = this, c = this.$locale();
        if (!this.isValid()) return s.bind(this)(o);
        var p = this.$utils(), f = (o || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(v) {
          switch (v) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return c.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return c.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return p.s(l.week(), v === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return p.s(l.isoWeek(), v === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return p.s(String(l.$H === 0 ? 24 : l.$H), v === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return v;
          }
        });
        return s.bind(this)(f);
      };
    };
  });
})(_t);
var Kg = _t.exports;
const kg = /* @__PURE__ */ ae(Kg);
var At = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r, t) {
      r.prototype.isBetween = function(s, o, l, c) {
        var p = t(s), f = t(o), v = (c = c || "()")[0] === "(", b = c[1] === ")";
        return (v ? this.isAfter(p, l) : !this.isBefore(p, l)) && (b ? this.isBefore(f, l) : !this.isAfter(f, l)) || (v ? this.isBefore(p, l) : !this.isAfter(p, l)) && (b ? this.isAfter(f, l) : !this.isBefore(f, l));
      };
    };
  });
})(At);
var Hg = At.exports;
const Yg = /* @__PURE__ */ ae(Hg);
var vt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r) {
      r.prototype.isSameOrAfter = function(t, s) {
        return this.isSame(t, s) || this.isAfter(t, s);
      };
    };
  });
})(vt);
var xg = vt.exports;
const jg = /* @__PURE__ */ ae(xg);
var St = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r) {
      r.prototype.isSameOrBefore = function(t, s) {
        return this.isSame(t, s) || this.isBefore(t, s);
      };
    };
  });
})(St);
var Vg = St.exports;
const Zg = /* @__PURE__ */ ae(Vg);
var Mt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, t, s) {
      var o = t.prototype, l = o.format;
      s.en.formats = n, o.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var p = this.$locale().formats, f = function(v, b) {
          return v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(A, C, d) {
            var S = d && d.toUpperCase();
            return C || b[d] || n[d] || b[S].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(E, R, z) {
              return R || z.slice(1);
            });
          });
        }(c, p === void 0 ? {} : p);
        return l.call(this, f);
      };
    };
  });
})(Mt);
var Wg = Mt.exports;
const Jg = /* @__PURE__ */ ae(Wg);
var Dt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r, t) {
      var s = function(o, l) {
        if (!l || !l.length || l.length === 1 && !l[0] || l.length === 1 && Array.isArray(l[0]) && !l[0].length) return null;
        var c;
        l.length === 1 && l[0].length > 0 && (l = l[0]), c = (l = l.filter(function(f) {
          return f;
        }))[0];
        for (var p = 1; p < l.length; p += 1) l[p].isValid() && !l[p][o](c) || (c = l[p]);
        return c;
      };
      t.max = function() {
        var o = [].slice.call(arguments, 0);
        return s("isAfter", o);
      }, t.min = function() {
        var o = [].slice.call(arguments, 0);
        return s("isBefore", o);
      };
    };
  });
})(Dt);
var qg = Dt.exports;
const Xg = /* @__PURE__ */ ae(qg);
var wt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return function(n, r, t) {
      n = n || {};
      var s = r.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function l(p, f, v, b) {
        return s.fromToBase(p, f, v, b);
      }
      t.en.relativeTime = o, s.fromToBase = function(p, f, v, b, A) {
        for (var C, d, S, E = v.$locale().relativeTime || o, R = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], z = R.length, L = 0; L < z; L += 1) {
          var D = R[L];
          D.d && (C = b ? t(p).diff(v, D.d, !0) : v.diff(p, D.d, !0));
          var O = (n.rounding || Math.round)(Math.abs(C));
          if (S = C > 0, O <= D.r || !D.r) {
            O <= 1 && L > 0 && (D = R[L - 1]);
            var G = E[D.l];
            A && (O = A("" + O)), d = typeof G == "string" ? G.replace("%d", O) : G(O, f, D.l, S);
            break;
          }
        }
        if (f) return d;
        var U = S ? E.future : E.past;
        return typeof U == "function" ? U(d) : U.replace("%s", d);
      }, s.to = function(p, f) {
        return l(p, f, this, !0);
      }, s.from = function(p, f) {
        return l(p, f, this);
      };
      var c = function(p) {
        return p.$u ? t.utc() : t();
      };
      s.toNow = function(p) {
        return this.to(c(this), p);
      }, s.fromNow = function(p) {
        return this.from(c(this), p);
      };
    };
  });
})(wt);
var Qg = wt.exports;
const em = /* @__PURE__ */ ae(Qg);
var zt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
    return function(t, s, o) {
      var l, c = function(b, A, C) {
        C === void 0 && (C = {});
        var d = new Date(b), S = function(E, R) {
          R === void 0 && (R = {});
          var z = R.timeZoneName || "short", L = E + "|" + z, D = r[L];
          return D || (D = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: E, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: z }), r[L] = D), D;
        }(A, C);
        return S.formatToParts(d);
      }, p = function(b, A) {
        for (var C = c(b, A), d = [], S = 0; S < C.length; S += 1) {
          var E = C[S], R = E.type, z = E.value, L = n[R];
          L >= 0 && (d[L] = parseInt(z, 10));
        }
        var D = d[3], O = D === 24 ? 0 : D, G = d[0] + "-" + d[1] + "-" + d[2] + " " + O + ":" + d[4] + ":" + d[5] + ":000", U = +b;
        return (o.utc(G).valueOf() - (U -= U % 1e3)) / 6e4;
      }, f = s.prototype;
      f.tz = function(b, A) {
        b === void 0 && (b = l);
        var C, d = this.utcOffset(), S = this.toDate(), E = S.toLocaleString("en-US", { timeZone: b }), R = Math.round((S - new Date(E)) / 1e3 / 60), z = 15 * -Math.round(S.getTimezoneOffset() / 15) - R;
        if (!Number(z)) C = this.utcOffset(0, A);
        else if (C = o(E, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(z, !0), A) {
          var L = C.utcOffset();
          C = C.add(d - L, "minute");
        }
        return C.$x.$timezone = b, C;
      }, f.offsetName = function(b) {
        var A = this.$x.$timezone || o.tz.guess(), C = c(this.valueOf(), A, { timeZoneName: b }).find(function(d) {
          return d.type.toLowerCase() === "timezonename";
        });
        return C && C.value;
      };
      var v = f.startOf;
      f.startOf = function(b, A) {
        if (!this.$x || !this.$x.$timezone) return v.call(this, b, A);
        var C = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return v.call(C, b, A).tz(this.$x.$timezone, !0);
      }, o.tz = function(b, A, C) {
        var d = C && A, S = C || A || l, E = p(+o(), S);
        if (typeof b != "string") return o(b).tz(S);
        var R = function(O, G, U) {
          var F = O - 60 * G * 1e3, T = p(F, U);
          if (G === T) return [F, G];
          var M = p(F -= 60 * (T - G) * 1e3, U);
          return T === M ? [F, T] : [O - 60 * Math.min(T, M) * 1e3, Math.max(T, M)];
        }(o.utc(b, d).valueOf(), E, S), z = R[0], L = R[1], D = o(z).utcOffset(L);
        return D.$x.$timezone = S, D;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(b) {
        l = b;
      };
    };
  });
})(zt);
var am = zt.exports;
const nm = /* @__PURE__ */ ae(am);
var Tt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, t = /([+-]|\d\d)/g;
    return function(s, o, l) {
      var c = o.prototype;
      l.utc = function(d) {
        var S = { date: d, utc: !0, args: arguments };
        return new o(S);
      }, c.utc = function(d) {
        var S = l(this.toDate(), { locale: this.$L, utc: !0 });
        return d ? S.add(this.utcOffset(), n) : S;
      }, c.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var p = c.parse;
      c.parse = function(d) {
        d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), p.call(this, d);
      };
      var f = c.init;
      c.init = function() {
        if (this.$u) {
          var d = this.$d;
          this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
        } else f.call(this);
      };
      var v = c.utcOffset;
      c.utcOffset = function(d, S) {
        var E = this.$utils().u;
        if (E(d)) return this.$u ? 0 : E(this.$offset) ? v.call(this) : this.$offset;
        if (typeof d == "string" && (d = function(D) {
          D === void 0 && (D = "");
          var O = D.match(r);
          if (!O) return null;
          var G = ("" + O[0]).match(t) || ["-", 0, 0], U = G[0], F = 60 * +G[1] + +G[2];
          return F === 0 ? 0 : U === "+" ? F : -F;
        }(d), d === null)) return this;
        var R = Math.abs(d) <= 16 ? 60 * d : d, z = this;
        if (S) return z.$offset = R, z.$u = d === 0, z;
        if (d !== 0) {
          var L = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (z = this.local().add(R + L, n)).$offset = R, z.$x.$localOffset = L;
        } else z = this.utc();
        return z;
      };
      var b = c.format;
      c.format = function(d) {
        var S = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return b.call(this, S);
      }, c.valueOf = function() {
        var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * d;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var A = c.toDate;
      c.toDate = function(d) {
        return d === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : A.call(this);
      };
      var C = c.diff;
      c.diff = function(d, S, E) {
        if (d && this.$u === d.$u) return C.call(this, d, S, E);
        var R = this.local(), z = l(d).local();
        return C.call(R, z, S, E);
      };
    };
  });
})(Tt);
var rm = Tt.exports;
const tm = /* @__PURE__ */ ae(rm);
var im = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r(Ct);
  })(V, function(n) {
    function r(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var t = r(n), s = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
      return "" + o + (o === 1 ? "er" : "");
    } };
    return t.default.locale(s, null, !0), s;
  });
})(im);
var om = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(V, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
      var r = ["th", "st", "nd", "rd"], t = n % 100;
      return "[" + n + (r[(t - 20) % 10] || r[t] || r[0]) + "]";
    } };
  });
})(om);
pe.extend(kg);
pe.extend(Yg);
pe.extend(jg);
pe.extend(Zg);
pe.extend(Jg);
pe.extend(Xg);
pe.extend(em);
pe.extend(nm);
pe.extend(tm);
const j = [];
for (let e = 0; e < 256; ++e)
  j.push((e + 256).toString(16).slice(1));
function sm(e, a = 0) {
  return (j[e[a + 0]] + j[e[a + 1]] + j[e[a + 2]] + j[e[a + 3]] + "-" + j[e[a + 4]] + j[e[a + 5]] + "-" + j[e[a + 6]] + j[e[a + 7]] + "-" + j[e[a + 8]] + j[e[a + 9]] + "-" + j[e[a + 10]] + j[e[a + 11]] + j[e[a + 12]] + j[e[a + 13]] + j[e[a + 14]] + j[e[a + 15]]).toLowerCase();
}
let Sa;
const lm = new Uint8Array(16);
function um() {
  if (!Sa) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Sa = crypto.getRandomValues.bind(crypto);
  }
  return Sa(lm);
}
const cm = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), rr = { randomUUID: cm };
function dm(e, a, n) {
  var r;
  if (rr.randomUUID && !e)
    return rr.randomUUID();
  e = e || {};
  const t = e.random ?? ((r = e.rng) == null ? void 0 : r.call(e)) ?? um();
  if (t.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, sm(t);
}
const gm = 1500, mm = class $e {
  constructor() {
    We(this, "defaultOptions", {
      callCount: 1,
      interval: gm,
      maxCallCount: 20,
      minCallCount: 2
    }), We(this, "pollings", {}), We(this, "events", {
      complete: () => {
      },
      data: () => {
      },
      error: () => {
      }
    });
  }
  static getInstance() {
    return $e.instance || ($e.instance = new $e()), $e.instance;
  }
  poll(a, n) {
    const r = this.buildPollerOptions(n);
    return this.storeCurrentPolling(r), this.isActivePoller(r) && a().then((t) => this.onRequest(t, a, r)).catch((t) => {
      this.dispatch("error", t);
    }), this;
  }
  on(a, n) {
    this.events[a] = n;
  }
  dispatch(a, n) {
    this.events[a](n);
  }
  async onRequest(a, n, r) {
    const t = Ga(a ?? {}, ft.Camel);
    this.isActivePoller(r) && (this.isInProgress(t) && r.callCount && r.maxCallCount && r.callCount < r.maxCallCount || !this.isInProgress(t) && r.callCount && r.minCallCount && r.callCount < r.minCallCount ? (this.isInProgress(t) || (t.meta = t.meta || {}, t.meta.status = "IN_PROGRESS"), r.callCount += 1, this.dispatch("data", t), r.interval && await this.pause(r), this.poll(n, r)) : this.isInProgress(t) ? (t.meta = t.meta || {}, t.meta.status = "COMPLETE", this.onComplete(t, r)) : this.onComplete(t, r));
  }
  onComplete(a, n) {
    this.dispatch("data", a), this.dispatch("complete", a), this.removeCurrentPolling(n);
  }
  isInProgress(a) {
    var n;
    return (((n = a == null ? void 0 : a.meta) == null ? void 0 : n.status) ?? "") !== "COMPLETE";
  }
  buildPollerOptions(a) {
    const n = Object.entries(a).reduce(
      (r, [t, s]) => {
        if (s !== void 0) {
          const o = t;
          r[o] = s;
        }
        return r;
      },
      {}
    );
    return {
      ...this.defaultOptions,
      ...n
    };
  }
  storeCurrentPolling(a) {
    a.type && !a.uuid && (a.uuid = dm(), this.pollings[a.type] = a.uuid);
  }
  isActivePoller(a) {
    return a.type ? !!this.pollings[a.type] && this.pollings[a.type] === a.uuid : !0;
  }
  pause(a) {
    return new Promise((n) => {
      setTimeout(n, a.interval);
    });
  }
  removeCurrentPolling(a) {
    a.type && this.pollings[a.type] && delete this.pollings[a.type];
  }
};
We(mm, "instance", null);
var tr = { exports: {} };
(function(e, a) {
  var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof V < "u" && V, r = function() {
    function s() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }
    return s.prototype = n, new s();
  }();
  (function(s) {
    (function(o) {
      var l = typeof s < "u" && s || typeof self < "u" && self || // eslint-disable-next-line no-undef
      typeof V < "u" && V || {}, c = {
        searchParams: "URLSearchParams" in l,
        iterable: "Symbol" in l && "iterator" in Symbol,
        blob: "FileReader" in l && "Blob" in l && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in l,
        arrayBuffer: "ArrayBuffer" in l
      };
      function p(i) {
        return i && DataView.prototype.isPrototypeOf(i);
      }
      if (c.arrayBuffer)
        var f = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], v = ArrayBuffer.isView || function(i) {
          return i && f.indexOf(Object.prototype.toString.call(i)) > -1;
        };
      function b(i) {
        if (typeof i != "string" && (i = String(i)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(i) || i === "")
          throw new TypeError('Invalid character in header field name: "' + i + '"');
        return i.toLowerCase();
      }
      function A(i) {
        return typeof i != "string" && (i = String(i)), i;
      }
      function C(i) {
        var u = {
          next: function() {
            var m = i.shift();
            return { done: m === void 0, value: m };
          }
        };
        return c.iterable && (u[Symbol.iterator] = function() {
          return u;
        }), u;
      }
      function d(i) {
        this.map = {}, i instanceof d ? i.forEach(function(u, m) {
          this.append(m, u);
        }, this) : Array.isArray(i) ? i.forEach(function(u) {
          if (u.length != 2)
            throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + u.length);
          this.append(u[0], u[1]);
        }, this) : i && Object.getOwnPropertyNames(i).forEach(function(u) {
          this.append(u, i[u]);
        }, this);
      }
      d.prototype.append = function(i, u) {
        i = b(i), u = A(u);
        var m = this.map[i];
        this.map[i] = m ? m + ", " + u : u;
      }, d.prototype.delete = function(i) {
        delete this.map[b(i)];
      }, d.prototype.get = function(i) {
        return i = b(i), this.has(i) ? this.map[i] : null;
      }, d.prototype.has = function(i) {
        return this.map.hasOwnProperty(b(i));
      }, d.prototype.set = function(i, u) {
        this.map[b(i)] = A(u);
      }, d.prototype.forEach = function(i, u) {
        for (var m in this.map)
          this.map.hasOwnProperty(m) && i.call(u, this.map[m], m, this);
      }, d.prototype.keys = function() {
        var i = [];
        return this.forEach(function(u, m) {
          i.push(m);
        }), C(i);
      }, d.prototype.values = function() {
        var i = [];
        return this.forEach(function(u) {
          i.push(u);
        }), C(i);
      }, d.prototype.entries = function() {
        var i = [];
        return this.forEach(function(u, m) {
          i.push([m, u]);
        }), C(i);
      }, c.iterable && (d.prototype[Symbol.iterator] = d.prototype.entries);
      function S(i) {
        if (!i._noBody) {
          if (i.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          i.bodyUsed = !0;
        }
      }
      function E(i) {
        return new Promise(function(u, m) {
          i.onload = function() {
            u(i.result);
          }, i.onerror = function() {
            m(i.error);
          };
        });
      }
      function R(i) {
        var u = new FileReader(), m = E(u);
        return u.readAsArrayBuffer(i), m;
      }
      function z(i) {
        var u = new FileReader(), m = E(u), g = /charset=([A-Za-z0-9_-]+)/.exec(i.type), y = g ? g[1] : "utf-8";
        return u.readAsText(i, y), m;
      }
      function L(i) {
        for (var u = new Uint8Array(i), m = new Array(u.length), g = 0; g < u.length; g++)
          m[g] = String.fromCharCode(u[g]);
        return m.join("");
      }
      function D(i) {
        if (i.slice)
          return i.slice(0);
        var u = new Uint8Array(i.byteLength);
        return u.set(new Uint8Array(i)), u.buffer;
      }
      function O() {
        return this.bodyUsed = !1, this._initBody = function(i) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = i, i ? typeof i == "string" ? this._bodyText = i : c.blob && Blob.prototype.isPrototypeOf(i) ? this._bodyBlob = i : c.formData && FormData.prototype.isPrototypeOf(i) ? this._bodyFormData = i : c.searchParams && URLSearchParams.prototype.isPrototypeOf(i) ? this._bodyText = i.toString() : c.arrayBuffer && c.blob && p(i) ? (this._bodyArrayBuffer = D(i.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : c.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(i) || v(i)) ? this._bodyArrayBuffer = D(i) : this._bodyText = i = Object.prototype.toString.call(i) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof i == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : c.searchParams && URLSearchParams.prototype.isPrototypeOf(i) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, c.blob && (this.blob = function() {
          var i = S(this);
          if (i)
            return i;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }), this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var i = S(this);
            return i || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else {
            if (c.blob)
              return this.blob().then(R);
            throw new Error("could not read as ArrayBuffer");
          }
        }, this.text = function() {
          var i = S(this);
          if (i)
            return i;
          if (this._bodyBlob)
            return z(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(L(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, c.formData && (this.formData = function() {
          return this.text().then(T);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var G = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
      function U(i) {
        var u = i.toUpperCase();
        return G.indexOf(u) > -1 ? u : i;
      }
      function F(i, u) {
        if (!(this instanceof F))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        u = u || {};
        var m = u.body;
        if (i instanceof F) {
          if (i.bodyUsed)
            throw new TypeError("Already read");
          this.url = i.url, this.credentials = i.credentials, u.headers || (this.headers = new d(i.headers)), this.method = i.method, this.mode = i.mode, this.signal = i.signal, !m && i._bodyInit != null && (m = i._bodyInit, i.bodyUsed = !0);
        } else
          this.url = String(i);
        if (this.credentials = u.credentials || this.credentials || "same-origin", (u.headers || !this.headers) && (this.headers = new d(u.headers)), this.method = U(u.method || this.method || "GET"), this.mode = u.mode || this.mode || null, this.signal = u.signal || this.signal || function() {
          if ("AbortController" in l) {
            var h = new AbortController();
            return h.signal;
          }
        }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && m)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(m), (this.method === "GET" || this.method === "HEAD") && (u.cache === "no-store" || u.cache === "no-cache")) {
          var g = /([?&])_=[^&]*/;
          if (g.test(this.url))
            this.url = this.url.replace(g, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var y = /\?/;
            this.url += (y.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      F.prototype.clone = function() {
        return new F(this, { body: this._bodyInit });
      };
      function T(i) {
        var u = new FormData();
        return i.trim().split("&").forEach(function(m) {
          if (m) {
            var g = m.split("="), y = g.shift().replace(/\+/g, " "), h = g.join("=").replace(/\+/g, " ");
            u.append(decodeURIComponent(y), decodeURIComponent(h));
          }
        }), u;
      }
      function M(i) {
        var u = new d(), m = i.replace(/\r?\n[\t ]+/g, " ");
        return m.split("\r").map(function(g) {
          return g.indexOf(`
`) === 0 ? g.substr(1, g.length) : g;
        }).forEach(function(g) {
          var y = g.split(":"), h = y.shift().trim();
          if (h) {
            var w = y.join(":").trim();
            try {
              u.append(h, w);
            } catch (B) {
              console.warn("Response " + B.message);
            }
          }
        }), u;
      }
      O.call(F.prototype);
      function Y(i, u) {
        if (!(this instanceof Y))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (u || (u = {}), this.type = "default", this.status = u.status === void 0 ? 200 : u.status, this.status < 200 || this.status > 599)
          throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300, this.statusText = u.statusText === void 0 ? "" : "" + u.statusText, this.headers = new d(u.headers), this.url = u.url || "", this._initBody(i);
      }
      O.call(Y.prototype), Y.prototype.clone = function() {
        return new Y(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new d(this.headers),
          url: this.url
        });
      }, Y.error = function() {
        var i = new Y(null, { status: 200, statusText: "" });
        return i.ok = !1, i.status = 0, i.type = "error", i;
      };
      var Ce = [301, 302, 303, 307, 308];
      Y.redirect = function(i, u) {
        if (Ce.indexOf(u) === -1)
          throw new RangeError("Invalid status code");
        return new Y(null, { status: u, headers: { location: i } });
      }, o.DOMException = l.DOMException;
      try {
        new o.DOMException();
      } catch {
        o.DOMException = function(i, u) {
          this.message = i, this.name = u;
          var m = Error(i);
          this.stack = m.stack;
        }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
      }
      function _(i, u) {
        return new Promise(function(m, g) {
          var y = new F(i, u);
          if (y.signal && y.signal.aborted)
            return g(new o.DOMException("Aborted", "AbortError"));
          var h = new XMLHttpRequest();
          function w() {
            h.abort();
          }
          h.onload = function() {
            var P = {
              statusText: h.statusText,
              headers: M(h.getAllResponseHeaders() || "")
            };
            y.url.indexOf("file://") === 0 && (h.status < 200 || h.status > 599) ? P.status = 200 : P.status = h.status, P.url = "responseURL" in h ? h.responseURL : P.headers.get("X-Request-URL");
            var $ = "response" in h ? h.response : h.responseText;
            setTimeout(function() {
              m(new Y($, P));
            }, 0);
          }, h.onerror = function() {
            setTimeout(function() {
              g(new TypeError("Network request failed"));
            }, 0);
          }, h.ontimeout = function() {
            setTimeout(function() {
              g(new TypeError("Network request timed out"));
            }, 0);
          }, h.onabort = function() {
            setTimeout(function() {
              g(new o.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function B(P) {
            try {
              return P === "" && l.location.href ? l.location.href : P;
            } catch {
              return P;
            }
          }
          if (h.open(y.method, B(y.url), !0), y.credentials === "include" ? h.withCredentials = !0 : y.credentials === "omit" && (h.withCredentials = !1), "responseType" in h && (c.blob ? h.responseType = "blob" : c.arrayBuffer && (h.responseType = "arraybuffer")), u && typeof u.headers == "object" && !(u.headers instanceof d || l.Headers && u.headers instanceof l.Headers)) {
            var N = [];
            Object.getOwnPropertyNames(u.headers).forEach(function(P) {
              N.push(b(P)), h.setRequestHeader(P, A(u.headers[P]));
            }), y.headers.forEach(function(P, $) {
              N.indexOf($) === -1 && h.setRequestHeader($, P);
            });
          } else
            y.headers.forEach(function(P, $) {
              h.setRequestHeader($, P);
            });
          y.signal && (y.signal.addEventListener("abort", w), h.onreadystatechange = function() {
            h.readyState === 4 && y.signal.removeEventListener("abort", w);
          }), h.send(typeof y._bodyInit > "u" ? null : y._bodyInit);
        });
      }
      return _.polyfill = !0, l.fetch || (l.fetch = _, l.Headers = d, l.Request = F, l.Response = Y), o.Headers = d, o.Request = F, o.Response = Y, o.fetch = _, o;
    })({});
  })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var t = n.fetch ? n : r;
  a = t.fetch, a.default = t.fetch, a.fetch = t.fetch, a.Headers = t.Headers, a.Request = t.Request, a.Response = t.Response, e.exports = a;
})(tr, tr.exports);
const Ap = {
  adultCount: 2,
  checkInDate: "2023-05-16",
  checkOutDate: "2023-05-20",
  hotelRoomOffer: {
    breakfastCount: 0,
    breakfastOption: Mg.NotIncluded,
    breakfastUnitPrice: 0,
    cancellationPolicies: [
      {
        dateFrom: "2023-05-16T09:33:52Z",
        dateTo: "2023-05-16T09:34:00Z",
        penaltyPercentage: 0
      },
      {
        dateFrom: "2023-05-16T09:34:00Z",
        dateTo: "2023-05-20T22:00:00Z",
        penaltyPercentage: 100
      }
    ],
    count: 1,
    currency: "EUR",
    hotelId: "B2T7",
    hotelRooms: [
      {
        amenities: ["Air conditioning", "Bar/lounge"],
        beds: [
          [
            {
              count: 1,
              name: "double",
              occupancy: 2
            }
          ]
        ],
        bedsPretty: "1× double bed",
        count: 1,
        description: "double room",
        highresImages: !0,
        id: "f4e3209212c3",
        imageIndexes: [7, 9, 10, 1, 3],
        lowresImages: !0,
        occupancy: 1,
        richDescription: "<p><strong>1 Double Bed</strong></p><p>194 sq feet (18 sq meters)</p><br/><p><b>Internet</b> - Free WiFi </p><p><b>Entertainment</b> - 32-cm flat-screen TV with premium channels</p><p><b>Food & Drink</b> - Coffee/tea maker, electric kettle, room service, and free bottled water</p><p><b>Sleep</b> - Premium bedding and blackout drapes/curtains </p><p><b>Bathroom</b> - Private bathroom, shower, and rainfall showerhead</p><p><b>Practical</b> - Safe, desk, and phone; free cribs/infant beds available on request</p><p><b>Comfort</b> - Daily housekeeping and climate-controlled heating and air conditioning</p><p><b>Accessibility</b> - Wheelchair accessible</p><p>Non-Smoking</p>&nbsp;",
        roomSquareFeet: 194,
        roomSquareMeters: 18,
        thumbImages: !0
      }
    ],
    packageType: "REGULAR",
    price: 29300,
    sourceMarket: "FR",
    tags: [],
    taxIncludedPrice: 29300,
    taxes: [],
    type: "PACKAGE"
  }
}, vp = {
  adultCount: {
    control: { type: "number" },
    name: "adult-count"
  },
  checkInDate: {
    control: { type: "date" },
    name: "check-in-date"
  },
  checkOutDate: {
    control: { type: "date" },
    name: "check-out-date"
  },
  hotelRoomOffer: {
    control: { type: "object" },
    name: "hotel-room-offer"
  }
}, Sp = {
  token: ""
}, Mp = {
  token: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span> Token of a previously created **booking**. This token is returned by <b><a href="https://booking-api.revolugo.com/v1/documentation#tag/8-Retrieve-a-Booking/operation/getV1BookingsTokenPublic" target="_blank" >Retrieve a Booking</a></b> or <b><a href="https://booking-api.revolugo.com/v1/documentation#tag/8-Retrieve-a-Booking/operation/getV1BookingsId" target="_blank" >Retrieve a Booking</a></b> endpoints. This token allows your customer to securely access his booking. It has a lifetime of 10 minutes.',
    name: "token",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, Dp = {
  token: ""
}, wp = {
  token: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span>',
    name: "token"
  }
}, pm = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), hm = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), fm = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), ym = /[^\p{L}\d]+/giu, ir = "$1\0$2", or = "";
function Rt(e) {
  let a = e.trim();
  a = a.replace(pm, ir).replace(hm, ir), a = a.replace(ym, "\0");
  let n = 0, r = a.length;
  for (; a.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; a.charAt(r - 1) === "\0"; )
    r--;
  return a.slice(n, r).split(/\0/g);
}
function bm(e) {
  const a = Rt(e);
  for (let n = 0; n < a.length; n++) {
    const r = a[n], t = fm.exec(r);
    if (t) {
      const s = t.index + (t[1] ?? t[2]).length;
      a.splice(n, 1, r.slice(0, s), r.slice(s));
    }
  }
  return a;
}
function Pt(e, a) {
  const [n, r, t] = da(e, a);
  return n + r.map(ca(a == null ? void 0 : a.locale)).join((a == null ? void 0 : a.delimiter) ?? " ") + t;
}
function Cm(e, a) {
  const [n, r, t] = da(e, a), s = ca(a == null ? void 0 : a.locale), o = ln(a == null ? void 0 : a.locale), l = a != null && a.mergeAmbiguousCharacters ? un(s, o) : Ot(s, o);
  return n + r.map((c, p) => p === 0 ? s(c) : l(c, p)).join((a == null ? void 0 : a.delimiter) ?? "") + t;
}
function _m(e, a) {
  const [n, r, t] = da(e, a), s = ca(a == null ? void 0 : a.locale), o = ln(a == null ? void 0 : a.locale), l = a != null && a.mergeAmbiguousCharacters ? un(s, o) : Ot(s, o);
  return n + r.map(l).join((a == null ? void 0 : a.delimiter) ?? "") + t;
}
function Am(e, a) {
  const [n, r, t] = da(e, a), s = ca(a == null ? void 0 : a.locale), o = ln(a == null ? void 0 : a.locale);
  return n + r.map(un(s, o)).join((a == null ? void 0 : a.delimiter) ?? " ") + t;
}
function Et(e, a) {
  return Pt(e, { delimiter: "-", ...a });
}
function vm(e, a) {
  return Pt(e, { delimiter: "_", ...a });
}
function ca(e) {
  return e === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e);
}
function ln(e) {
  return e === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e);
}
function un(e, a) {
  return (n) => `${a(n[0])}${e(n.slice(1))}`;
}
function Ot(e, a) {
  return (n, r) => {
    const t = n[0];
    return (r > 0 && t >= "0" && t <= "9" ? "_" + t : a(t)) + e(n.slice(1));
  };
}
function da(e, a = {}) {
  const n = a.split ?? (a.separateNumbers ? bm : Rt), r = a.prefixCharacters ?? or, t = a.suffixCharacters ?? or;
  let s = 0, o = e.length;
  for (; s < e.length; ) {
    const l = e.charAt(s);
    if (!r.includes(l))
      break;
    s++;
  }
  for (; o > s; ) {
    const l = o - 1, c = e.charAt(l);
    if (!t.includes(c))
      break;
    o = l;
  }
  return [
    e.slice(0, s),
    n(e.slice(s, o)),
    e.slice(o)
  ];
}
var X = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bt = { exports: {} };
(function(e, a) {
  (function(n, r, t) {
    e.exports = t(), e.exports.default = t();
  })("slugify", X, function() {
    var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), r = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
    function t(s, o) {
      if (typeof s != "string")
        throw new Error("slugify: string argument expected");
      o = typeof o == "string" ? { replacement: o } : o || {};
      var l = r[o.locale] || {}, c = o.replacement === void 0 ? "-" : o.replacement, p = o.trim === void 0 ? !0 : o.trim, f = s.normalize().split("").reduce(function(v, b) {
        var A = l[b];
        return A === void 0 && (A = n[b]), A === void 0 && (A = b), A === c && (A = " "), v + A.replace(o.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
      }, "");
      return o.strict && (f = f.replace(/[^A-Za-z0-9\s]/g, "")), p && (f = f.trim()), f = f.replace(/\s+/g, c), o.lower && (f = f.toLowerCase()), f;
    }
    return t.extend = function(s) {
      Object.assign(n, s);
    }, t;
  });
})(Bt);
var Sm = Bt.exports;
const Mm = /* @__PURE__ */ ne(Sm);
function Dm(e) {
  return Mm(Et(e), {
    lower: !0,
    strict: !0
  });
}
var wm = /* @__PURE__ */ ((e) => (e.Camel = "camelCase", e.Capital = "capitalCase", e.Param = "paramCase", e.Pascal = "pascalCase", e.Slug = "slugCase", e.Snake = "snakeCase", e))(wm || {});
const Ua = {
  camelCase: Cm,
  capitalCase: Am,
  paramCase: Et,
  pascalCase: _m,
  slugCase: Dm,
  snakeCase: vm
};
function zp(e, a) {
  return Array.isArray(e) ? e.map(
    (n) => Ua[a](n)
  ) : Ua[a](e);
}
function zm(e, a) {
  return e.some(
    (n) => typeof n == "string" ? n === a : n.test(a)
  );
}
function Tm(e) {
  return e === Object(e) && !Array.isArray(e) && typeof e != "function";
}
function sr(e, a, n = { deep: !0 }) {
  return Tm(e) ? Object.keys(e).reduce((r, t) => {
    const s = n != null && n.exclude && zm(n.exclude, t) ? t : Ua[a](t);
    return r[s] = n.deep ? sr(e[t], a, n) : e[t], r;
  }, {}) : Array.isArray(e) ? e.map((r) => sr(r, a, n)) : e;
}
var Lt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    var n = 1e3, r = 6e4, t = 36e5, s = "millisecond", o = "second", l = "minute", c = "hour", p = "day", f = "week", v = "month", b = "quarter", A = "year", C = "date", d = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, R = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(_) {
      var i = ["th", "st", "nd", "rd"], u = _ % 100;
      return "[" + _ + (i[(u - 20) % 10] || i[u] || i[0]) + "]";
    } }, z = function(_, i, u) {
      var m = String(_);
      return !m || m.length >= i ? _ : "" + Array(i + 1 - m.length).join(u) + _;
    }, L = { s: z, z: function(_) {
      var i = -_.utcOffset(), u = Math.abs(i), m = Math.floor(u / 60), g = u % 60;
      return (i <= 0 ? "+" : "-") + z(m, 2, "0") + ":" + z(g, 2, "0");
    }, m: function _(i, u) {
      if (i.date() < u.date()) return -_(u, i);
      var m = 12 * (u.year() - i.year()) + (u.month() - i.month()), g = i.clone().add(m, v), y = u - g < 0, h = i.clone().add(m + (y ? -1 : 1), v);
      return +(-(m + (u - g) / (y ? g - h : h - g)) || 0);
    }, a: function(_) {
      return _ < 0 ? Math.ceil(_) || 0 : Math.floor(_);
    }, p: function(_) {
      return { M: v, y: A, w: f, d: p, D: C, h: c, m: l, s: o, ms: s, Q: b }[_] || String(_ || "").toLowerCase().replace(/s$/, "");
    }, u: function(_) {
      return _ === void 0;
    } }, D = "en", O = {};
    O[D] = R;
    var G = "$isDayjsObject", U = function(_) {
      return _ instanceof Y || !(!_ || !_[G]);
    }, F = function _(i, u, m) {
      var g;
      if (!i) return D;
      if (typeof i == "string") {
        var y = i.toLowerCase();
        O[y] && (g = y), u && (O[y] = u, g = y);
        var h = i.split("-");
        if (!g && h.length > 1) return _(h[0]);
      } else {
        var w = i.name;
        O[w] = i, g = w;
      }
      return !m && g && (D = g), g || !m && D;
    }, T = function(_, i) {
      if (U(_)) return _.clone();
      var u = typeof i == "object" ? i : {};
      return u.date = _, u.args = arguments, new Y(u);
    }, M = L;
    M.l = F, M.i = U, M.w = function(_, i) {
      return T(_, { locale: i.$L, utc: i.$u, x: i.$x, $offset: i.$offset });
    };
    var Y = function() {
      function _(u) {
        this.$L = F(u.locale, null, !0), this.parse(u), this.$x = this.$x || u.x || {}, this[G] = !0;
      }
      var i = _.prototype;
      return i.parse = function(u) {
        this.$d = function(m) {
          var g = m.date, y = m.utc;
          if (g === null) return /* @__PURE__ */ new Date(NaN);
          if (M.u(g)) return /* @__PURE__ */ new Date();
          if (g instanceof Date) return new Date(g);
          if (typeof g == "string" && !/Z$/i.test(g)) {
            var h = g.match(S);
            if (h) {
              var w = h[2] - 1 || 0, B = (h[7] || "0").substring(0, 3);
              return y ? new Date(Date.UTC(h[1], w, h[3] || 1, h[4] || 0, h[5] || 0, h[6] || 0, B)) : new Date(h[1], w, h[3] || 1, h[4] || 0, h[5] || 0, h[6] || 0, B);
            }
          }
          return new Date(g);
        }(u), this.init();
      }, i.init = function() {
        var u = this.$d;
        this.$y = u.getFullYear(), this.$M = u.getMonth(), this.$D = u.getDate(), this.$W = u.getDay(), this.$H = u.getHours(), this.$m = u.getMinutes(), this.$s = u.getSeconds(), this.$ms = u.getMilliseconds();
      }, i.$utils = function() {
        return M;
      }, i.isValid = function() {
        return this.$d.toString() !== d;
      }, i.isSame = function(u, m) {
        var g = T(u);
        return this.startOf(m) <= g && g <= this.endOf(m);
      }, i.isAfter = function(u, m) {
        return T(u) < this.startOf(m);
      }, i.isBefore = function(u, m) {
        return this.endOf(m) < T(u);
      }, i.$g = function(u, m, g) {
        return M.u(u) ? this[m] : this.set(g, u);
      }, i.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, i.valueOf = function() {
        return this.$d.getTime();
      }, i.startOf = function(u, m) {
        var g = this, y = !!M.u(m) || m, h = M.p(u), w = function(J, I) {
          var x = M.w(g.$u ? Date.UTC(g.$y, I, J) : new Date(g.$y, I, J), g);
          return y ? x : x.endOf(p);
        }, B = function(J, I) {
          return M.w(g.toDate()[J].apply(g.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(I)), g);
        }, N = this.$W, P = this.$M, $ = this.$D, q = "set" + (this.$u ? "UTC" : "");
        switch (h) {
          case A:
            return y ? w(1, 0) : w(31, 11);
          case v:
            return y ? w(1, P) : w(0, P + 1);
          case f:
            var W = this.$locale().weekStart || 0, Q = (N < W ? N + 7 : N) - W;
            return w(y ? $ - Q : $ + (6 - Q), P);
          case p:
          case C:
            return B(q + "Hours", 0);
          case c:
            return B(q + "Minutes", 1);
          case l:
            return B(q + "Seconds", 2);
          case o:
            return B(q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, i.endOf = function(u) {
        return this.startOf(u, !1);
      }, i.$set = function(u, m) {
        var g, y = M.p(u), h = "set" + (this.$u ? "UTC" : ""), w = (g = {}, g[p] = h + "Date", g[C] = h + "Date", g[v] = h + "Month", g[A] = h + "FullYear", g[c] = h + "Hours", g[l] = h + "Minutes", g[o] = h + "Seconds", g[s] = h + "Milliseconds", g)[y], B = y === p ? this.$D + (m - this.$W) : m;
        if (y === v || y === A) {
          var N = this.clone().set(C, 1);
          N.$d[w](B), N.init(), this.$d = N.set(C, Math.min(this.$D, N.daysInMonth())).$d;
        } else w && this.$d[w](B);
        return this.init(), this;
      }, i.set = function(u, m) {
        return this.clone().$set(u, m);
      }, i.get = function(u) {
        return this[M.p(u)]();
      }, i.add = function(u, m) {
        var g, y = this;
        u = Number(u);
        var h = M.p(m), w = function(P) {
          var $ = T(y);
          return M.w($.date($.date() + Math.round(P * u)), y);
        };
        if (h === v) return this.set(v, this.$M + u);
        if (h === A) return this.set(A, this.$y + u);
        if (h === p) return w(1);
        if (h === f) return w(7);
        var B = (g = {}, g[l] = r, g[c] = t, g[o] = n, g)[h] || 1, N = this.$d.getTime() + u * B;
        return M.w(N, this);
      }, i.subtract = function(u, m) {
        return this.add(-1 * u, m);
      }, i.format = function(u) {
        var m = this, g = this.$locale();
        if (!this.isValid()) return g.invalidDate || d;
        var y = u || "YYYY-MM-DDTHH:mm:ssZ", h = M.z(this), w = this.$H, B = this.$m, N = this.$M, P = g.weekdays, $ = g.months, q = g.meridiem, W = function(I, x, ee, le) {
          return I && (I[x] || I(m, y)) || ee[x].slice(0, le);
        }, Q = function(I) {
          return M.s(w % 12 || 12, I, "0");
        }, J = q || function(I, x, ee) {
          var le = I < 12 ? "AM" : "PM";
          return ee ? le.toLowerCase() : le;
        };
        return y.replace(E, function(I, x) {
          return x || function(ee) {
            switch (ee) {
              case "YY":
                return String(m.$y).slice(-2);
              case "YYYY":
                return M.s(m.$y, 4, "0");
              case "M":
                return N + 1;
              case "MM":
                return M.s(N + 1, 2, "0");
              case "MMM":
                return W(g.monthsShort, N, $, 3);
              case "MMMM":
                return W($, N);
              case "D":
                return m.$D;
              case "DD":
                return M.s(m.$D, 2, "0");
              case "d":
                return String(m.$W);
              case "dd":
                return W(g.weekdaysMin, m.$W, P, 2);
              case "ddd":
                return W(g.weekdaysShort, m.$W, P, 3);
              case "dddd":
                return P[m.$W];
              case "H":
                return String(w);
              case "HH":
                return M.s(w, 2, "0");
              case "h":
                return Q(1);
              case "hh":
                return Q(2);
              case "a":
                return J(w, B, !0);
              case "A":
                return J(w, B, !1);
              case "m":
                return String(B);
              case "mm":
                return M.s(B, 2, "0");
              case "s":
                return String(m.$s);
              case "ss":
                return M.s(m.$s, 2, "0");
              case "SSS":
                return M.s(m.$ms, 3, "0");
              case "Z":
                return h;
            }
            return null;
          }(I) || h.replace(":", "");
        });
      }, i.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, i.diff = function(u, m, g) {
        var y, h = this, w = M.p(m), B = T(u), N = (B.utcOffset() - this.utcOffset()) * r, P = this - B, $ = function() {
          return M.m(h, B);
        };
        switch (w) {
          case A:
            y = $() / 12;
            break;
          case v:
            y = $();
            break;
          case b:
            y = $() / 3;
            break;
          case f:
            y = (P - N) / 6048e5;
            break;
          case p:
            y = (P - N) / 864e5;
            break;
          case c:
            y = P / t;
            break;
          case l:
            y = P / r;
            break;
          case o:
            y = P / n;
            break;
          default:
            y = P;
        }
        return g ? y : M.a(y);
      }, i.daysInMonth = function() {
        return this.endOf(v).$D;
      }, i.$locale = function() {
        return O[this.$L];
      }, i.locale = function(u, m) {
        if (!u) return this.$L;
        var g = this.clone(), y = F(u, m, !0);
        return y && (g.$L = y), g;
      }, i.clone = function() {
        return M.w(this.$d, this);
      }, i.toDate = function() {
        return new Date(this.valueOf());
      }, i.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, i.toISOString = function() {
        return this.$d.toISOString();
      }, i.toString = function() {
        return this.$d.toUTCString();
      }, _;
    }(), Ce = Y.prototype;
    return T.prototype = Ce, [["$ms", s], ["$s", o], ["$m", l], ["$H", c], ["$W", p], ["$M", v], ["$y", A], ["$D", C]].forEach(function(_) {
      Ce[_[1]] = function(i) {
        return this.$g(i, _[0], _[1]);
      };
    }), T.extend = function(_, i) {
      return _.$i || (_(i, Y, T), _.$i = !0), T;
    }, T.locale = F, T.isDayjs = U, T.unix = function(_) {
      return T(1e3 * _);
    }, T.en = O[D], T.Ls = O, T.p = {}, T;
  });
})(Lt);
var Nt = Lt.exports;
const Z = /* @__PURE__ */ ne(Nt);
var Gt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r) {
      var t = r.prototype, s = t.format;
      t.format = function(o) {
        var l = this, c = this.$locale();
        if (!this.isValid()) return s.bind(this)(o);
        var p = this.$utils(), f = (o || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(v) {
          switch (v) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return c.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return c.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return p.s(l.week(), v === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return p.s(l.isoWeek(), v === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return p.s(String(l.$H === 0 ? 24 : l.$H), v === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return v;
          }
        });
        return s.bind(this)(f);
      };
    };
  });
})(Gt);
var Rm = Gt.exports;
const Pm = /* @__PURE__ */ ne(Rm);
var Ft = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r, t) {
      r.prototype.isBetween = function(s, o, l, c) {
        var p = t(s), f = t(o), v = (c = c || "()")[0] === "(", b = c[1] === ")";
        return (v ? this.isAfter(p, l) : !this.isBefore(p, l)) && (b ? this.isBefore(f, l) : !this.isAfter(f, l)) || (v ? this.isBefore(p, l) : !this.isAfter(p, l)) && (b ? this.isAfter(f, l) : !this.isBefore(f, l));
      };
    };
  });
})(Ft);
var Em = Ft.exports;
const Om = /* @__PURE__ */ ne(Em);
var Ut = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r) {
      r.prototype.isSameOrAfter = function(t, s) {
        return this.isSame(t, s) || this.isAfter(t, s);
      };
    };
  });
})(Ut);
var Bm = Ut.exports;
const Lm = /* @__PURE__ */ ne(Bm);
var $t = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r) {
      r.prototype.isSameOrBefore = function(t, s) {
        return this.isSame(t, s) || this.isBefore(t, s);
      };
    };
  });
})($t);
var Nm = $t.exports;
const Gm = /* @__PURE__ */ ne(Nm);
var It = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, t, s) {
      var o = t.prototype, l = o.format;
      s.en.formats = n, o.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var p = this.$locale().formats, f = function(v, b) {
          return v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(A, C, d) {
            var S = d && d.toUpperCase();
            return C || b[d] || n[d] || b[S].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(E, R, z) {
              return R || z.slice(1);
            });
          });
        }(c, p === void 0 ? {} : p);
        return l.call(this, f);
      };
    };
  });
})(It);
var Fm = It.exports;
const Um = /* @__PURE__ */ ne(Fm);
var Kt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r, t) {
      var s = function(o, l) {
        if (!l || !l.length || l.length === 1 && !l[0] || l.length === 1 && Array.isArray(l[0]) && !l[0].length) return null;
        var c;
        l.length === 1 && l[0].length > 0 && (l = l[0]), c = (l = l.filter(function(f) {
          return f;
        }))[0];
        for (var p = 1; p < l.length; p += 1) l[p].isValid() && !l[p][o](c) || (c = l[p]);
        return c;
      };
      t.max = function() {
        var o = [].slice.call(arguments, 0);
        return s("isAfter", o);
      }, t.min = function() {
        var o = [].slice.call(arguments, 0);
        return s("isBefore", o);
      };
    };
  });
})(Kt);
var $m = Kt.exports;
const Im = /* @__PURE__ */ ne($m);
var kt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return function(n, r, t) {
      n = n || {};
      var s = r.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function l(p, f, v, b) {
        return s.fromToBase(p, f, v, b);
      }
      t.en.relativeTime = o, s.fromToBase = function(p, f, v, b, A) {
        for (var C, d, S, E = v.$locale().relativeTime || o, R = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], z = R.length, L = 0; L < z; L += 1) {
          var D = R[L];
          D.d && (C = b ? t(p).diff(v, D.d, !0) : v.diff(p, D.d, !0));
          var O = (n.rounding || Math.round)(Math.abs(C));
          if (S = C > 0, O <= D.r || !D.r) {
            O <= 1 && L > 0 && (D = R[L - 1]);
            var G = E[D.l];
            A && (O = A("" + O)), d = typeof G == "string" ? G.replace("%d", O) : G(O, f, D.l, S);
            break;
          }
        }
        if (f) return d;
        var U = S ? E.future : E.past;
        return typeof U == "function" ? U(d) : U.replace("%s", d);
      }, s.to = function(p, f) {
        return l(p, f, this, !0);
      }, s.from = function(p, f) {
        return l(p, f, this);
      };
      var c = function(p) {
        return p.$u ? t.utc() : t();
      };
      s.toNow = function(p) {
        return this.to(c(this), p);
      }, s.fromNow = function(p) {
        return this.from(c(this), p);
      };
    };
  });
})(kt);
var Km = kt.exports;
const km = /* @__PURE__ */ ne(Km);
var Ht = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
    return function(t, s, o) {
      var l, c = function(b, A, C) {
        C === void 0 && (C = {});
        var d = new Date(b), S = function(E, R) {
          R === void 0 && (R = {});
          var z = R.timeZoneName || "short", L = E + "|" + z, D = r[L];
          return D || (D = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: E, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: z }), r[L] = D), D;
        }(A, C);
        return S.formatToParts(d);
      }, p = function(b, A) {
        for (var C = c(b, A), d = [], S = 0; S < C.length; S += 1) {
          var E = C[S], R = E.type, z = E.value, L = n[R];
          L >= 0 && (d[L] = parseInt(z, 10));
        }
        var D = d[3], O = D === 24 ? 0 : D, G = d[0] + "-" + d[1] + "-" + d[2] + " " + O + ":" + d[4] + ":" + d[5] + ":000", U = +b;
        return (o.utc(G).valueOf() - (U -= U % 1e3)) / 6e4;
      }, f = s.prototype;
      f.tz = function(b, A) {
        b === void 0 && (b = l);
        var C, d = this.utcOffset(), S = this.toDate(), E = S.toLocaleString("en-US", { timeZone: b }), R = Math.round((S - new Date(E)) / 1e3 / 60), z = 15 * -Math.round(S.getTimezoneOffset() / 15) - R;
        if (!Number(z)) C = this.utcOffset(0, A);
        else if (C = o(E, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(z, !0), A) {
          var L = C.utcOffset();
          C = C.add(d - L, "minute");
        }
        return C.$x.$timezone = b, C;
      }, f.offsetName = function(b) {
        var A = this.$x.$timezone || o.tz.guess(), C = c(this.valueOf(), A, { timeZoneName: b }).find(function(d) {
          return d.type.toLowerCase() === "timezonename";
        });
        return C && C.value;
      };
      var v = f.startOf;
      f.startOf = function(b, A) {
        if (!this.$x || !this.$x.$timezone) return v.call(this, b, A);
        var C = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return v.call(C, b, A).tz(this.$x.$timezone, !0);
      }, o.tz = function(b, A, C) {
        var d = C && A, S = C || A || l, E = p(+o(), S);
        if (typeof b != "string") return o(b).tz(S);
        var R = function(O, G, U) {
          var F = O - 60 * G * 1e3, T = p(F, U);
          if (G === T) return [F, G];
          var M = p(F -= 60 * (T - G) * 1e3, U);
          return T === M ? [F, T] : [O - 60 * Math.min(T, M) * 1e3, Math.max(T, M)];
        }(o.utc(b, d).valueOf(), E, S), z = R[0], L = R[1], D = o(z).utcOffset(L);
        return D.$x.$timezone = S, D;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(b) {
        l = b;
      };
    };
  });
})(Ht);
var Hm = Ht.exports;
const Ym = /* @__PURE__ */ ne(Hm);
var Yt = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, t = /([+-]|\d\d)/g;
    return function(s, o, l) {
      var c = o.prototype;
      l.utc = function(d) {
        var S = { date: d, utc: !0, args: arguments };
        return new o(S);
      }, c.utc = function(d) {
        var S = l(this.toDate(), { locale: this.$L, utc: !0 });
        return d ? S.add(this.utcOffset(), n) : S;
      }, c.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var p = c.parse;
      c.parse = function(d) {
        d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), p.call(this, d);
      };
      var f = c.init;
      c.init = function() {
        if (this.$u) {
          var d = this.$d;
          this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
        } else f.call(this);
      };
      var v = c.utcOffset;
      c.utcOffset = function(d, S) {
        var E = this.$utils().u;
        if (E(d)) return this.$u ? 0 : E(this.$offset) ? v.call(this) : this.$offset;
        if (typeof d == "string" && (d = function(D) {
          D === void 0 && (D = "");
          var O = D.match(r);
          if (!O) return null;
          var G = ("" + O[0]).match(t) || ["-", 0, 0], U = G[0], F = 60 * +G[1] + +G[2];
          return F === 0 ? 0 : U === "+" ? F : -F;
        }(d), d === null)) return this;
        var R = Math.abs(d) <= 16 ? 60 * d : d, z = this;
        if (S) return z.$offset = R, z.$u = d === 0, z;
        if (d !== 0) {
          var L = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (z = this.local().add(R + L, n)).$offset = R, z.$x.$localOffset = L;
        } else z = this.utc();
        return z;
      };
      var b = c.format;
      c.format = function(d) {
        var S = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return b.call(this, S);
      }, c.valueOf = function() {
        var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * d;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var A = c.toDate;
      c.toDate = function(d) {
        return d === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : A.call(this);
      };
      var C = c.diff;
      c.diff = function(d, S, E) {
        if (d && this.$u === d.$u) return C.call(this, d, S, E);
        var R = this.local(), z = l(d).local();
        return C.call(R, z, S, E);
      };
    };
  });
})(Yt);
var xm = Yt.exports;
const jm = /* @__PURE__ */ ne(xm);
var Vm = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r(Nt);
  })(X, function(n) {
    function r(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var t = r(n), s = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
      return "" + o + (o === 1 ? "er" : "");
    } };
    return t.default.locale(s, null, !0), s;
  });
})(Vm);
var Zm = { exports: {} };
(function(e, a) {
  (function(n, r) {
    e.exports = r();
  })(X, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
      var r = ["th", "st", "nd", "rd"], t = n % 100;
      return "[" + n + (r[(t - 20) % 10] || r[t] || r[0]) + "]";
    } };
  });
})(Zm);
Z.extend(Pm);
Z.extend(Om);
Z.extend(Lm);
Z.extend(Gm);
Z.extend(Um);
Z.extend(Im);
Z.extend(km);
Z.extend(Ym);
Z.extend(jm);
function lr(e, a) {
  return a === void 0 ? Array.from({ length: e }, (n, r) => r) : Array.from({ length: a - e }, (n, r) => e + r);
}
const re = Z(), Tp = {
  cancellationPolicies: [
    {
      dateFrom: re.format("YYYY-MM-DD HH:mm:ss"),
      dateTo: `${re.subtract(-1, "day").format("YYYY-MM-DD")} 13:30:00`,
      penaltyPercentage: 0
    },
    {
      dateFrom: `${re.subtract(-1, "day").format("YYYY-MM-DD")} 13:30:00`,
      dateTo: `${re.subtract(-2, "day").format("YYYY-MM-DD")} 18:00:00`,
      penaltyPercentage: 5
    },
    {
      dateFrom: `${re.subtract(-2, "day").format("YYYY-MM-DD")} 18:00:00`,
      dateTo: `${re.subtract(-3, "day").format("YYYY-MM-DD")} 09:20:00`,
      penaltyPercentage: 0
    },
    {
      dateFrom: `${re.subtract(-3, "day").format("YYYY-MM-DD")} 09:20:00`,
      dateTo: `${re.subtract(-7, "day").format("YYYY-MM-DD")} 12:00:00`,
      penaltyPercentage: 50
    }
  ],
  checkInDate: re.subtract(-9, "day").format("YYYY-MM-DD"),
  initialDate: `${re.format("YYYY-MM-DD")} 13:00:00`,
  timezone: "Europe/Paris"
}, Rp = {
  cancellationPolicies: {
    control: {
      type: "array"
    },
    description: '<span style="color: red;">Required.</span> List of cancellation policies stringified as JSON. Included dates (dateFrom/dateTo) must be in ISO 8601 format and preferably in UTC. If dates are not in UTC, the timezone property will be used. Penalty percentage must be a number between 0 and 100.',
    name: "cancellation-policies",
    table: {
      defaultValue: { summary: "[]" }
    }
  },
  checkInDate: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Check-in date formatted as ```YYYY-MM-DD``` which will be used to compute and display the cancellation policies.',
    name: "check-in-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  initialDate: {
    control: {
      type: "text"
    },
    description: "Initial date ISO 8601 which will be used to compute and display the cancellation policies. If not provided, default to current datetime",
    name: "initial-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  timezone: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Timezone which will be used to compute the cancellation policies in the case provided dates are not in UTC. Usually, the timezone of the hotel.',
    name: "timezone",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, Pp = {
  amount: 100,
  currency: "EUR",
  disabled: !1,
  loading: !1,
  token: "",
  withAction: !1,
  withTerms: !1
}, Ep = {
  amount: {
    control: {
      type: "number"
    },
    description: "Amount of the Credit Card Payment Method",
    name: "amount",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  currency: {
    control: {
      type: "select"
    },
    description: "Currency of the Credit Card Payment Method",
    name: "currency",
    options: ["EUR", "USD"],
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  disabled: {
    control: {
      type: "boolean"
    },
    description: "Whether to disable the form",
    name: "disabled",
    table: {
      defaultValue: { summary: "false" }
    }
  },
  loading: {
    control: {
      type: "boolean"
    },
    description: "Whether to display loading state",
    name: "loading",
    table: {
      defaultValue: { summary: "false" }
    }
  },
  token: {
    control: {
      type: "text"
    },
    description: "Token of Credit Card Payment Method retrieved from Booking",
    name: "token",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  withAction: {
    control: {
      type: "boolean"
    },
    description: "Whether to display Pay Button",
    name: "withAction",
    table: {
      defaultValue: { summary: "false" }
    }
  },
  withTerms: {
    control: {
      type: "boolean"
    },
    description: "Whether to display Terms and Conditions",
    name: "withTerms",
    table: {
      defaultValue: { summary: "false" }
    }
  }
}, Op = {
  amount: 100,
  currency: "EUR",
  loading: !1,
  token: "",
  withTerms: !1
}, Bp = {
  amount: {
    control: {
      type: "number"
    },
    description: "Amount of the Credit Card Payment Method",
    name: "amount",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  currency: {
    control: {
      type: "select"
    },
    description: "Currency of the Credit Card Payment Method",
    name: "currency",
    options: ["EUR", "USD"],
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  token: {
    control: {
      type: "text"
    },
    description: "Token of Credit Card Payment Method retrieved from Booking",
    name: "token",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  withTerms: {
    control: {
      type: "boolean"
    },
    description: "Whether to display Terms and Conditions",
    name: "withTerms",
    table: {
      defaultValue: { summary: "false" }
    }
  }
}, ga = {
  BookingDetails: !0
}, Lp = {
  features: ga,
  token: ""
}, Wm = "<p>**BookingDetails**: Display the booking details in the sidebar.</p>", Np = {
  features: {
    control: {
      type: "object"
    },
    description: `This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.<br /><br />***Available features***: <div>${Wm}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(ga, null, 2)
      }
    }
  },
  token: {
    control: {
      type: "text"
    },
    description: 'Token of the booking returned by Booking API <a href="https://booking-api.revolugo.com/v1/documentation#operation/getV1BookingsId" target="_blank">Retrieve Booking endpoint</a>.',
    name: "token",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
};
function xt(e) {
  const a = typeof window < "u" && window;
  return !!(a && (/Chromatic/.test(a.navigator.userAgent) || /chromatic=true/.test(a.location.href)));
}
const ur = xt() ? Z("2050-01-01") : Z(), jt = {
  address: "",
  adultCount: 1,
  checkInDate: ur.subtract(-4, "days").format("YYYY-MM-DD"),
  checkOutDate: ur.subtract(-5, "days").format("YYYY-MM-DD"),
  children: void 0,
  hotelOfferRequestId: "",
  latitude: 48.8508305,
  longitude: 2.2844643,
  roomCount: 1,
  sourceMarket: sa.Fr
}, Vt = {
  address: {
    control: {
      type: "text"
    },
    description: `Search address.

When provided and successfully geocoded, this address is used as the center location for **Hotel Offers** search.

**Requirements:** must be a valid address string, e.g. "Paris, France", minimum length: 3 characters.,
`,
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  adultCount: {
    control: {
      type: "select"
    },
    description: '<span style="color: red;">Required.</span> Number of adult(s) requested',
    name: "adult-count",
    options: lr(1, 90),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkInDate: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Check-in date formatted as ```YYYY-MM-DD```',
    name: "check-in-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkOutDate: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span> Check-out date formatted as ```YYYY-MM-DD```',
    name: "check-out-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  children: {
    control: {
      type: "text"
    },
    description: "Comma-separated list of ages (0 to 17)",
    name: "children",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  hotelOfferRequestId: {
    control: {
      type: "text"
    },
    description: "id of a previously created **Hotel Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date/latitude/longitude** props takes precedence over any provided **hotel-offer-request-id** and a new **hotel-offer-request-id** will be created.",
    name: "hotel-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  latitude: {
    control: { type: "number" },
    description: '<span style="color: red;">Required.</span> Search location latitude.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  longitude: {
    control: { type: "number" },
    description: '<span style="color: red;">Required.</span> Search location longitude.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  roomCount: {
    control: {
      type: "select"
    },
    description: "Number of room(s) requested",
    name: "room-count",
    options: lr(1, 30),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  sourceMarket: {
    control: {
      type: "select"
    },
    description: `Nationality of the customer.

For sourcing availability within certain markets, a source market option may be used to get more accurate prices and to reduce booking errors.

You may use any valid ISO Alpha-2 country code, e.g. JP`,
    name: "source-market",
    options: Object.values(sa),
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
};
var ce = /* @__PURE__ */ ((e) => (e.DialogFullscreen = "DialogFullscreen", e.HotelDescriptionViewDialog = "HotelDescriptionViewDialog", e.HotelRoomOfferList = "HotelRoomOfferList", e.HotelRoomOffersViewDialog = "HotelRoomOffersViewDialog", e.RoomsDetails = "RoomsDetails", e))(ce || {});
const ea = {
  DialogFullscreen: !0,
  HotelDescriptionViewDialog: !1,
  HotelRoomOfferList: !1,
  HotelRoomOffersViewDialog: !1,
  RoomsDetails: !0
}, ma = {
  FiltersBar: !0,
  HotelOfferSearchMenu: !1,
  TermsAndConditionsFooter: !0,
  HotelOfferItem: ea
}, Zt = `<p>**DialogFullscreen**: Display the dialog in fullscreen mode (HotelDescriptionViewDialog + HotelRoomOffersViewDialog),</p>
<p>**HotelDescriptionViewDialog**: Display the hotel description dialog when clicking on the hotel name,</p>
<p>**HotelRoomOfferList**: Display the room offer list when clicking on the item (not applicable in some cases, e.g.: HotelOffersMap),</p>
<p>**HotelRoomOffersViewDialog**: Display the room offers dialog when clicking on the hotel name or on the room offer item,</p>
<p>**RoomDetails**: Display the room details on each Hotel Offer item</p>`, Jm = {
  ...jt,
  features: ma,
  height: "600px",
  hotelOfferRequestId: "",
  limit: Oe
}, Wt = `<p>**FiltersBar**: Display the filters bar at the top of the component,</p>
<p>**HotelOfferSearchMenu**: Display the search menu at the top of the component,</p>
<p>**TermsAndConditionsFooter**: Display the terms and conditions footer at the bottom of the component,</p>
<p><ins>**HotelOfferItem**:</ins></p>
<div style="padding-left: 20px">${Zt}</div>`, qm = {
  ...Vt,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${Wt}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(ma, null, 4)
      }
    }
  },
  height: {
    control: {
      type: "text"
    },
    description: "Height of the hotel offer list component expressed in any valid CSS unit (px, %, em, rem, vh, vw, etc.)",
    name: "height",
    table: {
      defaultValue: { summary: "600px" }
    }
  },
  hotelOfferRequestId: {
    control: {
      type: "text"
    },
    description: "id of a previously created **Hotel Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date/latitude/longitude** props takes precedence over any provided **hotel-offer-request-id** and a new **hotel-offer-request-id** will be created.",
    name: "hotel-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  limit: {
    control: {
      type: "number"
    },
    description: "Limit the number of Hotel Offers returned. Limit can range between 1 and 100.",
    table: {
      defaultValue: { summary: Oe }
    }
  }
};
var cn = /* @__PURE__ */ ((e) => (e.FiltersMenu = "FiltersMenu", e.LocationInput = "LocationInput", e.SearchAreaButton = "SearchAreaButton", e))(cn || {});
const je = {
  FiltersMenu: !0,
  LocationInput: !0,
  SearchAreaButton: !0,
  HotelOfferItem: {
    ...ea,
    [ce.HotelDescriptionViewDialog]: !1,
    [ce.HotelRoomOffersViewDialog]: !1,
    [ce.RoomsDetails]: !0
  }
}, Xm = {
  ...jt,
  features: je,
  height: "500px",
  limit: Oe,
  markers: [
    {
      icon: "tower-cell",
      latitude: 48.8584,
      longitude: 2.2945,
      pulse: !1,
      size: 80,
      tooltip: "La tour Eiffel"
    },
    {
      imgUrl: "https://via.placeholder.com/500",
      latitude: 48.8606,
      longitude: 2.3376
    },
    {
      latitude: 48.8421,
      longitude: 2.322
    }
  ],
  venue: {
    imgUrl: "https://via.placeholder.com/500",
    latitude: 48.8508305,
    longitude: 2.2844643,
    size: 70,
    tooltip: "Venue tooltip"
  }
}, Jt = `<p>**FiltersMenu**: Display the filters bar at the top of the component,</p> <p>**LocationInput**: Display the location input at the top of the component,</p> <p>**SearchAreaButton**: Display the search area button at the top of the component,</p> <p><ins> **HotelOfferItem**:</ins></p> <div style="margin-left: 20px;">${Zt}</div>`, Qm = {
  ...Vt,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${Jt}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(je, null, 2)
      }
    }
  },
  height: {
    control: {
      type: "text"
    },
    description: "Height of the map component. Can be any valid css size, e.g. `500px` or `100%`. If not specified, the map will take the full height of its container, if specified.",
    name: "height",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  limit: {
    control: {
      type: "number"
    },
    description: "Limit the number of Hotel Offers returned. Limit can range between 1 and 100.",
    table: {
      defaultValue: { summary: Oe }
    }
  },
  markers: {
    control: {
      type: "array"
    },
    description: "Array of markers if you want to highlight special places around the event. Required prop: <b>lat, lng</b>",
    table: {
      defaultValue: { summary: "[]" }
    }
  },
  venue: {
    control: {
      type: "object"
    },
    description: "Venue object to display a marker for the venue. Required prop: <b>lat, lng</b>",
    name: "venue",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, pa = {
  PreferencesMenu: !0,
  HotelOfferList: ma,
  HotelOffersMap: {
    ...je,
    [cn.FiltersMenu]: !1
  }
}, ep = {
  ...de(Jm, ["rounded"]),
  ...de(Xm, ["height"]),
  features: pa
}, qt = `<p>**PreferencesMenu**: Display the filters bar at the top of the component,</p> <p><ins>**HotelOfferList**:</ins></p> <p style="margin-left: 20px;">
${Wt}</p> <p><ins> **HotelOffersMap**:</ins></p> <p style="margin-left: 20px;">
${Jt}</p>`, ap = {
  ...de(qm, ["limit", "rounded"]),
  ...de(Qm, ["height", "withFilters"]),
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div style="margin-left: 20px;">${qt}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(pa, null, 2)
      }
    }
  },
  mapFirstOnMobile: {
    control: {
      type: "boolean"
    },
    description: "Display the map first on mobile screen size",
    name: "mapFirstOnMobile",
    table: {
      defaultValue: {
        summary: !1
      }
    }
  }
}, Ve = {
  BookingDetails: !0
}, Xt = {
  adultCount: 2,
  bookingPolicyId: "df6f894b-201a-4dc2-b39e-5c8cc31068a0",
  checkInDate: Z().subtract(-4, "days").format("YYYY-MM-DD"),
  checkOutDate: Z().subtract(-5, "days").format("YYYY-MM-DD"),
  emailAddress: "john.doe@example.com",
  features: Ve,
  firstName: "John",
  hotelRoomOffer: void 0,
  lastName: "Doe",
  metadata: {},
  nationality: "FR",
  paymentMethods: Qe.CreditCard,
  phoneCountry: "FR",
  phoneNumber: "0102030405",
  roomCount: 1,
  salutation: "",
  specialRequests: ""
}, dn = "<p>**BookingDetails**: Display the booking details in the sidebar.</p>", Qt = {
  bookingPolicyId: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Booking policy id',
    name: "booking-policy-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  emailAddress: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Email address',
    name: "email-address",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  features: {
    control: {
      type: "object"
    },
    description: `This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it. <br /> ***Available features***: <br /> ${dn}`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(Ve, null, 2)
      }
    }
  },
  firstName: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> First name',
    name: "first-name",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  lastName: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Last name',
    name: "last-name",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  metadata: {
    control: { type: "object" },
    description: 'If you want to attach some metadata of your choice to the booking (e.g.: a customer id or an order id from your system), you need to pass them as attributes of the component with the name starting with "metadata-". The component will build a "metadata" object based on those attributes that will be sent to the API.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  nationality: {
    control: { type: "select" },
    description: '<span style="color: red;">Required.</span> The status of being a legal citizen of a country',
    options: Object.keys(Pa),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  paymentMethods: {
    control: { type: "text" },
    description: `Specific payment methods used to setup the booking. If not provided, deposit account will be used.
      
***Available payment methods***:
      
${Object.values(Qe).join(", ")}`,
    name: "payment-methods",
    options: Object.values(Qe),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  phoneCountry: {
    control: { type: "select" },
    description: '<span style="color: red;">Required.</span> Phone country',
    name: "phone-country",
    options: Object.keys(Pa),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  phoneNumber: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Phone number',
    name: "phone-number",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  salutation: {
    control: { type: "select" },
    description: "Salutation",
    options: Object.values(Sg),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  specialRequests: {
    control: { type: "text" },
    description: "Special requests",
    name: "special-requests",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, gn = {
  CreditCardPayment: ga,
  HotelOffersView: In(pa, {
    HotelOfferList: {
      HotelOfferItem: {
        ...ea,
        [ce.HotelRoomOfferList]: !0,
        [ce.HotelRoomOffersViewDialog]: !0,
        [ce.RoomsDetails]: !0
      }
    },
    HotelOffersMap: In(je, {
      [cn.FiltersMenu]: !1,
      HotelOfferItem: {
        ...ea,
        [ce.HotelRoomOffersViewDialog]: !0,
        [ce.RoomsDetails]: !0
      }
    })
  }),
  PrebookForm: Ve
}, Gp = {
  ...Xt,
  ...ep,
  adultCount: 1,
  features: gn,
  roomCount: 1
}, np = `<ins>**HotelOffersView**:</ins> <div style="margin-left: 20px;">${qt}</div>
<ins>**PrebookForm**:</ins> <div style="margin-left: 20px;">${dn}</div>`, Fp = {
  ...ap,
  ...Qt,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${np}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(gn, null, 2)
      }
    }
  }
}, ha = {
  PreferencesMenu: !1
}, Up = {
  features: ha,
  hotelId: "67xX"
}, ei = "<p>**PreferencesMenu**: Display the filters bar at the top of the component,</p>", $p = {
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${ei}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(
          ha,
          null,
          2
        )
      }
    }
  },
  hotelId: {
    control: {
      type: "text"
    },
    description: "Hotel id",
    name: "hotel-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, cr = xt() ? Z("2050-01-01") : Z(), mn = {
  adultCount: 1,
  checkInDate: cr.subtract(-4, "days").format("YYYY-MM-DD"),
  checkOutDate: cr.subtract(-5, "days").format("YYYY-MM-DD"),
  children: null,
  hotelId: "TrPK",
  roomCount: 1,
  sourceMarket: sa.Fr
}, ai = {
  adultCount: {
    control: {
      type: "select"
    },
    description: '<span style="color: red;">Required.</span> Number of adult(s) requested',
    name: "adult-count",
    options: Array.from({ length: 30 }, (e, a) => a + 1),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkInDate: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Check-in date formatted as ```YYYY-MM-DD```',
    name: "check-in-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkOutDate: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span> Check-out date formatted as ```YYYY-MM-DD```',
    name: "check-out-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  children: {
    control: {
      type: "text"
    },
    description: "Comma-separated list of children ages",
    name: "children",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  hotelId: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Hotel id to search for **Hotel Room Offers**',
    name: "hotel-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  hotelRoomOfferRequestId: {
    control: {
      type: "text"
    },
    description: "id of a previously created **Hotel Room Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date** props takes precedence over any provided **hotel-offer-request-id** and a new **hotel room offer request** will be created.",
    name: "hotel-room-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  roomCount: {
    control: {
      type: "select"
    },
    description: "Number of room(s) requested",
    name: "room-count",
    options: Array.from({ length: 30 }, (e, a) => a + 1),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  sourceMarket: {
    control: {
      type: "select"
    },
    description: `Nationality of the customer.

For sourcing availability within certain markets, a source market option may be used to get more accurate prices and to reduce booking errors.

You may use any valid ISO Alpha-2 country code, e.g. JP`,
    name: "source-market",
    options: Object.values(sa),
    table: {
      defaultValue: { summary: mn.sourceMarket }
    }
  }
}, ni = {
  ...mn,
  hotelRoomOfferRequestId: "",
  limit: 10
}, rp = {
  ...ai,
  hotelRoomOfferRequestId: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span> id of a previously created **Hotel Room Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date/hotel-id** props takes precedence over any provided **hotel-room-offer-request-id** and a new **hotel-room-offer-request-id** will be created.',
    name: "hotel-room-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  limit: {
    control: {
      type: "number"
    },
    description: "This parameter limits the total number **Hotel Room Offers** displayed.",
    name: "limit",
    table: {
      defaultValue: { summary: ni.limit }
    }
  }
}, ri = {
  OnlyMatchingRoomCount: !1
}, fa = {
  HotelDescriptionView: ha,
  HotelRoomOfferList: ri
}, ti = `<p><ins>**HotelDescriptionView**:</ins></p> <div style="margin-left: 20px;">${ei}</div>`, tp = {
  ...mn,
  ...ni,
  features: fa
}, ip = {
  ...ai,
  ...rp,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${ti}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(
          fa,
          null,
          2
        )
      }
    }
  }
}, Ip = {
  dialog: !1,
  elevation: 0
}, Kp = {
  dialog: {
    control: {
      type: "boolean"
    },
    description: "Embed the Lang Picker Dialog component",
    name: "dialog",
    table: {
      defaultValue: {
        summary: !1
      }
    }
  },
  elevation: {
    control: {
      type: "number"
    },
    description: "Elevation (shadow) of the button",
    name: "elevation",
    table: {
      defaultValue: {
        summary: 0
      }
    }
  }
}, kp = {
  color: "primary",
  dialog: !1,
  elevation: 0
}, Hp = {
  color: {
    control: {
      type: "text"
    },
    description: "Color of the Currency Picker Button.",
    name: "color",
    table: {
      defaultValue: {
        summary: "primary"
      }
    }
  },
  dialog: {
    control: {
      type: "boolean"
    },
    description: "Embed the Currency Picker Dialog component",
    name: "dialog",
    table: {
      defaultValue: {
        summary: !1
      }
    }
  },
  elevation: {
    control: {
      type: "number"
    },
    description: "Elevation (shadow) of the button",
    name: "elevation",
    table: {
      defaultValue: {
        summary: 0
      }
    }
  }
}, pn = {
  HotelRoomOffersView: fa,
  PrebookForm: Ve
}, Yp = {
  ...tp,
  ...de(Xt, ["bookingId", "bookingPolicyId", "hotelRoomOffer"]),
  adultCount: 1,
  features: pn,
  roomCount: 1
}, op = `<ins>**HotelRoomOffersView**:</ins> <div style="margin-left: 20px;">${ti}</div>
<ins>**PrebookForm**:</ins> <div style="margin-left: 20px;">${dn}</div>`, xp = {
  ...ip,
  ...de(Qt, [
    "bookingId",
    "bookingPolicyId",
    "hotelRoomOffer"
  ]),
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${op}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(
          pn,
          null,
          2
        )
      }
    }
  }
}, jp = {
  theme: "light",
  token: ""
}, Vp = {
  theme: {
    control: { type: "select" },
    description: 'String : "dark" or "light" theme',
    name: "theme",
    options: ["dark", "light"]
  },
  token: {
    control: { type: "text" },
    description: 'String : Enter a booking token if you want to be redirected on the booking manager when clicking on "My Booking"',
    name: "token"
  }
}, Zp = {
  amount: { type: Number },
  currency: { type: String },
  loading: {
    default: !1,
    type: Boolean
  },
  token: { type: String },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, Wp = {
  adultCount: {
    type: Number
  },
  checkInDate: {
    type: String
  },
  checkOutDate: {
    type: String
  },
  hotelRoomOffer: {
    type: [String, Object]
  }
}, Jp = {
  token: {
    type: String
  }
}, sp = {
  cancellationPolicies: {
    required: !0,
    type: [String, Array]
  },
  checkInDate: {
    required: !0,
    type: String
  },
  initialDate: {
    type: String
  },
  timezone: {
    required: !0,
    type: String
  }
}, qp = {
  ...sp,
  tagClasses: { type: String }
}, Xp = {
  amount: { type: Number },
  currency: { type: String },
  disabled: {
    default: !1,
    type: Boolean
  },
  loading: {
    default: !1,
    type: Boolean
  },
  token: { required: !0, type: String },
  withAction: {
    default: !1,
    type: Boolean
  },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, Qp = {
  features: {
    default: () => ga,
    type: [Object, String]
  },
  token: { type: String }
}, eh = {
  color: {
    default: "primary",
    type: String
  },
  dialog: {
    default: !1,
    type: Boolean
  },
  elevation: {
    default: 0,
    type: [String, Number]
  },
  size: {
    default: 0,
    type: [String, Number]
  }
}, ii = {
  adultCount: { required: !0, type: Number },
  bookingId: { type: String },
  bookingPolicyId: { required: !0, type: String },
  checkInDate: { required: !0, type: String },
  checkOutDate: { required: !0, type: String },
  emailAddress: {
    default: "",
    type: String
  },
  features: {
    default: () => Ve,
    type: [Object, String]
  },
  firstName: {
    default: "",
    type: String
  },
  hotelRoomOffer: { type: Object },
  lastName: {
    default: "",
    type: String
  },
  nationality: {
    default: "",
    type: String
  },
  organizationAddress: {
    default: "",
    type: String
  },
  organizationCity: {
    default: "",
    type: String
  },
  organizationCountry: {
    default: "",
    type: String
  },
  organizationName: {
    default: "",
    type: String
  },
  organizationState: {
    default: "",
    type: String
  },
  organizationVatNumber: {
    default: "",
    type: String
  },
  organizationZipCode: {
    default: "",
    type: String
  },
  paymentMethods: {
    default: Qe.CreditCard,
    type: String
  },
  phoneCountry: {
    default: "FR",
    type: String
  },
  phoneNumber: {
    default: "",
    type: String
  },
  roomCount: { required: !0, type: Number },
  salutation: {
    default: "",
    type: String
  },
  specialRequests: {
    default: "",
    type: String
  }
}, oi = {
  address: {
    type: String
  },
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: String
  },
  hotelOfferRequestId: {
    type: String
  },
  latitude: {
    required: !0,
    type: Number
  },
  longitude: {
    required: !0,
    type: Number
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, lp = {
  ...oi,
  features: {
    default: () => ma,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hotelRoomOffersLimit: {
    type: Number
  },
  limit: {
    default: Oe,
    type: Number
  },
  loadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  rounded: {
    default: !0,
    type: Boolean
  }
}, up = {
  ...oi,
  features: {
    default: () => je,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hoveredHotel: {
    default: "",
    type: String
  },
  limit: {
    default: Oe,
    type: Number
  },
  loadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  markers: {
    default: () => [],
    type: [String, Array]
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  venue: {
    type: [String, Object]
  }
}, cp = {
  ...lp,
  ...up,
  features: {
    default: () => pa,
    type: [Object, String]
  },
  mapFirstOnMobile: {
    default: !1,
    type: Boolean
  }
}, ah = {
  ...cp,
  ...de(ii, ["bookingId"]),
  features: {
    default: () => gn,
    type: [Object, String]
  }
}, si = {
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: String
  },
  hotelId: {
    required: !0,
    type: String
  },
  hotelRoomOfferRequestId: {
    type: String
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, dp = {
  ...si,
  features: {
    default: () => ri,
    type: [Object, String]
  },
  limit: {
    default: () => 0,
    type: Number
  }
}, nh = {
  features: {
    default: () => ha,
    type: [Object, String]
  },
  hotelId: { type: String }
}, gp = {
  ...si,
  ...de(dp, "features"),
  features: {
    default: () => fa,
    type: [Object, String]
  }
}, rh = {
  ...gp,
  ...de(ii, ["bookingId", "bookingPolicyId", "hotelRoomOffer"]),
  features: {
    default: () => pn,
    type: [Object, String]
  }
}, th = {
  dialog: {
    default: !1,
    type: Boolean
  },
  elevation: {
    default: 0,
    type: [String, Number]
  }
}, ih = {
  theme: {
    default: "light",
    type: String
  },
  token: {
    type: String
  }
}, oh = {
  token: {
    required: !0,
    type: String
  }
};
var mp = /* @__PURE__ */ ((e) => (e.Idle = "IDLE", e.PaymentRequested = "PAYMENT_REQUESTED", e.PaymentSuccessful = "PAYMENT_SUCCESSFUL", e.Prebook = "PREBOOK", e))(mp || {});
const sh = {
  apiEnvironment: _e.Local,
  currency: Oa.EUR.code,
  theme: {}
};
te.en_US;
var pp = /* @__PURE__ */ ((e) => (e.BookingCreated = "booking:created", e.BookingManagerNewBooking = "booking-manager:new-booking", e.BookingManagerRetrieve = "booking-manager:retrieve", e.BookingManagerRetrieveFail = "booking-manager:retrieve-fail", e.BookingPolicyCreated = "booking-policy:created", e.CancellationPoliciesUpdated = "cancellation-policies:updated", e.CurrencyUpdated = "currency:updated", e.HotelOffersItemClick = "hotel-offer-item:click", e.HotelOffersMarkerClick = "hotel-offers:marker:click", e.HotelOffersPollingStarted = "hotel-offers:polling:started", e.HotelOffersRetrieved = "hotel-offers:retrieved", e.HotelOfferRequestCreated = "hotel-offer-request:created", e.HotelOfferRequestRetrieved = "hotel-offer-request:retrieved", e.HotelRetrieved = "hotel:retrieved", e.HotelRoomOffersBtnClick = "hotel-room-offers:click:btn", e.HotelRoomOffersPriceIncreased = "hotel-room-offers:price-increased", e.HotelRoomOffersRetrieved = "hotel-room-offers:retrieved", e.HotelRoomOfferRequestCreated = "hotel-room-offer-request:created", e.HotelRoomOfferRequestRetrieved = "hotel-room-offer-request:retrieved", e.LangUpdated = "lang:updated", e.PaymentSuccess = "payment:success", e.PrebookForm = "prebook:form", e.BookingFlowStepUpdated = "booking-flow-step:updated", e.HotelOffersViewShowMap = "hotel-offers-view:show-map", e))(pp || {});
const hp = {
  accent3: "#ff1744"
}, fp = {
  lighten2: "#64b5f6"
}, yp = {
  base: "#4caf50"
}, lh = {
  colors: {
    accent: "#f57f39",
    error: hp.accent3,
    "on-primary": "#fff",
    "on-secondary": "#fff",
    primary: "#007fff",
    secondary: fp.lighten2,
    success: yp.base
  }
}, bp = (e) => {
  var r;
  window.RevolugoElements = {
    ...window.RevolugoElements,
    ready: (t) => {
      var o;
      const s = (o = window.RevolugoElements) == null ? void 0 : o._ready;
      window.RevolugoElements._ready = () => {
        s && s(), t();
      };
    }
  };
  const a = document.createElement("script");
  a.src = e, a.type = "module", a.async = !1;
  const [n] = document.querySelectorAll("script");
  return n ? (r = n == null ? void 0 : n.parentNode) == null || r.insertBefore(a, n) : document.head.append(a), a;
}, uh = (e) => {
  const n = (e ? "https://cdn.jsdelivr.net/npm/@revolugo/elements-next@%V/dist/revolugo.min.js" : "https://cdn.jsdelivr.net/npm/@revolugo/elements@%V/dist/revolugo.min.js").replace("%V", "6.6.4"), t = [...document.querySelectorAll("script")].find((s) => s.src.includes(n));
  return new Promise((s) => {
    if (t) {
      s(!0);
      return;
    }
    bp(n).addEventListener("load", () => {
      s(!0);
    });
  });
};
export {
  sh as BOOKING_API_CLIENT_CONFIG_DEFAULT,
  mp as BookingState,
  wm as CaseTransformer,
  pp as Event,
  Bp as bankTransferDetailsArgTypes,
  Op as bankTransferDetailsArgs,
  Zp as bankTransferDetailsProps,
  vp as bookingDetailsSidebarArgTypes,
  Ap as bookingDetailsSidebarArgs,
  Wp as bookingDetailsSidebarProps,
  Mp as bookingManagerArgTypes,
  Sp as bookingManagerArgs,
  Jp as bookingManagerProps,
  Rp as cancellationPoliciesBadgeArgTypes,
  Tp as cancellationPoliciesBadgeArgs,
  qp as cancellationPoliciesBadgeProps,
  Rp as cancellationPoliciesListArgTypes,
  Tp as cancellationPoliciesListArgs,
  sp as cancellationPoliciesListProps,
  zp as changeCase,
  Ep as creditCardFormArgTypes,
  Pp as creditCardFormArgs,
  Xp as creditCardFormProps,
  Np as creditCardPaymentArgTypes,
  Lp as creditCardPaymentArgs,
  Qp as creditCardPaymentProps,
  Hp as currencyPickerBtnArgTypes,
  kp as currencyPickerBtnArgs,
  eh as currencyPickerBtnProps,
  Fp as fullBookingFlowArgTypes,
  Gp as fullBookingFlowArgs,
  ah as fullBookingFlowProps,
  $p as hotelDescriptionViewArgTypes,
  Up as hotelDescriptionViewArgs,
  nh as hotelDescriptionViewProps,
  qm as hotelOfferListArgTypes,
  Jm as hotelOfferListArgs,
  lp as hotelOfferListProps,
  Vt as hotelOfferRequestCreatorArgTypes,
  jt as hotelOfferRequestCreatorArgs,
  Vt as hotelOfferSearchMenuArgTypes,
  jt as hotelOfferSearchMenuArgs,
  oi as hotelOfferSearchMenuProps,
  Qm as hotelOffersMapArgTypes,
  Xm as hotelOffersMapArgs,
  up as hotelOffersMapProps,
  ap as hotelOffersViewArgTypes,
  ep as hotelOffersViewArgs,
  cp as hotelOffersViewProps,
  rp as hotelRoomOfferListArgTypes,
  ni as hotelRoomOfferListArgs,
  dp as hotelRoomOfferListProps,
  ai as hotelRoomOfferRequestCreatorArgTypes,
  mn as hotelRoomOfferRequestCreatorArgs,
  si as hotelRoomOfferRequestCreatorProps,
  ai as hotelRoomOfferSearchMenuArgTypes,
  mn as hotelRoomOfferSearchMenuArgs,
  si as hotelRoomOfferSearchMenuProps,
  xp as hotelRoomOffersBookingFlowArgTypes,
  Yp as hotelRoomOffersBookingFlowArgs,
  rh as hotelRoomOffersBookingFlowProps,
  ip as hotelRoomOffersViewArgTypes,
  tp as hotelRoomOffersViewArgs,
  gp as hotelRoomOffersViewProps,
  bp as injectScript,
  sr as keysChangeCase,
  Kp as langPickerBtnArgTypes,
  Ip as langPickerBtnArgs,
  th as langPickerBtnProps,
  lh as lightTheme,
  uh as loadScript,
  Qt as prebookFormArgTypes,
  Xt as prebookFormArgs,
  ii as prebookFormProps,
  wp as roomingListEditorArgTypes,
  Dp as roomingListEditorArgs,
  oh as roomingListEditorProps,
  _p as storybookGlobalTypesRevolugo,
  Cp as storybookParametersRevolugo,
  Vp as termsAndConditionsArgTypes,
  jp as termsAndConditionsArgs,
  ih as termsAndConditionsProps
};
//# sourceMappingURL=elements-core.es.js.map
